var jsxRuntime = require('react/jsx-runtime');
var window = require('global/window');
var react = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var window__default = /*#__PURE__*/_interopDefaultLegacy(window);

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var _excluded$4 = ["title", "titleId"];
var SvgLogo = function SvgLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  return jsxRuntime.jsxs("svg", _extends({
    viewBox: '0 0 145 28',
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsxRuntime.jsx("title", {
      id: titleId,
      children: title
    }) : null, jsxRuntime.jsxs("g", {
      fill: 'none',
      fillRule: 'evenodd',
      children: [jsxRuntime.jsx("path", {
        d: 'M138.731 11.402c0-.614.593-.933 1.322-.933.635 0 1.15.246 1.514.677a.432.432 0 0 0 .533.106l1.742-.93a.434.434 0 0 0 .137-.65c-.926-1.186-2.329-1.82-3.926-1.82-2.348 0-4.332 1.297-4.332 3.618 0 4.007 5.883 3.096 5.883 4.758 0 .66-.638.978-1.573.978-.911 0-1.584-.35-1.982-.967a.43.43 0 0 0-.564-.15l-1.8.961a.437.437 0 0 0-.162.615c.893 1.429 2.459 2.205 4.508 2.205 2.44 0 4.584-1.183 4.584-3.642 0-4.189-5.884-3.141-5.884-4.826M130.237 19.494h-1.294a.863.863 0 0 1-.863-.861V14.01a5.84 5.84 0 0 1 5.846-5.834h.001c.474 0 .859.383.859.857v1.3a.858.858 0 0 1-.859.858h-.002a2.822 2.822 0 0 0-2.824 2.82v4.62a.863.863 0 0 1-.864.862M120.471 17.002c-1.733 0-3.078-1.297-3.078-3.141s1.345-3.141 3.078-3.141c1.756 0 3.102 1.297 3.102 3.14 0 1.845-1.346 3.142-3.102 3.142m0-9.15c-3.353 0-6.02 2.617-6.02 6.009 0 3.391 2.667 6.01 6.02 6.01 3.353 0 6.043-2.619 6.043-6.01 0-3.392-2.69-6.01-6.043-6.01M110.009 4.495h-1.216a.862.862 0 0 0-.863.862V15.727c0 2.863 1.206 4.105 4.709 3.895a.866.866 0 0 0 .81-.862v-.98a.865.865 0 0 0-.876-.86c-1.117.007-1.701-.197-1.701-1.193v-4.734h1.714a.862.862 0 0 0 .863-.862v-1.1a.863.863 0 0 0-.863-.86h-1.714V5.356a.863.863 0 0 0-.863-.862M100.26 17.002c-1.733 0-3.078-1.297-3.078-3.141s1.345-3.141 3.078-3.141c1.756 0 3.102 1.297 3.102 3.14 0 1.845-1.346 3.142-3.102 3.142m0-9.15c-3.353 0-6.02 2.617-6.02 6.009 0 3.391 2.667 6.01 6.02 6.01 3.353 0 6.043-2.619 6.043-6.01 0-3.392-2.69-6.01-6.043-6.01M88.383 7.867a4.907 4.907 0 0 0-3.81 1.365 4.908 4.908 0 0 0-3.81-1.365c-2.585.205-4.525 2.465-4.525 5.054v5.914c0 .476.387.861.863.861h1.295a.862.862 0 0 0 .863-.861V12.85c0-.99.724-1.877 1.712-1.974a1.903 1.903 0 0 1 2.092 1.89v6.069c0 .476.385.861.863.861h1.294a.862.862 0 0 0 .864-.861V12.85c0-.99.724-1.878 1.711-1.974 1.134-.11 2.091.78 2.091 1.89v6.069c0 .476.387.861.863.861h1.295a.862.862 0 0 0 .863-.861V12.92c0-2.589-1.94-4.85-4.524-5.054M68.94 16.915c-1.73 0-3.072-1.293-3.077-3.132v-.018c.005-1.839 1.348-3.132 3.078-3.132 1.756 0 3.101 1.298 3.101 3.141 0 1.844-1.345 3.141-3.101 3.141m0-9.15c-1.13 0-2.18.303-3.078.828V4.479A.862.862 0 0 0 65 3.618h-1.216a.862.862 0 0 0-.863.861v9.334h.002c.02 3.372 2.68 5.97 6.018 5.97 3.352 0 6.043-2.617 6.043-6.009 0-3.392-2.69-6.009-6.043-6.009M55.539 10.546c1.228 0 2.254.636 2.76 1.65H52.8c.505-1.014 1.526-1.65 2.739-1.65Zm3.134 5.331c-.318-.17-.72-.138-.98.112-.55.529-1.3.84-2.154.84-1.237 0-2.274-.663-2.767-1.711a.434.434 0 0 1 .387-.626h7.616a.808.808 0 0 0 .807-.805c0-3.391-2.69-6.009-6.043-6.009s-6.02 2.618-6.02 6.01 2.667 6.01 6.02 6.01a6.03 6.03 0 0 0 4.448-1.917c.379-.408.25-1.068-.24-1.33l-1.074-.574ZM45.197 14.783c0 1.11-.958 2-2.092 1.89-.988-.097-1.711-.984-1.711-1.975V8.713a.863.863 0 0 0-.863-.861h-1.295a.862.862 0 0 0-.863.861v5.985c0 .991-.724 1.878-1.712 1.974a1.903 1.903 0 0 1-2.092-1.889v-6.07a.862.862 0 0 0-.863-.861h-1.295a.863.863 0 0 0-.863.861v5.915c0 2.588 1.94 4.849 4.525 5.053a4.908 4.908 0 0 0 3.81-1.364 4.907 4.907 0 0 0 3.81 1.364c2.584-.204 4.525-2.465 4.525-5.053V8.713a.863.863 0 0 0-.863-.861H46.06a.863.863 0 0 0-.863.861v6.07Z',
        fill: '#151918'
      }), jsxRuntime.jsx("path", {
        d: 'M13.891 0C6.22 0 .001 6.208.001 13.866c0 7.658 6.219 13.866 13.89 13.866 7.672 0 13.89-6.208 13.89-13.866C27.782 6.208 21.564 0 13.892 0Z',
        fill: '#F51344'
      }), jsxRuntime.jsx("path", {
        d: 'M21.656 18.476c0 .655-.548 1.181-1.211 1.146-.622-.032-1.088-.59-1.088-1.21v-2.536a.862.862 0 0 0-.863-.862h-2.59a.862.862 0 0 0-.863.862v3.462c0 .655-.549 1.18-1.212 1.146-.621-.033-1.087-.59-1.087-1.211v-3.397a.863.863 0 0 0-.864-.862H9.29a.862.862 0 0 0-.863.862v2.6c0 .655-.549 1.181-1.212 1.146-.622-.032-1.088-.59-1.088-1.21V9.255c0-.654.548-1.181 1.211-1.146.623.032 1.09.59 1.09 1.211v2.535c0 .476.385.862.862.862h2.59a.863.863 0 0 0 .863-.862V8.394c0-.654.548-1.18 1.21-1.146.623.032 1.09.59 1.09 1.211v3.397c0 .476.385.862.862.862h2.59a.862.862 0 0 0 .863-.862V9.321c0-.622.466-1.179 1.088-1.211a1.149 1.149 0 0 1 1.211 1.146v9.22Z',
        fill: '#FFF'
      })]
    })]
  }));
};

var _excluded$3 = ["title", "titleId"];
var SvgLogoSmall = function SvgLogoSmall(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return jsxRuntime.jsxs("svg", _extends({
    viewBox: '0 0 60 60',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-labelledby": titleId
  }, props, {
    children: [title ? jsxRuntime.jsx("title", {
      id: titleId,
      children: title
    }) : null, jsxRuntime.jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M30 0C13.432 0 0 13.432 0 30 0 46.57 13.432 60 30 60c16.569 0 30-13.431 30-30C60 13.432 46.569 0 30 0Z',
      fill: '#ECEDF2'
    }), jsxRuntime.jsx("mask", {
      id: 'logo-small_svg__a',
      style: {
        maskType: 'alpha'
      },
      maskUnits: 'userSpaceOnUse',
      x: 5,
      y: 5,
      width: 50,
      height: 50,
      children: jsxRuntime.jsx("rect", {
        x: 5.061,
        y: 5.061,
        width: 49.3,
        height: 49.3,
        rx: 24.65,
        fill: '#fff'
      })
    }), jsxRuntime.jsx("g", {
      mask: 'url(#logo-small_svg__a)',
      children: jsxRuntime.jsx("path", {
        fill: '#ECEDF2',
        d: 'M5.061 5.061h49v49h-49z'
      })
    }), jsxRuntime.jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.614 30.106c0-14.63 11.883-26.49 26.54-26.49 14.656 0 26.537 11.86 26.537 26.49 0 14.63-11.881 26.49-26.538 26.49-14.656 0-26.539-11.86-26.539-26.49Zm39.06 10.998a2.194 2.194 0 0 0 2.315-2.19V21.299a2.195 2.195 0 0 0-2.315-2.19c-1.188.061-2.079 1.126-2.079 2.314v4.844c0 .91-.739 1.646-1.649 1.646H34a1.647 1.647 0 0 1-1.649-1.646v-6.49c0-1.188-.89-2.253-2.079-2.314a2.194 2.194 0 0 0-2.314 2.19v6.614c0 .91-.74 1.646-1.65 1.646h-4.946a1.647 1.647 0 0 1-1.649-1.646v-4.844c0-1.188-.891-2.253-2.08-2.314a2.195 2.195 0 0 0-2.314 2.19v17.49c0 1.188.89 2.252 2.078 2.315a2.195 2.195 0 0 0 2.316-2.19v-4.968c0-.91.737-1.646 1.65-1.646h4.946c.91 0 1.649.736 1.649 1.646v6.49c0 1.187.89 2.251 2.078 2.314a2.195 2.195 0 0 0 2.315-2.19v-6.614c0-.91.738-1.646 1.65-1.646h4.946c.91 0 1.65.736 1.65 1.646v4.844c0 1.187.89 2.251 2.078 2.314Z',
      fill: '#AEAEBA'
    })]
  }));
};

var Notification = function Notification(props) {
  return jsxRuntime.jsxs("svg", _extends({
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, props, {
    children: [jsxRuntime.jsx("circle", {
      cx: '12',
      cy: '12',
      r: '12',
      fill: '#FFBED0'
    }), jsxRuntime.jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.57913 15.3333L9.22113 14.37C9.29447 14.2607 9.33313 14.1313 9.33313 14V11.3333C9.33313 9.86267 10.5298 8.66667 11.9998 8.66667C13.4705 8.66667 14.6665 9.86267 14.6665 11.3333V14C14.6665 14.1313 14.7058 14.2607 14.7785 14.37L15.4211 15.3333H8.57913ZM11.9998 17.3333C11.6325 17.3333 11.3331 17.034 11.3331 16.6667H12.6665C12.6665 17.034 12.3678 17.3333 11.9998 17.3333ZM17.2211 15.63L15.9998 13.798V11.3333C15.9998 9.85067 15.1878 8.55733 13.9865 7.866C13.9165 6.82667 13.0571 6 11.9998 6C10.9425 6 10.0838 6.82667 10.0138 7.866C8.81247 8.55733 7.9998 9.85067 7.9998 11.3333V13.798L6.77847 15.63C6.64247 15.8347 6.6298 16.0973 6.7458 16.3147C6.8618 16.5313 7.0878 16.6667 7.33313 16.6667H9.9998C9.9998 17.7693 10.8971 18.6667 11.9998 18.6667C13.1031 18.6667 13.9998 17.7693 13.9998 16.6667H16.6665C16.9125 16.6667 17.1385 16.5313 17.2545 16.3147C17.3705 16.0973 17.3578 15.8347 17.2211 15.63Z',
      fill: '#2E2D37'
    })]
  }));
};

var IconDataSet = {
  CAR_USED: {
    path: ['M7.618 6H16.382L18.382 10H5.618L7.618 6ZM5.5 16H5V15H7C7.552 15 8 14.552 8 14C8 13.448 7.552 13 7 13H5V12H19V13H17C16.448 13 16 13.448 16 14C16 14.552 16.448 15 17 15H19V16H18.5H5.5ZM21 11C21 10.986 20.993 10.975 20.992 10.961C20.988 10.857 20.967 10.755 20.931 10.656C20.922 10.634 20.917 10.612 20.908 10.59C20.902 10.578 20.9 10.565 20.894 10.553L17.894 4.553C17.725 4.214 17.379 4 17 4H7C6.621 4 6.275 4.214 6.105 4.553L3.105 10.553C3.099 10.565 3.097 10.578 3.092 10.59C3.082 10.612 3.077 10.634 3.069 10.656C3.033 10.755 3.012 10.857 3.008 10.961C3.007 10.975 3 10.986 3 11V17C3 17.064 3.025 17.12 3.036 17.18C3.014 17.284 3 17.39 3 17.5V18.5C3 19.325 3.675 20 4.5 20H5.5C6.325 20 7 19.325 7 18.5V18H17V18.5C17 19.325 17.675 20 18.5 20H19.5C20.325 20 21 19.325 21 18.5V17.5C21 17.39 20.986 17.284 20.964 17.18C20.975 17.12 21 17.064 21 17V11Z']
  },
  CAR: {
    path: ['M10.4148 12C10.6801 12 10.9344 11.8946 11.1219 11.7071C11.3095 11.5196 11.4148 11.2652 11.4148 11C11.4148 10.7348 11.3095 10.4804 11.1219 10.2929C10.9344 10.1054 10.6801 10 10.4148 10H5.03484L7.03484 6H15.7948L16.5248 7.45001C16.655 7.66636 16.8622 7.82543 17.1048 7.89532C17.3475 7.96522 17.6076 7.94077 17.8329 7.82684C18.0583 7.71291 18.2321 7.51796 18.3197 7.28113C18.4072 7.04429 18.4019 6.78308 18.3049 6.54999L17.3049 4.54999C17.2218 4.38507 17.0946 4.24643 16.9375 4.14935C16.7804 4.05227 16.5995 4.00056 16.4148 4H6.41484C6.23017 4.00056 6.04929 4.05227 5.8922 4.14935C5.7351 4.24643 5.60793 4.38507 5.52483 4.54999L2.52483 10.55C2.49582 10.6201 2.52483 10.55 2.49582 10.6201C2.45671 10.7153 2.46534 10.8171 2.46483 10.92V16.92C2.46483 17.1 2.46483 16.92 2.46483 17.1C2.46487 17.42 2.46482 17.1 2.46483 17.42V18.42C2.46483 18.8178 2.62286 19.1993 2.90416 19.4807C3.18546 19.762 3.567 19.92 3.96483 19.92H4.96483C5.34047 19.908 5.69796 19.7554 5.96648 19.4924C6.23499 19.2295 6.39499 18.8753 6.41484 18.5V18H10.4148C10.6801 18 10.9344 17.8946 11.1219 17.7071C11.3095 17.5196 11.4148 17.2652 11.4148 17C11.4148 16.7348 11.3095 16.4804 11.1219 16.2929C10.9344 16.1054 10.6801 16 10.4148 16H4.41484V15H6.41484C6.68006 15 6.9344 14.8946 7.12193 14.7071C7.30947 14.5196 7.41484 14.2652 7.41484 14C7.41484 13.7348 7.30947 13.4804 7.12193 13.2929C6.9344 13.1054 6.68006 13 6.41484 13H4.41484V12H10.4148Z', 'M21.5452 13.17C21.4931 13.0091 21.3937 12.8676 21.2599 12.7641C21.126 12.6606 20.9641 12.6 20.7952 12.5901L18.6152 12.43L17.7852 10.43C17.7237 10.2714 17.615 10.1354 17.4737 10.0406C17.3324 9.94582 17.1653 9.89677 16.9952 9.90006V9.90006C16.8257 9.89955 16.6599 9.94972 16.5191 10.0442C16.3783 10.1386 16.269 10.273 16.2052 10.43L15.3752 12.43L13.1852 12.5901C13.0177 12.6006 12.8572 12.6616 12.7251 12.7652C12.593 12.8687 12.4955 13.0099 12.4452 13.17C12.3899 13.3316 12.3851 13.5063 12.4316 13.6706C12.478 13.835 12.5734 13.9813 12.7052 14.0901L14.4152 15.5L13.9052 17.5801C13.8642 17.7498 13.8746 17.9279 13.9352 18.0918C13.9957 18.2556 14.1036 18.3977 14.2452 18.5C14.3939 18.6062 14.5725 18.6622 14.7552 18.66C14.9179 18.6621 15.0777 18.617 15.2152 18.5301L17.0352 17.4001L18.8152 18.5C18.9611 18.6043 19.1359 18.6603 19.3152 18.6603C19.4945 18.6603 19.6693 18.6043 19.8152 18.5C19.9568 18.3977 20.0647 18.2556 20.1253 18.0918C20.1858 17.9279 20.1962 17.7498 20.1552 17.5801L19.6152 15.5L21.2852 14.0901C21.4147 13.9796 21.5086 13.8332 21.5548 13.6695C21.6011 13.5057 21.5978 13.3319 21.5452 13.17V13.17ZM18.2852 14.66C18.1777 14.749 18.0979 14.867 18.0554 14.9999C18.0129 15.1328 18.0093 15.2751 18.0452 15.41L18.2952 16.41L17.3852 15.8401C17.2665 15.7666 17.1298 15.7276 16.9902 15.7276C16.8506 15.7276 16.7138 15.7666 16.5952 15.8401L15.6852 16.41L15.9452 15.41C15.9787 15.2741 15.973 15.1316 15.9287 14.9989C15.8845 14.8661 15.8035 14.7486 15.6952 14.66L14.8852 13.97L15.9452 13.89C16.0859 13.8818 16.2211 13.8331 16.3347 13.7497C16.4483 13.6663 16.5352 13.5518 16.5852 13.42L16.9952 12.42L17.3952 13.42C17.4472 13.5504 17.5348 13.6636 17.6479 13.7467C17.7611 13.8298 17.8952 13.8794 18.0352 13.89L19.1052 13.97L18.2852 14.66Z']
  },
  CAR_ZERO: {
    path: ['M19.9565 13.1514C19.9565 12.8623 19.9078 12.6672 19.7766 12.459L17.1465 8.45905C17.056 8.32148 16.9328 8.20839 16.788 8.12988C16.6432 8.05138 16.4813 8.00989 16.3166 8.00903H7.55658C7.39187 8.00989 7.22994 8.05138 7.08515 8.12988C6.94035 8.20839 6.81715 8.32148 6.72656 8.45905L4.09656 12.459C3.96038 12.6726 3.95644 12.9209 3.95654 13.179C3.95663 13.2178 3.9565 13.3115 3.95654 13.389V20.009V20.809C3.95654 21.1273 4.083 21.4325 4.30805 21.6575C4.53309 21.8826 4.8383 22.009 5.15656 22.009H6.75659C7.07485 22.009 7.38006 21.8826 7.6051 21.6575C7.83015 21.4325 7.95654 21.1273 7.95654 20.809V20.009H15.9565V20.809C15.9565 21.1273 16.083 21.4325 16.308 21.6575C16.5331 21.8826 16.8383 22.009 17.1566 22.009H18.7566C19.0749 22.009 19.3801 21.8826 19.6051 21.6575C19.8301 21.4325 19.9565 21.1273 19.9565 20.809V13.259C19.9565 13.259 19.9565 13.1914 19.9565 13.1514ZM6.71655 18.009H5.91657V16.889H7.39655C7.66176 16.889 7.91616 16.7837 8.1037 16.5961C8.29124 16.4086 8.39655 16.1543 8.39655 15.889C8.39655 15.6238 8.29124 15.3695 8.1037 15.1819C7.91616 14.9944 7.66176 14.889 7.39655 14.889H5.91657V14.009H17.9166V14.9091H17.8466H16.1066C15.8414 14.9091 15.587 15.0144 15.3995 15.2019C15.2119 15.3894 15.1066 15.6438 15.1066 15.9091C15.1066 16.1743 15.2119 16.4286 15.3995 16.6161C15.587 16.8037 15.8414 16.9091 16.1066 16.9091H17.9166V18.009H6.71655ZM8.08655 10.009H15.7466L17.0666 12.009H6.76654L8.08655 10.009Z', 'M6.2099 6.71599C6.39744 6.90353 6.65178 7.0089 6.91699 7.0089H16.917C17.1822 7.0089 17.4365 6.90353 17.6241 6.71599C17.8116 6.52845 17.917 6.27412 17.917 6.0089C17.917 5.74368 17.8116 5.48934 17.6241 5.30181C17.4365 5.11427 17.1822 5.0089 16.917 5.0089H16.597C16.6308 4.85398 16.6542 4.69699 16.667 4.53893C16.6826 4.21437 16.6302 3.89006 16.5131 3.58696C16.396 3.28386 16.2168 3.00865 15.987 2.77892C15.5332 2.31234 14.9188 2.03606 14.2687 2.00634C13.6185 1.97661 12.9814 2.19565 12.487 2.61888C12.309 2.76194 12.1568 2.93445 12.037 3.12889L11.917 3.30889C11.7673 3.04834 11.5746 2.81504 11.347 2.61888C10.8526 2.19565 10.2155 1.97661 9.56531 2.00634C8.91515 2.03606 8.30074 2.31234 7.84698 2.77892C7.61718 3.00865 7.43797 3.28386 7.32086 3.58696C7.20375 3.89006 7.15135 4.21437 7.16699 4.53893C7.17977 4.69699 7.20317 4.85398 7.237 5.0089H6.91699C6.65178 5.0089 6.39744 5.11427 6.2099 5.30181C6.02236 5.48934 5.91699 5.74368 5.91699 6.0089C5.91699 6.27412 6.02236 6.52845 6.2099 6.71599ZM14.147 4.0089C14.012 4.00622 13.8806 4.05239 13.777 4.1389C13.5569 4.37847 13.4232 4.68466 13.397 5.0089C13.7941 5.02668 14.1875 4.92574 14.527 4.71892C14.5694 4.68532 14.6039 4.64279 14.6281 4.59441C14.6522 4.54603 14.6655 4.49296 14.667 4.43889C14.6679 4.38878 14.6586 4.339 14.6397 4.29259C14.6208 4.24618 14.5927 4.20408 14.557 4.16887C14.5027 4.11636 14.4384 4.07518 14.368 4.04772C14.2977 4.02025 14.2225 4.00706 14.147 4.0089ZM9.46594 4.01775C9.39556 4.04522 9.3313 4.08639 9.27698 4.1389C9.21205 4.20266 9.1729 4.31812 9.16699 4.40892C9.16844 4.46299 9.18174 4.51606 9.20593 4.56444C9.23012 4.61282 9.26462 4.65529 9.30701 4.68889C9.645 4.8992 10.0395 5.00043 10.437 4.97887C10.4108 4.65463 10.2771 4.34844 10.057 4.10887C9.95337 4.02236 9.82198 3.97619 9.68701 3.97887C9.61148 3.97703 9.53633 3.99028 9.46594 4.01775Z']
  },
  CAR_SELL: {
    path: ['M23 15H20V12C20 11.448 19.552 11 19 11C18.448 11 18 11.448 18 12V15H15C14.448 15 14 15.448 14 16C14 16.552 14.448 17 15 17H18V20C18 20.552 18.448 21 19 21C19.552 21 20 20.552 20 20V17H23C23.552 17 24 16.552 24 16C24 15.448 23.552 15 23 15M11 16H5.5H5V15H7C7.552 15 8 14.552 8 14C8 13.448 7.552 13 7 13H5V12H11H15C15.552 12 16 11.552 16 11C16 10.448 15.552 10 15 10H11H5.618L7.618 6H16.382L17.105 7.447C17.353 7.941 17.953 8.143 18.447 7.895C18.941 7.647 19.142 7.047 18.895 6.553L17.895 4.553C17.725 4.214 17.379 4 17 4H7C6.621 4 6.275 4.214 6.105 4.553L3.105 10.553C3.1 10.565 3.098 10.578 3.092 10.59C3.083 10.612 3.078 10.634 3.069 10.656C3.033 10.755 3.012 10.857 3.008 10.961C3.007 10.975 3 10.986 3 11V17C3 17.064 3.025 17.12 3.036 17.18C3.014 17.284 3 17.39 3 17.5V18.5C3 19.325 3.675 20 4.5 20H5.5C6.325 20 7 19.325 7 18.5V18H11C11.552 18 12 17.552 12 17C12 16.448 11.552 16 11 16']
  },
  BIKE: {
    path: ['M21.9413 12.499C21.8806 12.3472 21.7813 12.2138 21.6533 12.1121C21.5253 12.0104 21.3729 11.9438 21.2113 11.919L18.9713 11.759L18.1213 9.67898C18.0606 9.52459 17.9545 9.39225 17.8171 9.29941C17.6796 9.20657 17.5172 9.15758 17.3513 9.15896C17.1886 9.17052 17.0319 9.22468 16.8967 9.31595C16.7616 9.40722 16.6528 9.53241 16.5813 9.67898L15.7313 11.759L13.4913 11.919C13.326 11.9327 13.1684 11.9952 13.0384 12.0984C12.9085 12.2016 12.8121 12.341 12.7613 12.499C12.7195 12.6554 12.7216 12.8203 12.7675 12.9756C12.8134 13.1308 12.9012 13.2704 13.0213 13.379L14.7313 14.839L14.2113 16.969C14.1691 17.1323 14.177 17.3045 14.2341 17.4633C14.2912 17.622 14.3948 17.7599 14.5313 17.859C14.6749 17.9677 14.8513 18.0242 15.0313 18.019C15.1893 18.0197 15.3446 17.9782 15.4813 17.899L17.3513 16.739L19.2213 17.899C19.3652 17.9875 19.5322 18.0311 19.7009 18.0243C19.8697 18.0175 20.0325 17.9606 20.1688 17.8608C20.3051 17.761 20.4086 17.6229 20.466 17.464C20.5234 17.3052 20.5323 17.1328 20.4913 16.969L19.9713 14.839L21.6913 13.379C21.8146 13.2729 21.904 13.133 21.9485 12.9765C21.9929 12.8201 21.9905 12.654 21.9413 12.499ZM18.6413 13.989C18.5366 14.0802 18.4589 14.1983 18.4166 14.3305C18.3743 14.4627 18.369 14.604 18.4013 14.739L18.6613 15.739L17.7513 15.179C17.6308 15.1057 17.4924 15.0669 17.3513 15.0669C17.2102 15.0669 17.0718 15.1057 16.9513 15.179L16.0413 15.739L16.3013 14.739C16.3336 14.604 16.3283 14.4627 16.286 14.3305C16.2437 14.1983 16.166 14.0802 16.0613 13.989L15.2413 13.299L16.3113 13.219C16.4499 13.2081 16.5828 13.1596 16.6956 13.0785C16.8085 12.9974 16.8969 12.8869 16.9513 12.759L17.3513 11.759L17.7513 12.759C17.8058 12.8869 17.8942 12.9974 18.007 13.0785C18.1199 13.1596 18.2528 13.2081 18.3913 13.219L19.4613 13.299L18.6413 13.989Z', 'M10.5 12.9991H9.5C9.10218 12.9991 8.72064 13.1571 8.43933 13.4384C8.15803 13.7197 8 14.1013 8 14.4991V17.6491C7.40346 17.3662 6.89912 16.9202 6.54523 16.3629C6.19133 15.8055 6.00232 15.1593 6 14.4991V11.4991C5.99957 10.9969 6.10847 10.5006 6.31915 10.0447C6.52983 9.58878 6.8372 9.18421 7.21997 8.85907C7.72205 9.34202 8.3416 9.68546 9.01721 9.85541C9.69282 10.0254 10.4011 10.0159 11.0719 9.828C11.7427 9.64009 12.3529 9.28024 12.8419 8.78406C13.3309 8.28788 13.6818 7.67258 13.86 6.99908H17C17.2652 6.99908 17.5196 6.89371 17.7071 6.70618C17.8946 6.51864 18 6.2643 18 5.99908C18 5.73387 17.8946 5.47953 17.7071 5.29199C17.5196 5.10446 17.2652 4.99908 17 4.99908H13.86C13.6297 4.15171 13.127 3.40368 12.4294 2.87036C11.7318 2.33704 10.8781 2.0481 10 2.0481C9.1219 2.0481 8.26821 2.33704 7.57062 2.87036C6.87302 3.40368 6.3703 4.15171 6.14001 4.99908H3C2.73478 4.99908 2.48044 5.10446 2.29291 5.29199C2.10537 5.47953 2 5.73387 2 5.99908C2 6.2643 2.10537 6.51864 2.29291 6.70618C2.48044 6.89371 2.73478 6.99908 3 6.99908H6.14001V7.12909C5.4703 7.64298 4.92857 8.30491 4.55731 9.06305C4.18605 9.82118 3.99532 10.6549 4 11.4991V14.4991C4.0036 15.6952 4.39561 16.8577 5.117 17.8118C5.8384 18.7658 6.85015 19.4597 8 19.7891V20.4991C8 20.8969 8.15803 21.2784 8.43933 21.5598C8.72064 21.8411 9.10218 21.9991 9.5 21.9991H10.5C10.8978 21.9991 11.2794 21.8411 11.5607 21.5598C11.842 21.2784 12 20.8969 12 20.4991V14.4991C12 14.1013 11.842 13.7197 11.5607 13.4384C11.2794 13.1571 10.8978 12.9991 10.5 12.9991ZM10 3.99908C10.3956 3.99908 10.7822 4.11636 11.1111 4.33612C11.44 4.55588 11.6964 4.86825 11.8478 5.2337C11.9992 5.59916 12.0387 6.00132 11.9615 6.38928C11.8844 6.77724 11.6939 7.13356 11.4142 7.41327C11.1345 7.69297 10.7782 7.88346 10.3902 7.96063C10.0022 8.0378 9.60007 7.99824 9.23462 7.84686C8.86917 7.69549 8.5568 7.43913 8.33704 7.11023C8.11727 6.78133 8 6.39465 8 5.99908C8 5.46865 8.21074 4.95997 8.58582 4.5849C8.96089 4.20983 9.46957 3.99908 10 3.99908Z']
  },
  BIKE_USED: {
    path: ['M12 12.5C12 13.891 11.178 15.085 10 15.649V12.5C10 11.675 9.325 11 8.5 11H7.5C6.675 11 6 11.675 6 12.5V15.649C4.822 15.085 4 13.891 4 12.5V9.5C4 8.473 4.455 7.521 5.216 6.862C5.937 7.564 6.917 8 8 8C9.083 8 10.063 7.564 10.784 6.863C11.545 7.521 12 8.473 12 9.5V12.5ZM8 2C9.103 2 10 2.897 10 4C10 5.103 9.103 6 8 6C6.897 6 6 5.103 6 4C6 2.897 6.897 2 8 2ZM15 3H11.857C11.411 1.28 9.858 0 8 0C6.142 0 4.589 1.28 4.143 3H1C0.447 3 0 3.448 0 4C0 4.552 0.447 5 1 5H4.143C4.153 5.043 4.169 5.085 4.182 5.128C2.821 6.161 2 7.763 2 9.5V12.5C2 15.012 3.695 17.131 6 17.787V18.5C6 19.325 6.675 20 7.5 20H8.5C9.325 20 10 19.325 10 18.5V17.787C12.305 17.131 14 15.012 14 12.5V9.5C14 7.763 13.179 6.161 11.818 5.128C11.831 5.085 11.847 5.043 11.857 5H15C15.553 5 16 4.552 16 4C16 3.448 15.553 3 15 3Z']
  },
  BIKE_SELL: {
    path: ['M7.21997 8.86005C7.72205 9.343 8.3416 9.68644 9.01721 9.85638C9.69282 10.0263 10.4011 10.0169 11.0719 9.82898C11.7427 9.64107 12.3529 9.28121 12.8419 8.78503C13.3309 8.28885 13.6818 7.67356 13.86 7.00006H17C17.2652 7.00006 17.5196 6.89469 17.7071 6.70715C17.8946 6.51962 18 6.26528 18 6.00006C18 5.73484 17.8946 5.48051 17.7071 5.29297C17.5196 5.10543 17.2652 5.00006 17 5.00006H13.86C13.6297 4.15269 13.127 3.40465 12.4294 2.87134C11.7318 2.33802 10.8781 2.04907 10 2.04907C9.1219 2.04907 8.26821 2.33802 7.57062 2.87134C6.87302 3.40465 6.3703 4.15269 6.14001 5.00006H3C2.73478 5.00006 2.48044 5.10543 2.29291 5.29297C2.10537 5.48051 2 5.73484 2 6.00006C2 6.26528 2.10537 6.51962 2.29291 6.70715C2.48044 6.89469 2.73478 7.00006 3 7.00006H6.14001V7.13007C5.4703 7.64396 4.92857 8.30589 4.55731 9.06403C4.18605 9.82216 3.99532 10.6559 4 11.5001V14.5001C4.0036 15.6961 4.39561 16.8587 5.117 17.8127C5.8384 18.7668 6.85015 19.4607 8 19.79V20.5001C8 20.8979 8.15803 21.2794 8.43933 21.5607C8.72064 21.842 9.10218 22.0001 9.5 22.0001H10.5C10.8978 22.0001 11.2794 21.842 11.5607 21.5607C11.842 21.2794 12 20.8979 12 20.5001V14.5001C12 14.1022 11.842 13.7207 11.5607 13.4394C11.2794 13.1581 10.8978 13.0001 10.5 13.0001H9.5C9.10218 13.0001 8.72064 13.1581 8.43933 13.4394C8.15803 13.7207 8 14.1022 8 14.5001V17.6501C7.40346 17.3671 6.89912 16.9212 6.54523 16.3638C6.19133 15.8064 6.00232 15.1603 6 14.5001V11.5001C5.99957 10.9978 6.10847 10.5015 6.31915 10.0457C6.52983 9.58976 6.8372 9.18518 7.21997 8.86005V8.86005ZM10 4.00006C10.3956 4.00006 10.7822 4.11733 11.1111 4.3371C11.44 4.55686 11.6964 4.86923 11.8478 5.23468C11.9992 5.60013 12.0387 6.0023 11.9615 6.39026C11.8844 6.77822 11.6939 7.13454 11.4142 7.41425C11.1345 7.69395 10.7782 7.88444 10.3902 7.96161C10.0022 8.03878 9.60007 7.99921 9.23462 7.84784C8.86917 7.69646 8.5568 7.4401 8.33704 7.11121C8.11727 6.78231 8 6.39562 8 6.00006C8 5.46963 8.21074 4.96095 8.58582 4.58588C8.96089 4.2108 9.46957 4.00006 10 4.00006Z', 'M21 12H18.5V9.5C18.5 9.23478 18.3946 8.98044 18.2071 8.79291C18.0196 8.60537 17.7652 8.5 17.5 8.5C17.2348 8.5 16.9804 8.60537 16.7929 8.79291C16.6054 8.98044 16.5 9.23478 16.5 9.5V12H14C13.7348 12 13.4804 12.1054 13.2929 12.2929C13.1054 12.4804 13 12.7348 13 13C13 13.2652 13.1054 13.5196 13.2929 13.7071C13.4804 13.8946 13.7348 14 14 14H16.5V16.5C16.5 16.7652 16.6054 17.0196 16.7929 17.2071C16.9804 17.3946 17.2348 17.5 17.5 17.5C17.7652 17.5 18.0196 17.3946 18.2071 17.2071C18.3946 17.0196 18.5 16.7652 18.5 16.5V14H21C21.2652 14 21.5196 13.8946 21.7071 13.7071C21.8946 13.5196 22 13.2652 22 13C22 12.7348 21.8946 12.4804 21.7071 12.2929C21.5196 12.1054 21.2652 12 21 12Z']
  },
  FAZ_TUDO: {
    path: ['M1.84454 5.00876C1.98994 4.91852 2.17545 4.96364 2.2657 5.10403L2.52642 5.52017L2.8824 6.09174C3.00774 6.29229 3.30355 6.28226 3.41386 6.07168C4.3765 4.2216 6.2316 2.88794 8.46273 2.6924L9.49557 1.46402C9.60587 1.33366 9.58582 1.14314 9.45546 1.03284L8.22708 0C5.02328 0.280772 2.35595 2.20606 0.987189 4.87339C0.846803 5.14915 1.16267 5.43494 1.42339 5.26948L1.4284 5.26447L1.84454 5.00876ZM17.9938 8.1925L17.9938 8.19242C17.9738 7.9919 17.9537 7.79137 17.9186 7.59084C17.8685 7.27999 17.4473 7.22985 17.332 7.52065V7.52566L17.1515 7.9769C17.0863 8.13233 16.9109 8.20754 16.7504 8.14737L16.2992 7.96186L15.6725 7.71117C15.4519 7.62093 15.2212 7.80644 15.2563 8.04208C15.2764 8.16743 15.2914 8.29779 15.3014 8.42814C15.4819 10.5189 14.6246 12.4592 13.1555 13.7377L13.0452 15.3371C13.0352 15.5076 13.1606 15.653 13.331 15.663L14.9304 15.7733C17.0262 13.9533 18.2546 11.1807 17.9938 8.1925ZM0.0345465 9.76687C-0.0506877 8.79921 0.0245189 7.85161 0.230084 6.95414L1.58882 6.09678C1.7292 6.00654 1.91973 6.04665 2.00998 6.19205L2.86232 7.55078C2.71692 8.18252 2.66678 8.84433 2.72695 9.52119C2.8573 11.0404 3.52414 12.3891 4.51686 13.3968C4.68232 13.5673 4.6021 13.8531 4.37146 13.9082L3.71466 14.0737L3.23835 14.194C3.07791 14.2341 2.97763 14.3996 3.01774 14.5651L3.13808 15.0414C3.21328 15.3472 2.84226 15.5528 2.62166 15.3322C1.18772 13.8932 0.22507 11.9529 0.0345465 9.76687ZM12.4787 16.4101C12.3083 16.4 12.1829 16.2496 12.193 16.0842L12.2281 15.5978L12.2732 14.926C12.2882 14.6903 12.0426 14.5249 11.832 14.6302C11.1401 14.9761 10.378 15.1967 9.56073 15.2719C8.18194 15.3923 6.86332 15.0564 5.76029 14.3945L4.201 14.7806C4.03555 14.8207 3.93527 14.9862 3.97538 15.1516L4.36144 16.7109C5.93577 17.6585 7.81594 18.1398 9.79136 17.9643C10.9746 17.8591 12.0827 17.5332 13.0854 17.0268C13.3612 16.8864 13.2759 16.4702 12.9651 16.4502H12.9601L12.4787 16.4101ZM10.4431 0.0800813C13.5115 0.571432 16.1087 2.62708 17.312 5.45986L16.7103 6.94394C16.6451 7.10438 16.4646 7.17959 16.3092 7.11441L14.8201 6.51276C13.9828 4.53733 12.1779 3.10339 10.047 2.75242C9.81638 2.71733 9.7161 2.43656 9.86651 2.25606L10.2977 1.73964L10.6136 1.36361C10.7189 1.23325 10.7038 1.04273 10.5735 0.932424L10.1974 0.616556C9.96177 0.421018 10.1373 0.0299436 10.4431 0.0800813Z']
  },
  FINANCING: {
    path: ['M17.451 3.80858C19.0985 5.00269 20.3192 6.69407 20.9336 8.63385L21.3627 7.85139C21.4162 7.74915 21.4895 7.65856 21.5783 7.5849C21.6671 7.51124 21.7697 7.45597 21.8801 7.4223C22.0435 7.36899 22.2188 7.36447 22.3847 7.4093C22.5506 7.45413 22.6998 7.54636 22.814 7.6747C22.8891 7.76063 22.9488 7.85882 22.9907 7.96497C23.0031 8.07821 23.0031 8.19247 22.9907 8.30572C22.9763 8.42011 22.9421 8.53113 22.8897 8.63385L21.5267 11.3977C21.4496 11.5378 21.3417 11.6586 21.2112 11.7511C21.0768 11.8293 20.925 11.8726 20.7695 11.8773C20.6334 11.8855 20.4977 11.8549 20.3783 11.7889L17.5639 10.3502C17.3712 10.2381 17.2272 10.0581 17.1601 9.8454C17.1021 9.63285 17.1255 9.40628 17.2259 9.21016C17.3263 9.01403 17.4964 8.8625 17.7028 8.78529C17.9094 8.70309 18.1397 8.70309 18.3464 8.78529L19.2803 9.26487C18.8387 7.6529 17.8812 6.22997 16.5543 5.21373C15.2067 4.18211 13.5567 3.6231 11.8596 3.6231C10.1624 3.6231 8.51244 4.18211 7.16478 5.21373C5.83511 6.24947 4.8855 7.69606 4.46403 9.32797C4.4259 9.44013 4.36463 9.54302 4.28419 9.62999C4.20375 9.71695 4.10593 9.78604 3.99708 9.83278C3.79285 9.94531 3.55241 9.97253 3.3282 9.9085C3.11128 9.83522 2.93065 9.68168 2.82338 9.47941C2.71508 9.27346 2.6924 9.0331 2.76028 8.81053C3.3368 6.85918 4.52441 5.14438 6.14839 3.91846C7.77236 2.69254 9.74694 2.02023 11.7816 2.00045C13.8162 1.98067 15.8035 2.61446 17.451 3.80858ZM6.44542 20.0805C8.0831 21.3019 10.0572 21.9893 12.0993 22.0493H12.1246C14.1974 21.9965 16.2014 21.2946 17.8542 20.0426C19.4899 18.8358 20.7042 17.1447 21.3248 15.209C21.3494 15.0968 21.3494 14.9805 21.3248 14.8683C21.3104 14.7539 21.2762 14.6429 21.2239 14.5402C21.1738 14.44 21.1001 14.3533 21.0093 14.2878C20.9234 14.2089 20.8194 14.1526 20.7064 14.1237C20.5942 14.0991 20.4779 14.0991 20.3657 14.1237C20.2513 14.1381 20.1403 14.1723 20.0375 14.2247C19.9357 14.2777 19.8456 14.3507 19.7725 14.4392C19.7013 14.5256 19.6458 14.6239 19.6084 14.7295C19.2898 15.9668 18.6677 17.1052 17.7984 18.0417C16.9291 18.9781 15.8401 19.6831 14.6298 20.0927C13.4196 20.5024 12.1263 20.6039 10.8669 20.388C9.60757 20.1722 8.4219 19.6457 7.41719 18.8563C6.11627 17.8525 5.17718 16.4527 4.74168 14.8683L5.67558 15.3226C5.88992 15.4103 6.13012 15.4103 6.34446 15.3226C6.56226 15.2441 6.74249 15.0864 6.84927 14.8809C6.93694 14.6666 6.93694 14.4264 6.84927 14.212C6.7707 13.9942 6.613 13.814 6.40756 13.7072L3.56798 12.3568C3.46125 12.3072 3.34495 12.2815 3.22723 12.2815C3.10951 12.2815 2.99322 12.3072 2.88648 12.3568C2.77208 12.3953 2.66832 12.4602 2.5836 12.5462C2.49535 12.6265 2.42634 12.7257 2.38167 12.8364L1.05653 16.0041C0.981155 16.2077 0.981155 16.4316 1.05653 16.6351C1.14558 16.8382 1.30777 17.0004 1.51087 17.0895C1.62003 17.1298 1.73527 17.1511 1.85162 17.1526C2.02008 17.1558 2.18612 17.1121 2.33119 17.0264C2.47579 16.9356 2.59004 16.8038 2.65932 16.6478L3.11365 15.575C3.76366 17.3683 4.92129 18.9337 6.44542 20.0805ZM11.1781 6.74069V7.30861C10.7128 7.43835 10.2847 7.67618 9.92873 8.00273C9.51887 8.41715 9.24203 8.94447 9.13365 9.51717C9.0228 10.0765 9.07988 10.6561 9.29771 11.1831C9.5258 11.7181 9.9081 12.1732 10.3959 12.4901C10.8836 12.807 11.4547 12.9715 12.0363 12.9625C12.2428 12.9849 12.4393 13.0635 12.6042 13.1897C12.7878 13.3066 12.9293 13.479 13.0081 13.6819C13.0982 13.8795 13.1203 14.1014 13.0712 14.3129C13.0248 14.5055 12.924 14.6807 12.7809 14.8177C12.621 14.9661 12.4253 15.0704 12.213 15.1206C12.0007 15.1536 11.7835 15.1319 11.582 15.0575C11.382 14.9738 11.2109 14.8334 11.0898 14.6537C10.9656 14.4762 10.8994 14.2645 10.9005 14.0479C10.9154 13.9239 10.9038 13.7981 10.8666 13.6789C10.8293 13.5597 10.7672 13.4497 10.6843 13.3562C10.6014 13.2628 10.4996 13.188 10.3857 13.1368C10.2718 13.0855 10.1483 13.059 10.0234 13.059C9.89847 13.059 9.77498 13.0855 9.66106 13.1368C9.54714 13.188 9.44538 13.2628 9.36249 13.3562C9.2796 13.4497 9.21747 13.5597 9.1802 13.6789C9.14293 13.7981 9.13136 13.9239 9.14627 14.0479C9.14113 14.6674 9.33435 15.2723 9.69767 15.7742C10.061 16.276 10.5754 16.6484 11.1655 16.837V17.3923C11.1506 17.5163 11.1622 17.6421 11.1995 17.7613C11.2367 17.8805 11.2989 17.9904 11.3817 18.0839C11.4646 18.1773 11.5664 18.2521 11.6803 18.3034C11.7942 18.3546 11.9177 18.3811 12.0426 18.3811C12.1675 18.3811 12.291 18.3546 12.405 18.3034C12.5189 18.2521 12.6206 18.1773 12.7035 18.0839C12.7864 17.9904 12.8485 17.8805 12.8858 17.7613C12.9231 17.6421 12.9347 17.5163 12.9198 17.3923V16.7865C13.3571 16.6457 13.7549 16.4035 14.0808 16.0797C14.3487 15.8135 14.5613 15.4969 14.7063 15.1482C14.8514 14.7995 14.9261 14.4256 14.9261 14.0479C14.9261 13.6702 14.8514 13.2962 14.7063 12.9475C14.5613 12.5988 14.3487 12.2822 14.0808 12.016C13.5326 11.4845 12.7999 11.186 12.0363 11.1831C11.7941 11.1733 11.5607 11.0897 11.3674 10.9433C11.1877 10.8221 11.0473 10.651 10.9636 10.4511C10.9066 10.2446 10.9066 10.0265 10.9636 9.82006C11.0158 9.61225 11.12 9.42115 11.2665 9.26476C11.407 9.14361 11.5766 9.06099 11.7587 9.02498C11.9703 8.97677 12.1918 8.99893 12.3897 9.08808C12.5892 9.1664 12.7606 9.30267 12.8819 9.47931C12.9956 9.66105 13.0567 9.87072 13.0586 10.0851C13.0595 10.2006 13.0835 10.3147 13.129 10.4209C13.1745 10.5271 13.2406 10.6231 13.3236 10.7035C13.4059 10.7874 13.504 10.8541 13.6124 10.8997C13.7207 10.9452 13.8371 10.9686 13.9546 10.9686C14.0722 10.9686 14.1885 10.9452 14.2969 10.8997C14.4052 10.8541 14.5034 10.7874 14.5856 10.7035C14.6686 10.6231 14.7348 10.5271 14.7803 10.4209C14.8258 10.3147 14.8497 10.2006 14.8507 10.0851C14.8463 9.51427 14.6753 8.95716 14.3585 8.4823C14.053 8.01091 13.6135 7.6417 13.0964 7.42219L12.9198 7.34647V6.69021C12.9202 6.57751 12.8981 6.46587 12.8547 6.36184C12.8114 6.25781 12.7477 6.16349 12.6673 6.08444C12.4988 5.91834 12.2729 5.82345 12.0363 5.81941C11.8007 5.84048 11.5829 5.95389 11.4306 6.13492C11.3502 6.21397 11.2865 6.30829 11.2432 6.41232C11.1998 6.51635 11.1777 6.628 11.1781 6.74069Z']
  },
  CONSORTIUM: {
    path: ['M19.584 2.18876C19.323 1.99976 18.988 1.94976 18.684 2.05076L16.077 2.92076L14.447 2.10576C14.166 1.96476 13.834 1.96476 13.553 2.10576L12 2.88176L10.447 2.10576C10.166 1.96476 9.834 1.96476 9.553 2.10576L7.924 2.92076L5.316 2.05076C5.011 1.94976 4.677 1.99976 4.415 2.18876C4.154 2.37676 4 2.67876 4 2.99976V20.9998C4 21.3208 4.154 21.6228 4.416 21.8108C4.677 21.9988 5.011 22.0488 5.316 21.9488L7.923 21.0798L9.553 21.8948C9.834 22.0348 10.166 22.0348 10.447 21.8948L12.041 21.0978L14.059 21.9258C14.359 22.0478 14.703 22.0178 14.978 21.8418L16.137 21.0998L18.684 21.9488C18.787 21.9828 18.894 21.9998 19 21.9998C19.207 21.9998 19.412 21.9358 19.584 21.8108C19.846 21.6228 20 21.3208 20 20.9998V2.99976C20 2.67876 19.846 2.37676 19.584 2.18876ZM18 19.6128L16.316 19.0508C16.029 18.9558 15.715 18.9948 15.461 19.1578L14.337 19.8778L12.379 19.0748C12.114 18.9658 11.812 18.9758 11.553 19.1058L10 19.8818L8.447 19.1058C8.307 19.0358 8.154 18.9998 8 18.9998C7.894 18.9998 7.787 19.0168 7.684 19.0508L6 19.6128V4.38676L7.684 4.94876C7.937 5.03176 8.211 5.01276 8.448 4.89476L10 4.11776L11.553 4.89476C11.834 5.03476 12.166 5.03476 12.447 4.89476L14 4.11776L15.553 4.89476C15.79 5.01276 16.064 5.03176 16.316 4.94876L18 4.38676V19.6128ZM14.2104 11.7554L14.2004 11.7474C13.7434 11.4164 13.1584 11.1774 12.3464 10.9954L12.1714 10.9604C11.7304 10.8554 11.4024 10.7214 11.1974 10.5624C10.9794 10.3944 10.9614 10.2794 10.9614 10.1684C10.9614 9.93036 11.1334 9.75236 11.2304 9.67236C11.4374 9.50236 11.7344 9.39436 11.9984 9.37736L12.1644 9.37636C12.6274 9.39536 13.0104 9.65336 13.5284 10.0344C13.7284 10.1694 13.9774 10.2114 14.2104 10.1534L14.5644 10.0334L14.7234 9.76936C14.9624 9.37136 14.8544 8.85836 14.5044 8.62136C14.1324 8.34136 13.6164 7.95536 12.9454 7.76236V7.22136C12.9454 6.26136 12.1234 6.25036 12.0884 6.25036L11.7104 6.27136L11.4894 6.49636C11.2394 6.75036 11.2454 7.05936 11.2484 7.22136V7.76236C10.0844 8.08736 9.2664 9.03136 9.2554 10.1684C9.2554 10.8714 9.5814 11.5024 10.1724 11.9464C10.5954 12.2644 11.1544 12.5024 11.8474 12.6564L12.0334 12.6934C12.5724 12.8134 12.9584 12.9634 13.1864 13.1404C13.4184 13.3184 13.4654 13.4634 13.4654 13.6244C13.4654 13.8964 13.2864 14.1014 13.1384 14.2244C12.8874 14.4324 12.5474 14.5504 12.1954 14.5564L12.0544 14.5584C11.3174 14.5044 10.6594 13.9524 10.4694 13.7794C10.2994 13.6274 10.0854 13.5584 9.8534 13.5654L9.4254 13.6224L9.2184 13.9124C8.9594 14.2724 9.0154 14.7854 9.3374 15.0724C9.6324 15.3434 10.3304 15.9104 11.2484 16.1654V16.7124C11.2454 16.8434 11.2394 17.1524 11.4894 17.4064L11.7734 17.6534H12.0884C12.1234 17.6534 12.9454 17.6424 12.9454 16.6814V16.1964C14.2294 15.8914 15.1604 14.8654 15.1704 13.6244C15.1704 12.8854 14.8294 12.2214 14.2104 11.7554Z']
  },
  POCKET: {
    path: ['M14.0981 11.8032L14.0881 11.7952C13.6311 11.4642 13.0461 11.2252 12.2341 11.0432L12.0591 11.0082C11.6181 10.9032 11.2901 10.7692 11.0851 10.6102C10.8671 10.4422 10.8491 10.3272 10.8491 10.2162C10.8491 9.9782 11.0211 9.8002 11.1181 9.7202C11.3251 9.5502 11.6211 9.4422 11.8861 9.4252L12.0521 9.4242C12.5151 9.4432 12.8981 9.7012 13.4161 10.0822C13.6161 10.2172 13.8651 10.2592 14.0981 10.2012L14.4521 10.0812L14.6111 9.8172C14.8501 9.4192 14.7421 8.9062 14.3921 8.6692C14.0201 8.3892 13.5041 8.0032 12.8331 7.8102V7.2692C12.8331 6.3092 12.0111 6.2982 11.9761 6.2982L11.5981 6.3192L11.3771 6.5442C11.1271 6.7982 11.1331 7.1072 11.1361 7.2692V7.8102C9.9721 8.1352 9.1541 9.0792 9.1431 10.2162C9.1431 10.9192 9.4691 11.5502 10.0601 11.9942C10.4831 12.3122 11.0421 12.5502 11.7351 12.7042L11.9211 12.7412C12.4601 12.8612 12.8461 13.0112 13.0741 13.1882C13.3061 13.3662 13.3531 13.5112 13.3531 13.6722C13.3531 13.9442 13.1741 14.1492 13.0261 14.2722C12.7751 14.4802 12.4351 14.5982 12.0831 14.6042L11.9421 14.6062C11.2041 14.5522 10.5471 14.0002 10.3571 13.8272C10.1871 13.6752 9.9731 13.6062 9.7411 13.6132L9.3131 13.6702L9.1061 13.9602C8.8471 14.3202 8.9031 14.8332 9.2251 15.1202C9.5201 15.3912 10.2181 15.9582 11.1361 16.2132V16.7602C11.1331 16.8912 11.1271 17.2002 11.3771 17.4542L11.6601 17.7012H11.9761C12.0111 17.7012 12.8331 17.6902 12.8331 16.7292V16.2442C14.1171 15.9392 15.0481 14.9132 15.0581 13.6722C15.0581 12.9332 14.7171 12.2692 14.0981 11.8032ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z']
  },
  PORTAL: {
    path: ['M16.87 2C17.0188 1.99867 17.1663 2.027 17.304 2.08331C17.4417 2.13963 17.5668 2.22281 17.672 2.328C17.7772 2.4332 17.8604 2.55828 17.9167 2.69598C17.973 2.83368 18.0013 2.98124 18 3.13V12.87C18.0013 13.0188 17.973 13.1663 17.9167 13.304C17.8604 13.4417 17.7772 13.5668 17.672 13.672C17.5668 13.7772 17.4417 13.8604 17.304 13.9167C17.1663 13.973 17.0188 14.0013 16.87 14H3.13C2.83031 14 2.54291 13.8809 2.33099 13.669C2.11908 13.4571 2 13.1697 2 12.87V3.13C2 2.83031 2.11908 2.54291 2.33099 2.33099C2.54291 2.11908 2.83031 2 3.13 2H16.87ZM16.87 0H3.13C2.29988 0 1.50374 0.329759 0.916748 0.916748C0.329759 1.50374 0 2.29988 0 3.13V12.87C0 13.7001 0.329759 14.4963 0.916748 15.0833C1.50374 15.6702 2.29988 16 3.13 16H16.87C17.7001 16 18.4963 15.6702 19.0833 15.0833C19.6702 14.4963 20 13.7001 20 12.87V3.13C20 2.29988 19.6702 1.50374 19.0833 0.916748C18.4963 0.329759 17.7001 0 16.87 0V0Z', 'M16 12H12C11.7348 12 11.4804 11.8946 11.2929 11.7071C11.1054 11.5196 11 11.2652 11 11C11 10.7348 11.1054 10.4804 11.2929 10.2929C11.4804 10.1054 11.7348 10 12 10H16C16.2652 10 16.5196 10.1054 16.7071 10.2929C16.8946 10.4804 17 10.7348 17 11C17 11.2652 16.8946 11.5196 16.7071 11.7071C16.5196 11.8946 16.2652 12 16 12Z', 'M16 9H12C11.7348 9 11.4804 8.89463 11.2929 8.70709C11.1054 8.51956 11 8.26522 11 8C11 7.73478 11.1054 7.48044 11.2929 7.29291C11.4804 7.10537 11.7348 7 12 7H16C16.2652 7 16.5196 7.10537 16.7071 7.29291C16.8946 7.48044 17 7.73478 17 8C17 8.26522 16.8946 8.51956 16.7071 8.70709C16.5196 8.89463 16.2652 9 16 9Z', 'M4.03023 5.02995C4.60461 5.02995 5.07023 4.56433 5.07023 3.98995C5.07023 3.41557 4.60461 2.94995 4.03023 2.94995C3.45586 2.94995 2.99023 3.41557 2.99023 3.98995C2.99023 4.56433 3.45586 5.02995 4.03023 5.02995Z', 'M7.04 5.02995C7.61438 5.02995 8.08 4.56433 8.08 3.98995C8.08 3.41557 7.61438 2.94995 7.04 2.94995C6.46562 2.94995 6 3.41557 6 3.98995C6 4.56433 6.46562 5.02995 7.04 5.02995Z', 'M10.04 5.02995C10.6144 5.02995 11.08 4.56433 11.08 3.98995C11.08 3.41557 10.6144 2.94995 10.04 2.94995C9.46562 2.94995 9 3.41557 9 3.98995C9 4.56433 9.46562 5.02995 10.04 5.02995Z', 'M8.2198 7.05005H3.7698C3.37216 7.05005 3.0498 7.3724 3.0498 7.77005V11.31C3.0498 11.7077 3.37216 12.03 3.7698 12.03H8.2198C8.61745 12.03 8.9398 11.7077 8.9398 11.31V7.77005C8.9398 7.3724 8.61745 7.05005 8.2198 7.05005Z']
  },
  LASTNEWS: {
    path: ['M9.13071 3.57561C8.88905 3.079 8.29057 2.87232 7.79396 3.11398C7.29735 3.35564 7.09067 3.95412 7.33233 4.45073L8.63619 7.13015H6.14699C4.38307 7.13015 3 8.39295 3 9.99651V16.7916C3 18.2205 4.17939 19.3635 5.72831 19.4866V20.0487C5.72831 20.601 6.17602 21.0487 6.72831 21.0487C7.28059 21.0487 7.72831 20.601 7.72831 20.0487V19.4976H16.2517V20.0487C16.2517 20.601 16.6994 21.0487 17.2517 21.0487C17.804 21.0487 18.2517 20.601 18.2517 20.0487V19.4875C19.8046 19.3694 20.9805 18.233 20.99 16.7916L21 9.88627C21 9.05442 20.6091 8.27268 19.9176 7.75153C19.3664 7.35064 18.6849 7.13015 17.9833 7.13015H15.3436L16.6474 4.45073C16.8891 3.95412 16.6824 3.35564 16.1858 3.11398C15.6892 2.87232 15.0907 3.079 14.849 3.57561L13.1193 7.13015H10.8604L9.13071 3.57561ZM18.9855 9.89629C18.9855 9.47536 18.5345 9.1346 17.9833 9.1346H6.14699C5.51559 9.1346 5.00445 9.52547 5.00445 9.99651V16.7916C5.00445 17.1825 5.45546 17.4932 6.00668 17.4932L17.9733 17.5032C18.5245 17.5032 18.9755 17.1925 18.9755 16.8016L18.9855 9.89629ZM18 11C18 11.5523 17.5523 12 17 12C16.4477 12 16 11.5523 16 11C16 10.4477 16.4477 10 17 10C17.5523 10 18 10.4477 18 11ZM17 15C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13C16.4477 13 16 13.4477 16 14C16 14.5523 16.4477 15 17 15Z']
  },
  TESTS: {
    path: ['M10.9996 11.999C11.2648 11.999 11.5191 11.8937 11.7067 11.7061C11.8942 11.5186 11.9996 11.2642 11.9996 10.999C11.9996 10.7338 11.8942 10.4795 11.7067 10.2919C11.5191 10.1044 11.2648 9.99902 10.9996 9.99902H5.61958L7.61958 5.99902H16.3796L17.1096 7.44904C17.2398 7.66538 17.447 7.82445 17.6896 7.89435C17.9322 7.96425 18.1923 7.9398 18.4177 7.82587C18.643 7.71194 18.8169 7.51699 18.9044 7.28015C18.992 7.04332 18.9867 6.7821 18.8896 6.54901L17.8896 4.54901C17.8065 4.3841 17.6793 4.24546 17.5222 4.14838C17.3651 4.0513 17.1843 3.99958 16.9996 3.99902H6.99959C6.81492 3.99958 6.63403 4.0513 6.47694 4.14838C6.31985 4.24546 6.19267 4.3841 6.10957 4.54901L3.10957 10.549C3.10829 10.5723 3.10829 10.5957 3.10957 10.619C3.07046 10.7142 3.05009 10.8161 3.04957 10.919V16.919C3.04021 16.9786 3.04021 17.0394 3.04957 17.099C3.03426 17.2051 3.03426 17.3129 3.04957 17.419V18.419C3.04957 18.8168 3.2076 19.1984 3.4889 19.4797C3.77021 19.761 4.15175 19.919 4.54957 19.919H5.54957C5.92522 19.907 6.2827 19.7544 6.55122 19.4915C6.81974 19.2285 6.97973 18.8743 6.99959 18.499V17.999H10.9996C11.2648 17.999 11.5191 17.8937 11.7067 17.7061C11.8942 17.5186 11.9996 17.2642 11.9996 16.999C11.9996 16.7338 11.8942 16.4795 11.7067 16.2919C11.5191 16.1044 11.2648 15.999 10.9996 15.999H4.99959V14.999H6.99959C7.2648 14.999 7.51914 14.8937 7.70668 14.7061C7.89421 14.5186 7.99959 14.2642 7.99959 13.999C7.99959 13.7338 7.89421 13.4795 7.70668 13.2919C7.51914 13.1044 7.2648 12.999 6.99959 12.999H4.99959V11.999H10.9996Z', 'M20.9999 12.999C21.0036 12.3471 20.8478 11.7042 20.5461 11.1262C20.2445 10.5483 19.8063 10.0528 19.2694 9.68293C18.7326 9.31306 18.1134 9.07998 17.4659 9.00404C16.8185 8.92809 16.1622 9.01159 15.5544 9.2472C14.9465 9.48281 14.4054 9.86342 13.9783 10.3559C13.5511 10.8484 13.2508 11.4378 13.1035 12.0729C12.9561 12.7079 12.9663 13.3694 13.133 13.9996C13.2997 14.6299 13.6179 15.2099 14.0599 15.689C14.0247 15.7888 14.0045 15.8933 13.9999 15.999V19.999C14.0005 20.1695 14.0445 20.337 14.128 20.4856C14.2115 20.6342 14.3315 20.7591 14.4768 20.8483C14.6221 20.9374 14.7878 20.988 14.9581 20.9951C15.1284 21.0023 15.2977 20.9658 15.45 20.889L16.9999 20.119L18.5499 20.8991C18.702 20.9868 18.8744 21.033 19.0499 21.033C19.2255 21.033 19.3979 20.9868 19.5499 20.8991C19.694 20.809 19.8129 20.6836 19.8951 20.5349C19.9773 20.3862 20.0203 20.219 20.02 20.049V16.049C20.0154 15.9433 19.9952 15.8388 19.96 15.739C20.6408 14.9901 21.0124 14.011 20.9999 12.999ZM16.9999 10.999C17.3955 10.999 17.7822 11.1163 18.1111 11.3361C18.44 11.5558 18.6963 11.8682 18.8477 12.2336C18.9991 12.5991 19.0387 13.0013 18.9615 13.3892C18.8843 13.7772 18.6938 14.1335 18.4141 14.4132C18.1344 14.6929 17.7781 14.8834 17.3901 14.9606C17.0022 15.0377 16.6 14.9982 16.2346 14.8468C15.8691 14.6954 15.5567 14.4391 15.337 14.1102C15.1172 13.7813 14.9999 13.3946 14.9999 12.999C14.9999 12.4686 15.2107 11.9599 15.5858 11.5848C15.9608 11.2098 16.4695 10.999 16.9999 10.999ZM17.45 18.109C17.3104 18.0387 17.1562 18.0021 16.9999 18.0021C16.8436 18.0021 16.6895 18.0387 16.5499 18.109L15.9999 18.379V16.859C16.6535 17.0458 17.3464 17.0458 17.9999 16.859V18.379L17.45 18.109Z']
  },
  COMPARATIVES: {
    path: ['M13 19C11.897 19 11 18.103 11 17C11 15.897 11.897 15 13 15C14.103 15 15 15.897 15 17C15 18.103 14.103 19 13 19ZM21 16H16.858C16.411 14.28 14.858 13 13 13C11.142 13 9.589 14.28 9.142 16H4V14H6C6.552 14 7 13.552 7 13C7 12.448 6.552 12 6 12H4V10.856L6.311 10.495C8.217 10.197 10.022 9.242 11.587 7.678C12.678 6.611 14.241 6 15.876 6H21C21.552 6 22 5.552 22 5C22 4.448 21.552 4 21 4H15.876C13.691 4 11.672 4.798 10.189 6.247C10.187 6.25 10.121 6.315 10.118 6.318C8.91 7.526 7.487 8.287 6.002 8.519L2.846 9.012C2.359 9.088 2 9.507 2 10V17C2 17.552 2.448 18 3 18H9.142C9.589 19.72 11.142 21 13 21C14.858 21 16.411 19.72 16.858 18H21C21.552 18 22 17.552 22 17C22 16.448 21.552 16 21 16Z']
  },
  VIDEOS: {
    path: ['M19.6 1.4C19.3 1.2 19 1.2 18.7 1.3L14 2.9V3C14 1.4 12.6 0 11 0H2.8C1.3 0 0 1.3 0 2.9V9.2C0 10.7 1.3 12 2.8 12H11.1C12.7 12 14 10.7 14 9.1L18.7 10.7C18.8 10.7 18.9 10.8 19 10.8C19.2 10.8 19.4 10.7 19.6 10.6C19.9 10.4 20 10.1 20 9.8V2.3C20 1.9 19.9 1.6 19.6 1.4ZM12 9.1C12 9.6 11.6 10 11.1 10H2.8C2.4 10 2 9.6 2 9.1V2.9C2 2.4 2.4 2 2.8 2H11C11.6 2 12 2.4 12 3V9.1ZM18 8.4L14 7V5L18 3.7V8.4Z']
  },
  SECRETS: {
    path: ['M15.2895 18.28C15.1095 18.28 14.9195 18.23 14.7595 18.13L9.99953 15.18L5.23953 18.13C4.89953 18.34 4.44953 18.33 4.12953 18.09C3.79953 17.85 3.64953 17.44 3.74953 17.04L5.08953 11.6L0.799531 7.98C0.489531 7.72 0.359531 7.3 0.489531 6.91C0.619531 6.52 0.959531 6.25 1.36953 6.22L6.95953 5.81L9.07953 0.62C9.22953 0.25 9.58953 0 9.99953 0C10.4095 0 10.7695 0.25 10.9295 0.62L13.0495 5.81L18.6395 6.22C19.0495 6.25 19.3895 6.52 19.5195 6.91C19.6495 7.3 19.5195 7.72 19.2095 7.98L14.9295 11.6L16.2695 17.04C16.3695 17.43 16.2195 17.85 15.8895 18.09C15.6995 18.22 15.4995 18.28 15.2895 18.28ZM3.95953 8.04L6.83953 10.48C7.12953 10.73 7.25953 11.11 7.16953 11.48L6.26953 15.14L9.47953 13.15C9.79953 12.95 10.2095 12.95 10.5295 13.15L13.7395 15.14L12.8395 11.48C12.7495 11.11 12.8795 10.72 13.1695 10.48L16.0495 8.04L12.2895 7.76C11.9095 7.73 11.5795 7.49 11.4395 7.14L9.99953 3.65L8.56953 7.14C8.42953 7.49 8.09953 7.73 7.71953 7.76L3.95953 8.04Z']
  },
  TIPS: {
    path: ['M11.2929 4.29532C11.4804 4.48361 11.7348 4.5894 12 4.5894C12.2652 4.5894 12.5196 4.48361 12.7071 4.29532C12.8946 4.10703 13 3.85167 13 3.58539V3.00304C13 2.73676 12.8946 2.4814 12.7071 2.29311C12.5196 2.10482 12.2652 1.99902 12 1.99902C11.7348 1.99902 11.4804 2.10482 11.2929 2.29311C11.1054 2.4814 11 2.73676 11 3.00304V3.58539C11 3.85167 11.1054 4.10703 11.2929 4.29532ZM5.80487 7.26117C5.92675 7.31287 6.05763 7.33979 6.18994 7.34034C6.45228 7.33923 6.70369 7.23468 6.88995 7.0492C7.0762 6.86108 7.18073 6.6066 7.18073 6.34135C7.18073 6.0761 7.0762 5.82162 6.88995 5.6335L6.30994 5.04117C6.21697 4.94706 6.10636 4.87233 5.9845 4.82135C5.86264 4.77038 5.73193 4.74414 5.59991 4.74414C5.4679 4.74414 5.33719 4.77038 5.21533 4.82135C5.09347 4.87233 4.98292 4.94706 4.88995 5.04117C4.7037 5.22928 4.59912 5.48371 4.59912 5.74895C4.59912 6.0142 4.7037 6.26869 4.88995 6.4568L5.47992 7.03915C5.57253 7.13402 5.683 7.20946 5.80487 7.26117ZM13.7199 19.1275H10.3699C10.1656 19.1289 9.9629 19.0896 9.77369 19.012C9.58448 18.9344 9.41246 18.8199 9.26747 18.6753C9.12248 18.5307 9.00742 18.3587 8.92891 18.1692C8.85039 17.9797 8.80994 17.7765 8.80995 17.5713V16.236C8.08125 15.771 7.46109 15.1536 6.99183 14.4259C6.52257 13.6982 6.21526 12.8774 6.09089 12.0195C5.96653 11.1617 6.02801 10.287 6.27119 9.45519C6.51437 8.62339 6.93352 7.8541 7.49995 7.19983C8.06665 6.55518 8.76421 6.03982 9.54579 5.68835C10.3274 5.33689 11.1748 5.15749 12.0312 5.1622C12.8876 5.1669 13.7331 5.35559 14.5108 5.71562C15.2885 6.07565 15.9803 6.59869 16.54 7.24953C17.0996 7.90036 17.514 8.6639 17.7553 9.48889C17.9966 10.3139 18.0592 11.1812 17.9389 12.0325C17.8185 12.8838 17.5182 13.6994 17.0578 14.4244C16.5975 15.1494 15.9879 15.7671 15.27 16.236V17.5613C15.2726 17.7669 15.2344 17.9709 15.1576 18.1615C15.0808 18.352 14.9669 18.5253 14.8225 18.6712C14.6782 18.817 14.5063 18.9325 14.317 19.0109C14.1277 19.0892 13.9247 19.1289 13.7199 19.1275ZM10.8099 17.1195H13.27V14.991L13.8099 14.7099C14.3488 14.45 14.8229 14.0722 15.1972 13.6042C15.5714 13.1362 15.8365 12.5899 15.9728 12.0055C16.1091 11.4211 16.1132 10.8134 15.9848 10.2272C15.8564 9.64099 15.5988 9.09112 15.2309 8.61804C14.863 8.14496 14.3941 7.76067 13.8588 7.49349C13.3235 7.2263 12.7353 7.083 12.1376 7.07408C11.5398 7.06517 10.9477 7.1909 10.4047 7.44201C9.86169 7.69312 9.3817 8.06324 8.99995 8.52514C8.59283 8.98919 8.29798 9.54138 8.13832 10.1386C7.97866 10.7359 7.9585 11.3621 8.07948 11.9685C8.20046 12.5748 8.45929 13.145 8.83577 13.6344C9.21224 14.1239 9.69621 14.5194 10.25 14.7902L10.8099 15.0613V17.1195ZM14.9271 21.705C14.7396 21.8933 14.4852 21.999 14.22 21.999H9.78003C9.51481 21.999 9.26041 21.8933 9.07288 21.705C8.88534 21.5167 8.78003 21.2613 8.78003 20.995C8.78003 20.7287 8.88534 20.4733 9.07288 20.2851C9.26041 20.0968 9.51481 19.991 9.78003 19.991H14.22C14.4852 19.991 14.7396 20.0968 14.9271 20.2851C15.1147 20.4733 15.22 20.7287 15.22 20.995C15.22 21.2613 15.1147 21.5167 14.9271 21.705ZM17.8699 7.34035C17.6062 7.33657 17.3546 7.22832 17.1699 7.03915C16.9837 6.85104 16.8792 6.59655 16.8792 6.33131C16.8792 6.06606 16.9837 5.81157 17.1699 5.62346L17.7499 5.04117C17.9369 4.85211 18.1911 4.74533 18.4564 4.74439C18.7218 4.74345 18.9766 4.84842 19.1649 5.03615C19.3532 5.22388 19.4596 5.47897 19.4605 5.7454C19.4614 6.01183 19.3569 6.26775 19.1699 6.45681L18.58 7.03915C18.4873 7.13402 18.3769 7.20947 18.255 7.26117C18.1331 7.31288 18.0022 7.33979 17.8699 7.34035ZM4.59003 13.0432H4C3.73478 13.0432 3.48044 12.9374 3.29291 12.7491C3.10537 12.5608 3 12.3055 3 12.0392C3 11.7729 3.10537 11.5175 3.29291 11.3292C3.48044 11.141 3.73478 11.0352 4 11.0352H4.59003C4.85524 11.0352 5.10958 11.141 5.29712 11.3292C5.48466 11.5175 5.59003 11.7729 5.59003 12.0392C5.59003 12.3055 5.48466 12.5608 5.29712 12.7491C5.10958 12.9374 4.85524 13.0432 4.59003 13.0432ZM19.4199 13.0432H19.9999C20.2652 13.0432 20.5195 12.9374 20.707 12.7491C20.8946 12.5608 20.9999 12.3055 20.9999 12.0392C20.9999 11.7729 20.8946 11.5175 20.707 11.3292C20.5195 11.141 20.2652 11.0352 19.9999 11.0352H19.4199C19.1547 11.0352 18.9004 11.141 18.7128 11.3292C18.5253 11.5175 18.4199 11.7729 18.4199 12.0392C18.4199 12.3055 18.5253 12.5608 18.7128 12.7491C18.9004 12.9374 19.1547 13.0432 19.4199 13.0432Z']
  },
  SUBSCRIPTION: {
    path: ['M7.37725 7.29767C7.623 7.29767 7.85868 7.20155 8.03245 7.03047C8.20622 6.8594 8.30386 6.62739 8.30386 6.38546C8.30386 6.14353 8.20622 5.91151 8.03245 5.74044C7.85868 5.56937 7.623 5.47325 7.37725 5.47325H2.39205L4.24528 1.82442H12.3624L13.0389 3.14713C13.1595 3.34449 13.3515 3.48959 13.5763 3.55335C13.8011 3.61711 14.0422 3.59481 14.251 3.49088C14.4598 3.38695 14.6209 3.20912 14.702 2.99307C14.7831 2.77703 14.7782 2.53875 14.6883 2.32612L13.7616 0.501703C13.6846 0.351267 13.5668 0.224798 13.4212 0.136241C13.2757 0.0476844 13.1081 0.000510568 12.9369 0H3.67079C3.49967 0.000510568 3.33206 0.0476844 3.1865 0.136241C3.04093 0.224798 2.92309 0.351267 2.84609 0.501703L0.0662391 5.97495C0.0650558 5.99622 0.0650558 6.01755 0.0662391 6.03881C0.0299963 6.12566 0.0111211 6.21857 0.0106445 6.31247V11.7857C0.0019648 11.8401 0.0019648 11.8955 0.0106445 11.9499C-0.00354816 12.0467 -0.00354816 12.145 0.0106445 12.2418V13.154C0.0106445 13.5169 0.157074 13.865 0.417735 14.1216C0.678396 14.3782 1.03194 14.5223 1.40057 14.5223H2.32718C2.67526 14.5114 3.00651 14.3722 3.25532 14.1323C3.50414 13.8924 3.65239 13.5694 3.67079 13.227V12.7709H7.37725C7.623 12.7709 7.85868 12.6748 8.03245 12.5037C8.20622 12.3327 8.30386 12.1006 8.30386 11.8587C8.30386 11.6168 8.20622 11.3848 8.03245 11.2137C7.85868 11.0426 7.623 10.9465 7.37725 10.9465H1.81756V10.0343H3.67079C3.91654 10.0343 4.15221 9.93817 4.32599 9.7671C4.49976 9.59603 4.5974 9.36402 4.5974 9.12208C4.5974 8.88015 4.49976 8.64814 4.32599 8.47707C4.15221 8.306 3.91654 8.20988 3.67079 8.20988H1.81756V7.29767H7.37725Z', 'M16.3104 9.12485C16.0629 9.20875 15.8262 9.19734 15.5994 9.08848C15.3727 8.97961 15.2178 8.80298 15.1326 8.55932C15.0474 8.31566 15.059 8.0826 15.1696 7.8594C15.2801 7.6362 15.4596 7.48373 15.7071 7.39983C15.9546 7.31593 16.1913 7.32733 16.418 7.4362C16.6448 7.54506 16.7996 7.72169 16.8849 7.96535C16.9701 8.20901 16.9585 8.44207 16.8479 8.66527C16.7373 8.88848 16.5579 9.04095 16.3104 9.12485ZM16.9284 15.2346L19.8581 9.32119C19.9342 9.16755 19.9816 8.99473 19.9958 8.80419C20.01 8.61366 19.9884 8.43285 19.9281 8.26034L18.7591 4.91812C18.6331 4.55802 18.3997 4.29705 18.0552 4.13163C17.7107 3.96622 17.3582 3.94584 16.9924 4.06983L13.5974 5.22065C13.4221 5.28005 13.2641 5.37462 13.1203 5.50295C12.9766 5.63127 12.8674 5.77441 12.7913 5.92804L9.86154 11.8415C9.69926 12.169 9.68151 12.5175 9.80972 12.8841C9.93793 13.2507 10.1699 13.5145 10.5026 13.6743L15.0666 15.8657C15.3993 16.0255 15.7534 16.0429 16.1257 15.9167C16.4981 15.7905 16.7661 15.5622 16.9284 15.2346ZM15.4586 14.0445L11.7191 12.2489L14.3759 6.88628L17.1577 5.94335L18.1155 8.68181L15.4586 14.0445Z']
  },
  WEBMOTORS_SERVICES: {
    path: ['M8.9423 14.75C7.34508 14.75 5.98745 14.191 4.8694 13.0729C3.75135 11.9549 3.19232 10.5972 3.19232 9.00001C3.19232 8.72224 3.21251 8.44446 3.2529 8.16668C3.29328 7.88891 3.36091 7.62246 3.45577 7.36733C3.51987 7.2135 3.60641 7.09971 3.7154 7.02598C3.82436 6.95226 3.94744 6.89874 4.08462 6.86541C4.22179 6.83207 4.35992 6.83464 4.49902 6.87311C4.63812 6.91157 4.76473 6.98786 4.87885 7.10196L7.5423 9.74618L9.68847 7.60001L7.05387 4.95578C6.93977 4.84168 6.86349 4.71286 6.82502 4.56933C6.78656 4.42581 6.78399 4.28607 6.81732 4.15011C6.85066 4.01414 6.90579 3.89167 6.98272 3.78271C7.05964 3.67374 7.17181 3.58721 7.31925 3.52311C7.57438 3.42182 7.83976 3.35099 8.1154 3.31061C8.39103 3.27022 8.66666 3.25003 8.9423 3.25003C10.5395 3.25003 11.8971 3.80906 13.0152 4.92711C14.1332 6.04516 14.6923 7.40279 14.6923 9.00001C14.6923 9.42181 14.6525 9.81476 14.573 10.1789C14.4936 10.543 14.3743 10.8949 14.2153 11.2346L19.65 16.6385C20.0692 17.056 20.2788 17.5671 20.2788 18.1718C20.2788 18.7765 20.0699 19.2885 19.652 19.7077C19.2342 20.1269 18.7226 20.3365 18.1174 20.3365C17.5122 20.3365 17 20.1218 16.5808 19.6923L11.1769 14.2731C10.8244 14.4256 10.4659 14.5433 10.1017 14.626C9.73745 14.7086 9.35098 14.75 8.9423 14.75ZM8.9423 13.25C9.37991 13.25 9.81752 13.185 10.2551 13.0548C10.6927 12.9247 11.0929 12.7212 11.4558 12.4443L17.6654 18.6539C17.7872 18.7757 17.9398 18.834 18.1231 18.8289C18.3064 18.8238 18.459 18.7603 18.5808 18.6385C18.7026 18.5167 18.7635 18.3641 18.7635 18.1808C18.7635 17.9975 18.7026 17.8449 18.5808 17.7231L12.3712 11.5289C12.6519 11.1827 12.859 10.7888 12.9923 10.3471C13.1257 9.90546 13.1923 9.45642 13.1923 9.00001C13.1923 7.89102 12.7962 6.90961 12.0038 6.05576C11.2115 5.20191 10.2089 4.78332 8.9961 4.79998L11.1634 6.96733C11.3442 7.1481 11.4346 7.35899 11.4346 7.60001C11.4346 7.84102 11.3442 8.05191 11.1634 8.23268L8.175 11.2211C7.99423 11.4019 7.78333 11.4923 7.5423 11.4923C7.30128 11.4923 7.09039 11.4019 6.90962 11.2211L4.74227 9.05381C4.74484 10.3372 5.17625 11.3574 6.03652 12.1144C6.89677 12.8715 7.86536 13.25 8.9423 13.25Z']
  },
  FIPE: {
    path: ['M20.9233 3.61824C20.8213 3.37324 20.6273 3.17924 20.3822 3.07724C20.2603 3.02624 20.1302 3.00024 20.0002 3.00024H17.0002C16.4473 3.00024 16.0002 3.44824 16.0002 4.00024C16.0002 4.55224 16.4473 5.00024 17.0002 5.00024H17.5863L12.5002 10.0862L9.20725 6.79324C8.81725 6.40224 8.18425 6.40224 7.79325 6.79324L3.29325 11.2932C2.90225 11.6832 2.90225 12.3162 3.29325 12.7072C3.48825 12.9022 3.74425 13.0002 4.00025 13.0002C4.25625 13.0002 4.51225 12.9022 4.70725 12.7072L8.50025 8.91424L11.7933 12.2072C12.1842 12.5972 12.8172 12.5972 13.2072 12.2072L19.0002 6.41424V7.00024C19.0002 7.55224 19.4473 8.00024 20.0002 8.00024C20.5532 8.00024 21.0002 7.55224 21.0002 7.00024V4.00024C21.0002 3.87024 20.9743 3.74024 20.9233 3.61824ZM4.00035 15C3.44735 15 3.00035 15.448 3.00035 16V20C3.00035 20.552 3.44735 21 4.00035 21C4.55335 21 5.00035 20.552 5.00035 20V16C5.00035 15.448 4.55335 15 4.00035 15ZM8.00035 12C7.44735 12 7.00035 12.448 7.00035 13V20C7.00035 20.552 7.44735 21 8.00035 21C8.55335 21 9.00035 20.552 9.00035 20V13C9.00035 12.448 8.55335 12 8.00035 12ZM16.0003 12C15.4474 12 15.0003 12.448 15.0003 13V20C15.0003 20.552 15.4474 21 16.0003 21C16.5534 21 17.0003 20.552 17.0003 20V13C17.0003 12.448 16.5534 12 16.0003 12ZM20.0004 10C19.4474 10 19.0004 10.448 19.0004 11V20C19.0004 20.552 19.4474 21 20.0004 21C20.5534 21 21.0004 20.552 21.0004 20V11C21.0004 10.448 20.5534 10 20.0004 10ZM12.0003 15C11.4474 15 11.0003 15.448 11.0003 16V20C11.0003 20.552 11.4474 21 12.0003 21C12.5534 21 13.0003 20.552 13.0003 20V16C13.0003 15.448 12.5534 15 12.0003 15Z']
  },
  AUTOPAGO: {
    path: ['M18.8672 8.65151C18.9022 11.3985 18.2882 17.9355 11.9342 19.9285C5.58024 17.9355 4.96624 11.3985 5.00124 8.63851V8.17551C6.53224 7.79651 9.82524 6.76651 11.9342 4.55951C14.0432 6.76651 17.3372 7.79651 18.8672 8.17551V8.65151ZM20.0412 6.38751C19.9882 6.37851 14.7722 5.42651 12.7662 2.41751C12.3952 1.86051 11.4732 1.86051 11.1022 2.41751C9.10324 5.41551 3.87924 6.37851 3.82624 6.38751C3.34924 6.47251 3.00124 6.88751 3.00124 7.37251V8.62651C2.96924 11.1585 3.49924 19.6025 11.6592 21.9335C11.7492 21.9595 11.8422 21.9725 11.9342 21.9725C12.0262 21.9725 12.1192 21.9595 12.2092 21.9335C20.3692 19.6025 20.8992 11.1585 20.8672 8.63851V7.37251C20.8672 6.88651 20.5192 6.47151 20.0412 6.38751ZM11.9048 6.67101L11.4878 6.69401L11.2398 6.94601C10.9608 7.23001 10.9678 7.57601 10.9698 7.74101V8.20701C9.78584 8.56801 8.98884 9.55701 8.97784 10.689C8.97784 11.424 9.31784 12.084 9.93384 12.546C10.3698 12.874 10.9458 13.118 11.6498 13.275L11.8338 13.311C12.3548 13.427 12.7298 13.571 12.9478 13.739C13.1698 13.91 13.1878 14.033 13.1878 14.145C13.1878 14.377 13.0298 14.557 12.8968 14.667C12.6668 14.858 12.3448 14.971 12.0158 14.976L11.8838 14.979C11.1778 14.927 10.5388 14.389 10.3578 14.225C10.1828 14.068 9.96084 13.986 9.70284 13.986C9.68984 13.986 9.67584 13.986 9.66184 13.986L9.19084 14.049L8.95984 14.374C8.67084 14.775 8.72884 15.343 9.09184 15.666C9.41784 15.965 10.0878 16.497 10.9698 16.761V17.23C10.9678 17.362 10.9598 17.712 11.2458 18.002L11.5568 18.274H11.9108C11.9498 18.274 12.8668 18.261 12.8668 17.201V16.795C14.1908 16.448 15.0818 15.393 15.0918 14.145C15.0918 13.373 14.7368 12.681 14.0928 12.195L14.0808 12.187C13.6098 11.846 13.0088 11.602 12.1878 11.417L12.0168 11.383C11.5898 11.282 11.2748 11.154 11.0808 11.004C10.8828 10.851 10.8828 10.765 10.8828 10.689C10.8828 10.485 11.0458 10.328 11.1158 10.27C11.3008 10.118 11.5728 10.014 11.8208 9.99801L11.9818 9.99701C12.4168 10.014 12.7828 10.261 13.2948 10.637C13.5168 10.788 13.7948 10.835 14.0638 10.768L14.4528 10.636L14.6318 10.341C14.8928 9.90501 14.7818 9.33001 14.3868 9.06201C14.0428 8.80201 13.5278 8.41501 12.8668 8.20801V7.74101C12.8668 6.68801 11.9588 6.67101 11.9058 6.67101H11.9048Z']
  },
  CATALOG_0KM: {
    path: ['M19.957 13.1514C19.957 12.8623 19.9082 12.6672 19.777 12.459L17.147 8.45905C17.0564 8.32148 16.9333 8.20839 16.7885 8.12988C16.6437 8.05138 16.4818 8.00989 16.3171 8.00903H7.55707C7.39236 8.00989 7.23043 8.05138 7.08563 8.12988C6.94084 8.20839 6.81764 8.32148 6.72705 8.45905L4.09705 12.459C3.96087 12.6726 3.95693 12.9209 3.95703 13.179C3.95711 13.2178 3.95699 13.3115 3.95703 13.389V20.009V20.809C3.95703 21.1273 4.08349 21.4325 4.30853 21.6575C4.53358 21.8826 4.83879 22.009 5.15705 22.009H6.75708C7.07534 22.009 7.38055 21.8826 7.60559 21.6575C7.83064 21.4325 7.95703 21.1273 7.95703 20.809V20.009H15.957V20.809C15.957 21.1273 16.0835 21.4325 16.3085 21.6575C16.5336 21.8826 16.8388 22.009 17.157 22.009H18.7571C19.0753 22.009 19.3806 21.8826 19.6056 21.6575C19.8306 21.4325 19.957 21.1273 19.957 20.809V13.259C19.957 13.259 19.957 13.1914 19.957 13.1514ZM6.71704 18.009H5.91706V16.889H7.39704C7.66225 16.889 7.91665 16.7837 8.10419 16.5961C8.29173 16.4086 8.39704 16.1543 8.39704 15.889C8.39704 15.6238 8.29173 15.3695 8.10419 15.1819C7.91665 14.9944 7.66225 14.889 7.39704 14.889H5.91706V14.009H17.9171V14.9091H17.847H16.1071C15.8418 14.9091 15.5875 15.0144 15.4 15.2019C15.2124 15.3894 15.1071 15.6438 15.1071 15.9091C15.1071 16.1743 15.2124 16.4286 15.4 16.6161C15.5875 16.8037 15.8418 16.9091 16.1071 16.9091H17.9171V18.009H6.71704ZM8.08704 10.009H15.7471L17.0671 12.009H6.76703L8.08704 10.009Z', 'M6.2099 6.71599C6.39744 6.90353 6.65178 7.0089 6.91699 7.0089H16.917C17.1822 7.0089 17.4365 6.90353 17.6241 6.71599C17.8116 6.52845 17.917 6.27412 17.917 6.0089C17.917 5.74368 17.8116 5.48934 17.6241 5.30181C17.4365 5.11427 17.1822 5.0089 16.917 5.0089H16.597C16.6308 4.85398 16.6542 4.69699 16.667 4.53893C16.6826 4.21437 16.6302 3.89006 16.5131 3.58696C16.396 3.28386 16.2168 3.00865 15.987 2.77892C15.5332 2.31234 14.9188 2.03606 14.2687 2.00634C13.6185 1.97661 12.9814 2.19565 12.487 2.61888C12.309 2.76194 12.1568 2.93445 12.037 3.12889L11.917 3.30889C11.7673 3.04834 11.5746 2.81504 11.347 2.61888C10.8526 2.19565 10.2155 1.97661 9.56531 2.00634C8.91515 2.03606 8.30074 2.31234 7.84698 2.77892C7.61718 3.00865 7.43797 3.28386 7.32086 3.58696C7.20375 3.89006 7.15135 4.21437 7.16699 4.53893C7.17977 4.69699 7.20317 4.85398 7.237 5.0089H6.91699C6.65178 5.0089 6.39744 5.11427 6.2099 5.30181C6.02236 5.48934 5.91699 5.74368 5.91699 6.0089C5.91699 6.27412 6.02236 6.52845 6.2099 6.71599ZM14.147 4.0089C14.012 4.00622 13.8806 4.05239 13.777 4.1389C13.5569 4.37847 13.4232 4.68466 13.397 5.0089C13.7941 5.02668 14.1875 4.92574 14.527 4.71892C14.5694 4.68532 14.6039 4.64279 14.6281 4.59441C14.6522 4.54603 14.6655 4.49296 14.667 4.43889C14.6679 4.38878 14.6586 4.339 14.6397 4.29259C14.6208 4.24618 14.5927 4.20408 14.557 4.16887C14.5027 4.11636 14.4384 4.07518 14.368 4.04772C14.2977 4.02025 14.2225 4.00706 14.147 4.0089ZM9.46594 4.01775C9.39556 4.04522 9.3313 4.08639 9.27698 4.1389C9.21205 4.20266 9.1729 4.31812 9.16699 4.40892C9.16844 4.46299 9.18174 4.51606 9.20593 4.56444C9.23012 4.61282 9.26462 4.65529 9.30701 4.68889C9.645 4.8992 10.0395 5.00043 10.437 4.97887C10.4108 4.65463 10.2771 4.34844 10.057 4.10887C9.95337 4.02236 9.82198 3.97619 9.68701 3.97887C9.61148 3.97703 9.53633 3.99028 9.46594 4.01775Z']
  },
  INSURANCE: {
    path: ['M8 8C8.552 8 9 7.552 9 7C9 6.448 8.552 6 8 6H2.618L4.618 2H13.382L14.105 3.447C14.353 3.941 14.953 4.142 15.447 3.895C15.941 3.647 16.142 3.047 15.895 2.553L14.895 0.553C14.725 0.214 14.379 0 14 0H4C3.621 0 3.275 0.214 3.105 0.553L0.105 6.553C0.1 6.565 0.098 6.578 0.092 6.59C0.083 6.612 0.078 6.634 0.069 6.656C0.033 6.755 0.012 6.857 0.008 6.961C0.007 6.975 0 6.986 0 7V13C0 13.064 0.025 13.12 0.036 13.18C0.014 13.284 0 13.39 0 13.5V14.5C0 15.325 0.675 16 1.5 16H2.5C3.325 16 4 15.325 4 14.5V14H8C8.552 14 9 13.552 9 13C9 12.448 8.552 12 8 12H2.5H2V11H4C4.552 11 5 10.552 5 10C5 9.448 4.552 9 4 9H2V8H8ZM14.7582 13.9308C12.9292 13.3328 12.0202 10.5878 12.0002 9.05675C12.7442 8.81375 13.8632 8.34275 14.7582 7.52075C15.6532 8.34275 16.7722 8.81375 17.5162 9.05675C17.5012 10.5748 16.5922 13.3318 14.7582 13.9308M18.7093 7.31475C18.6873 7.31075 16.4393 6.83275 15.6173 5.45375C15.2563 4.84875 14.2603 4.84875 13.8993 5.45375C13.2123 6.60575 11.4323 7.18775 10.8073 7.31475C10.3383 7.40775 10.0003 7.81875 10.0003 8.29575V8.95575C9.98026 10.8218 11.0943 15.1717 14.5403 15.9427C14.6123 15.9587 14.6853 15.9668 14.7583 15.9668C14.8313 15.9668 14.9043 15.9587 14.9763 15.9427C18.4233 15.1717 19.5373 10.8217 19.5163 8.96675V8.29575C19.5163 7.81875 19.1783 7.40775 18.7093 7.31475']
  },
  AUTOMOTIVE_SERVICES: {
    path: ['M20 18H4V12H20V14H17C16.448 14 16 14.448 16 15C16 15.552 16.448 16 17 16H20V18ZM8.404 7.685C9.672 6.599 11.29 6 12.959 6H19C19.551 6 20 6.449 20 7V10H5.703L8.404 7.685ZM19 4H12.959C10.812 4 8.732 4.77 7.102 6.167L3.047 9.642C2.382 10.212 2 11.042 2 11.92V19C2 19.552 2.448 20 3 20H21C21.552 20 22 19.552 22 19V7C22 5.346 20.654 4 19 4Z']
  },
  DEALER_PLATFORM: {
    path: ['M12 16C12.256 16 12.512 15.902 12.707 15.707L16.707 11.707C17.098 11.316 17.098 10.684 16.707 10.293C16.316 9.902 15.684 9.902 15.293 10.293L11.293 14.293C10.902 14.684 10.902 15.316 11.293 15.707C11.488 15.902 11.744 16 12 16ZM12 7C16.411 7 20 10.589 20 15C20 15.68 19.915 16.35 19.747 17H4.253C4.085 16.351 4 15.68 4 15C4 10.589 7.589 7 12 7ZM21.431 18.333C21.809 17.264 22 16.143 22 15C22 9.486 17.514 5 12 5C6.486 5 2 9.486 2 15C2 16.144 2.192 17.266 2.57 18.334C2.575 18.35 2.586 18.361 2.593 18.376C2.6 18.393 2.61 18.406 2.618 18.423C2.663 18.519 2.72 18.604 2.79 18.677C2.808 18.697 2.828 18.714 2.848 18.733C2.919 18.798 2.997 18.85 3.083 18.892C3.107 18.904 3.13 18.917 3.155 18.927C3.269 18.971 3.388 19.001 3.513 19.001C3.516 19.001 3.519 19 3.521 19H20.488C20.497 19 20.505 18.995 20.514 18.995C20.596 18.993 20.671 18.969 20.749 18.947C20.798 18.934 20.849 18.93 20.895 18.909C20.957 18.881 21.008 18.836 21.064 18.795C21.112 18.76 21.166 18.732 21.207 18.689C21.247 18.647 21.271 18.593 21.305 18.544C21.345 18.484 21.389 18.428 21.415 18.359C21.419 18.35 21.427 18.343 21.431 18.333Z']
  },
  HELP_YOU: {
    path: ['M5.0996 5C5.0996 3.346 6.4456 2 8.0996 2C9.7536 2 11.0996 3.346 11.0996 5C11.0996 6.654 9.7536 8 8.0996 8C6.4456 8 5.0996 6.654 5.0996 5ZM15.8036 12.905C14.9056 10.982 13.3236 9.509 11.4336 8.699C12.4486 7.783 13.0996 6.471 13.0996 5C13.0996 2.243 10.8566 0 8.0996 0C5.3426 0 3.0996 2.243 3.0996 5C3.0996 6.471 3.7506 7.783 4.7656 8.699C2.8746 9.51 1.2916 10.984 0.393598 12.909C0.160598 13.409 0.376598 14.004 0.876598 14.238C1.0136 14.302 1.1576 14.332 1.2996 14.332C1.6756 14.332 2.0366 14.118 2.2056 13.754C3.2706 11.474 5.5836 10 8.0996 10C10.6146 10 12.9276 11.473 13.9926 13.752C14.2266 14.253 14.8246 14.468 15.3216 14.234C15.8216 14.001 16.0376 13.406 15.8036 12.905Z']
  },
  HELP_STORE: {
    path: ['M7.99995 6C8.95595 6 9.73695 6.729 9.83695 7.66C9.01095 8.127 8.34495 8.838 7.95695 9.71C6.95295 9.687 6.14295 8.867 6.14295 7.857C6.14295 6.833 6.97595 6 7.99995 6ZM14.429 11.5C14.429 12.839 13.339 13.929 12 13.929C10.661 13.929 9.57095 12.839 9.57095 11.5C9.57095 10.161 10.661 9.071 12 9.071C13.339 9.071 14.429 10.161 14.429 11.5ZM16 6C17.024 6 17.857 6.833 17.857 7.857C17.857 8.867 17.047 9.687 16.043 9.71C15.655 8.838 14.989 8.127 14.163 7.66C14.263 6.729 15.044 6 16 6ZM21.923 13.898C21.282 12.361 20.174 11.161 18.839 10.446C19.465 9.76 19.857 8.856 19.857 7.857C19.857 5.73 18.127 4 16 4C14.135 4 12.576 5.331 12.22 7.094C12.146 7.09 12.075 7.071 12 7.071C11.925 7.071 11.854 7.09 11.78 7.094C11.424 5.331 9.86495 4 7.99995 4C5.87295 4 4.14295 5.73 4.14295 7.857C4.14295 8.856 4.53495 9.76 5.16095 10.446C3.82595 11.162 2.71795 12.362 2.07695 13.901C1.86495 14.411 2.10595 14.997 2.61595 15.209C2.74095 15.261 2.87195 15.286 2.99995 15.286C3.39095 15.286 3.76295 15.054 3.92295 14.67C4.61195 13.016 6.02595 11.914 7.59695 11.748C7.66095 12.887 8.14295 13.913 8.90895 14.663C7.24695 15.481 5.86295 16.941 5.07695 18.83C4.86495 19.34 5.10595 19.925 5.61595 20.138C5.74095 20.19 5.87195 20.215 5.99995 20.215C6.39195 20.215 6.76295 19.983 6.92295 19.599C7.85095 17.369 9.84395 15.929 12 15.929C14.156 15.929 16.149 17.368 17.077 19.596C17.29 20.105 17.874 20.349 18.385 20.134C18.895 19.921 19.136 19.336 18.923 18.826C18.136 16.938 16.753 15.48 15.091 14.662C15.857 13.913 16.339 12.886 16.403 11.748C17.974 11.913 19.388 13.015 20.077 14.668C20.237 15.052 20.609 15.284 21 15.284C21.129 15.284 21.259 15.259 21.385 15.206C21.895 14.994 22.136 14.408 21.923 13.898Z']
  },
  HELP_SECURITY: {
    path: ['M2.00062 6.17575V6.63875C1.96262 9.61575 4.02062 15.8158 8.93362 16.9487C13.8466 15.8158 15.9046 9.61575 15.8666 6.65175V6.17575C14.3366 5.79575 11.0426 4.76575 8.93362 2.55975C6.82462 4.76575 3.53162 5.79575 2.00062 6.17575ZM8.93362 18.9718C8.86762 18.9718 8.80262 18.9657 8.73762 18.9527C2.46962 17.6987 -0.0453812 10.3057 0.000618819 6.62575V5.37175C0.000618819 4.88775 0.348619 4.47275 0.825619 4.38775C0.878619 4.37775 6.10362 3.41475 8.10162 0.41775C8.47262 -0.13925 9.39462 -0.13925 9.76562 0.41775C11.7716 3.42675 16.9876 4.37775 17.0406 4.38675C17.5186 4.47175 17.8666 4.88675 17.8666 5.37175V6.63875C17.9136 10.3057 15.3976 17.6987 9.12962 18.9527C9.06462 18.9657 8.99962 18.9718 8.93362 18.9718Z']
  },
  MESSAGES: {
    path: ['M6 5C5.449 5 5 5.449 5 6V14.586L6.293 13.293C6.48 13.105 6.735 13 7 13H15.002C15.554 13 16.002 12.551 16.002 12V6C16.002 5.449 15.554 5 15.002 5H6ZM4 18C3.871 18 3.741 17.975 3.617 17.924C3.244 17.769 3 17.404 3 17V6C3 4.346 4.346 3 6 3H15.002C16.657 3 18.002 4.346 18.002 6V12C18.002 13.654 16.657 15 15.002 15H7.414L4.707 17.707C4.516 17.898 4.26 18 4 18ZM20 21C19.74 21 19.484 20.898 19.293 20.707L16.586 18H9.002C8.45 18 8.002 17.552 8.002 17C8.002 16.448 8.45 16 9.002 16H17C17.265 16 17.519 16.105 17.707 16.293L19 17.586V10.002C19 9.45 19.448 9.002 20 9.002C20.552 9.002 21 9.45 21 10.002V20C21 20.404 20.756 20.769 20.383 20.924C20.259 20.975 20.129 21 20 21Z']
  },
  FAVORITES: {
    path: ['M8.028 6.00475C7.865 6.00475 7.705 6.01775 7.549 6.04175C6.317 6.23575 5 7.21575 5 9.38475C5 13.4097 10.272 17.1217 12 18.2297C13.728 17.1217 19 13.4097 19 9.38475C19 7.21575 17.682 6.23575 16.45 6.04175C15.174 5.84175 13.533 6.44475 12.951 8.24575C12.818 8.65875 12.434 8.93875 12 8.93875C11.566 8.93875 11.181 8.65875 11.048 8.24575C10.537 6.66375 9.209 6.00475 8.028 6.00475ZM12.194 20.2887H11.805C11.621 20.2887 11.44 20.2367 11.282 20.1407C9.339 18.9467 3 14.6447 3 9.38475C3 6.17175 5.129 4.39875 7.239 4.06675C9.109 3.77275 10.874 4.47975 12 5.86375C13.126 4.48075 14.889 3.76975 16.76 4.06675C18.871 4.39875 21 6.17175 21 9.38475C21 14.6447 14.66 18.9467 12.717 20.1407C12.56 20.2367 12.379 20.2887 12.194 20.2887Z']
  },
  FAVORITES_SOLID: {
    path: ['M11.9675 0.388356C10.41 0.143356 8.9375 0.733356 8 1.88669C7.0625 0.733356 5.59083 0.141689 4.0325 0.388356C2.27417 0.665023 0.5 2.14252 0.5 4.82086C0.5 9.20419 5.7825 12.7892 7.40167 13.7842C7.53333 13.8642 7.68417 13.9075 7.83833 13.9075H8.16167C8.31583 13.9075 8.46667 13.8642 8.59833 13.7842C10.2175 12.7892 15.5 9.20419 15.5 4.82086C15.5 2.14252 13.7258 0.665023 11.9675 0.388356Z']
  },
  USER: {
    path: ['M5.06494 16.284C6.29494 14.849 8.09594 14 9.99994 14C11.9119 14 13.7089 14.845 14.9379 16.282C13.5769 17.354 11.8639 18 9.99994 18C8.13794 18 6.42594 17.355 5.06494 16.284ZM7 9C7 7.346 8.346 6 10 6C11.654 6 13 7.346 13 9C13 10.655 11.654 12 10 12C8.346 12 7 10.655 7 9ZM10 2C14.411 2 18 5.589 18 10C18 11.825 17.379 13.503 16.348 14.85C15.51 13.909 14.477 13.185 13.336 12.697C14.35 11.782 15 10.471 15 9C15 6.243 12.757 4 10 4C7.243 4 5 6.243 5 9C5 10.472 5.651 11.784 6.666 12.699C5.525 13.187 4.492 13.914 3.655 14.853C2.621 13.505 2 11.826 2 10C2 5.589 5.589 2 10 2ZM10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0Z']
  },
  CLOSE: {
    path: ['M7.18209 5.00001L10.4181 1.70701C10.8023 1.31601 10.8023 0.684006 10.4181 0.293006C10.0338 -0.0979941 9.41278 -0.0979941 9.02855 0.293006L5.79257 3.58601L2.55659 0.293006C2.17236 -0.0979941 1.55131 -0.0979941 1.16708 0.293006C0.782849 0.684006 0.782849 1.31601 1.16708 1.70701L4.40306 5.00001L1.16708 8.29301C0.782849 8.68401 0.782849 9.31601 1.16708 9.70701C1.3587 9.90201 1.61027 10 1.86184 10C2.1134 10 2.36497 9.90201 2.55659 9.70701L5.79257 6.41401L9.02855 9.70701C9.22017 9.90201 9.47174 10 9.7233 10C9.97487 10 10.2264 9.90201 10.4181 9.70701C10.8023 9.31601 10.8023 8.68401 10.4181 8.29301L7.18209 5.00001Z']
  },
  SLIM_CLOSE: {
    path: ['M13.5808 11.95L20.2618 5.26901C20.7128 4.81807 20.7128 4.08919 20.2618 3.63825C19.8109 3.18731 19.082 3.18731 18.6311 3.63825L11.95 10.3193L5.26901 3.63825C4.81807 3.18731 4.08919 3.18731 3.63825 3.63825C3.18731 4.08919 3.18731 4.81807 3.63825 5.26901L10.3193 11.95L3.63825 18.6311C3.18731 19.082 3.18731 19.8109 3.63825 20.2618C3.86315 20.4867 4.15839 20.5998 4.45363 20.5998C4.74888 20.5998 5.04412 20.4867 5.26901 20.2618L11.95 13.5808L18.6311 20.2618C18.856 20.4867 19.1512 20.5998 19.4465 20.5998C19.7417 20.5998 20.037 20.4867 20.2618 20.2618C20.7128 19.8109 20.7128 19.082 20.2618 18.6311L13.5808 11.95Z']
  },
  CHECK: {
    path: ['M8.96674 18.0332C8.71074 18.0332 8.45474 17.9352 8.25974 17.7402L4.29274 13.7733C3.90274 13.3833 3.90274 12.7502 4.29274 12.3593C4.68374 11.9693 5.31674 11.9693 5.70674 12.3593L8.96674 15.6193L18.2927 6.29325C18.6837 5.90225 19.3167 5.90225 19.7067 6.29325C20.0977 6.68325 20.0977 7.31625 19.7067 7.70725L9.67374 17.7402C9.47874 17.9352 9.22274 18.0332 8.96674 18.0332Z']
  },
  MANAGE_AD: {
    path: ['M16 15.9995H15V8.9995C15 8.4475 14.552 7.9995 14 7.9995H4C3.448 7.9995 3 8.4475 3 8.9995V15.9995H2V6.5535L9 2.1785L16 6.5535V15.9995ZM5 15.9995H13V13.9995H5V15.9995ZM5 11.9995H13V9.9995H5V11.9995ZM9.53 0.1515C9.206 -0.0505 8.794 -0.0505 8.47 0.1515L0.47 5.1515C0.178 5.3345 0 5.6545 0 5.9995V16.9995C0 17.5515 0.448 17.9995 1 17.9995H17C17.552 17.9995 18 17.5515 18 16.9995V5.9995C18 5.6545 17.822 5.3345 17.53 5.1515L9.53 0.1515Z']
  },
  EDIT: {
    path: ['M17.9996 8.671L15.4136 6.085L16.4996 4.999L19.0856 7.585L17.9996 8.671ZM8.50661 18.164L5.27461 18.81L5.92061 15.578L13.9996 7.499L16.5856 10.085L8.50661 18.164ZM20.4996 6.171L17.9136 3.585C17.1346 2.805 15.8646 2.805 15.0856 3.585L4.29261 14.378C4.15261 14.518 4.05761 14.695 4.01961 14.889L3.01961 19.889C2.95361 20.217 3.05661 20.556 3.29261 20.792C3.48161 20.982 3.73661 21.085 3.99961 21.085C4.06461 21.085 4.13061 21.079 4.19561 21.066L9.19561 20.066C9.38961 20.027 9.56661 19.932 9.70661 19.792L20.4996 8.999C21.2796 8.219 21.2796 6.951 20.4996 6.171Z']
  },
  PRODUCTS: {
    path: ['M18.2849 15.2626H8.32961C7.82682 15.2626 7.42458 14.9609 7.32402 14.4581L5.81564 8.12291L5.21229 6.01117H4.00559C3.40223 6.01117 3 5.60894 3 5.00559C3 4.40223 3.40223 4 4.00559 4H6.01676C6.51955 4 6.92179 4.30168 7.02235 4.80447L7.52514 6.9162L19.9944 7.01676C20.2961 7.01676 20.5978 7.11732 20.7989 7.41899C21 7.62011 21 8.02235 21 8.32402L19.2905 14.6592C19.0894 14.9609 18.6872 15.2626 18.2849 15.2626ZM9.13408 13.2514H17.4804L18.6872 8.92737L8.02793 8.82682L9.13408 13.2514Z', 'M9.23464 21.095C7.82682 21.095 6.62011 19.9888 6.62011 18.4804C6.62011 16.9721 7.72626 15.8659 9.23464 15.8659C10.743 15.8659 11.8492 16.9721 11.8492 18.4804C11.8492 19.9888 10.6425 21.095 9.23464 21.095ZM9.23464 17.9777C8.93296 17.9777 8.63129 18.1788 8.63129 18.581C8.63129 18.8827 8.8324 19.1844 9.23464 19.1844C9.53631 19.1844 9.83799 18.9832 9.83799 18.581C9.83799 18.1788 9.53631 17.9777 9.23464 17.9777Z', 'M16.9777 21.095C15.5698 21.095 14.3631 19.9888 14.3631 18.4804C14.3631 16.9721 15.4693 15.8659 16.9777 15.8659C18.486 15.8659 19.5922 16.9721 19.5922 18.4804C19.5922 19.9888 18.3855 21.095 16.9777 21.095ZM16.9777 17.9777C16.676 17.9777 16.3743 18.1788 16.3743 18.581C16.3743 18.8827 16.5754 19.1844 16.9777 19.1844C17.2793 19.1844 17.581 18.9832 17.581 18.581C17.4804 18.1788 17.2793 17.9777 16.9777 17.9777Z']
  },
  MENU: {
    path: ['M19 8H5C4.448 8 4 7.552 4 7C4 6.448 4.448 6 5 6H19C19.552 6 20 6.448 20 7C20 7.552 19.552 8 19 8ZM19 11H5C4.448 11 4 11.448 4 12C4 12.552 4.448 13 5 13H19C19.552 13 20 12.552 20 12C20 11.448 19.552 11 19 11ZM19 16H5C4.448 16 4 16.448 4 17C4 17.552 4.448 18 5 18H19C19.552 18 20 17.552 20 17C20 16.448 19.552 16 19 16Z']
  },
  FOWARD: {
    path: ['M20 15.94C19.45 15.94 19 16.39 19 16.94V18C19 18.55 18.55 19 18 19H6C5.45 19 5 18.55 5 18V6C5 5.45 5.45 5 6 5H18C18.55 5 19 5.45 19 6C19 6.55 19.45 7 20 7C20.55 7 21 6.55 21 6C21 4.35 19.65 3 18 3H6C4.35 3 3 4.35 3 6V18C3 19.65 4.35 21 6 21H18C19.65 21 21 19.65 21 18V16.94C21 16.39 20.55 15.94 20 15.94Z', 'M21.8998 11.4001C21.9998 11.1601 21.9998 10.8801 21.8998 10.6401C21.8498 10.5201 21.7798 10.4101 21.6798 10.3101L18.6598 7.29006C18.2698 6.90006 17.6398 6.90006 17.2498 7.29006C16.8598 7.68006 16.8598 8.31006 17.2498 8.70006L18.5598 10.0101H17.2198C12.2498 9.97006 10.7098 14.0001 10.2598 15.7401C10.1198 16.2701 10.4498 16.8201 10.9798 16.9601C11.0698 16.9901 11.1498 17.0001 11.2298 17.0001C11.6798 17.0001 12.0798 16.7001 12.1998 16.2501C12.6998 14.3001 13.9598 12.0201 17.2098 12.0201H18.5598L17.2498 13.3301C16.8598 13.7201 16.8598 14.3501 17.2498 14.7401C17.4498 14.9401 17.6998 15.0301 17.9598 15.0301C18.2198 15.0301 18.4698 14.9301 18.6698 14.7401L21.6898 11.7201C21.7698 11.6301 21.8498 11.5201 21.8998 11.4001Z']
  },
  ODOMETER: {
    path: ['M12 16C12.256 16 12.512 15.902 12.707 15.707L16.707 11.707C17.098 11.316 17.098 10.684 16.707 10.293C16.316 9.902 15.684 9.902 15.293 10.293L11.293 14.293C10.902 14.684 10.902 15.316 11.293 15.707C11.488 15.902 11.744 16 12 16ZM12 7C16.411 7 20 10.589 20 15C20 15.68 19.915 16.35 19.747 17H4.253C4.085 16.351 4 15.68 4 15C4 10.589 7.589 7 12 7ZM21.431 18.333C21.809 17.264 22 16.143 22 15C22 9.486 17.514 5 12 5C6.486 5 2 9.486 2 15C2 16.144 2.192 17.266 2.57 18.334C2.575 18.35 2.586 18.361 2.593 18.376C2.6 18.393 2.61 18.406 2.618 18.423C2.663 18.519 2.72 18.604 2.79 18.677C2.808 18.697 2.828 18.714 2.848 18.733C2.919 18.798 2.997 18.85 3.083 18.892C3.107 18.904 3.13 18.917 3.155 18.927C3.269 18.971 3.388 19.001 3.513 19.001C3.516 19.001 3.519 19 3.521 19H20.488C20.497 19 20.505 18.995 20.514 18.995C20.596 18.993 20.671 18.969 20.749 18.947C20.798 18.934 20.849 18.93 20.895 18.909C20.957 18.881 21.008 18.836 21.064 18.795C21.112 18.76 21.166 18.732 21.207 18.689C21.247 18.647 21.271 18.593 21.305 18.544C21.345 18.484 21.389 18.428 21.415 18.359C21.419 18.35 21.427 18.343 21.431 18.333Z']
  },
  GARAGE: {
    path: ['M19 18.9995H18V11.9995C18 11.4475 17.552 10.9995 17 10.9995H7C6.448 10.9995 6 11.4475 6 11.9995V18.9995H5V9.5535L12 5.1785L19 9.5535V18.9995ZM8 18.9995H16V16.9995H8V18.9995ZM8 14.9995H16V12.9995H8V14.9995ZM12.53 3.1515C12.206 2.9495 11.794 2.9495 11.47 3.1515L3.47 8.1515C3.178 8.3345 3 8.6545 3 8.9995V19.9995C3 20.5515 3.448 20.9995 4 20.9995H20C20.552 20.9995 21 20.5515 21 19.9995V8.9995C21 8.6545 20.822 8.3345 20.53 8.1515L12.53 3.1515Z']
  },
  BADGE_PRICE: {
    path: ['M0 0H14V17.7092C14 17.9776 13.8921 18.2348 13.7005 18.4228L7.70051 24.3124C7.31154 24.6942 6.68846 24.6942 6.29949 24.3124L0.299492 18.4228C0.107923 18.2348 0 17.9776 0 17.7092V0Z', 'M9.05584 12.7933C9.66416 13.2867 10 13.98 10 14.76C9.98733 16.0667 9.07485 17.1467 7.81386 17.4667V17.98C7.82019 18.9867 7.0091 19 6.97742 19H6.66692L6.38811 18.74C6.14098 18.4733 6.14732 18.1467 6.15365 18.0067V17.4333C5.25385 17.1667 4.56949 16.5667 4.278 16.28C3.96117 15.98 3.90414 15.44 4.16394 15.06L4.36672 14.7533L4.78494 14.6933C5.01306 14.6867 5.22217 14.76 5.38692 14.92C5.57068 15.1 6.21702 15.68 6.9394 15.74H7.0788C7.42732 15.7333 7.75683 15.6067 8.00395 15.3933C8.1497 15.2667 8.32712 15.0467 8.32712 14.76C8.32712 14.5933 8.28277 14.44 8.05465 14.2533C7.83287 14.0667 7.45267 13.9067 6.92039 13.78L6.73662 13.74C6.0586 13.58 5.51365 13.3267 5.09543 12.9933C4.51246 12.5267 4.19563 11.86 4.19563 11.12C4.2083 9.92667 5.00672 8.93333 6.15365 8.59333V8.02C6.15365 7.84667 6.14732 7.52667 6.38811 7.26L6.60355 7.02L6.97742 7C7.0091 7 7.82019 7.01333 7.82019 8.02V8.58667C8.4792 8.78667 8.98614 9.19333 9.34732 9.49333C9.6895 9.74 9.79723 10.28 9.56277 10.7L9.40435 10.98L9.05584 11.1067C8.82772 11.1667 8.58693 11.1267 8.39049 10.98C7.88356 10.58 7.50336 10.3067 7.05346 10.2867H6.8887C6.6289 10.3067 6.33742 10.42 6.13464 10.6C6.03959 10.6867 5.8685 10.8733 5.8685 11.12C5.8685 11.24 5.88751 11.36 6.10296 11.5333C6.30573 11.7 6.6289 11.84 7.05979 11.9533L7.23088 11.9933C8.0293 12.1867 8.5996 12.4333 9.0495 12.7867L9.05584 12.7933Z']
  },
  PIN: {
    path: ['M7.5 7.37475C7.15562 7.37475 6.875 7.09413 6.875 6.74975C6.875 6.40538 7.15562 6.12475 7.5 6.12475C7.84438 6.12475 8.125 6.40538 8.125 6.74975C8.125 7.09413 7.84438 7.37475 7.5 7.37475ZM7.5 4.87475C6.46625 4.87475 5.625 5.716 5.625 6.74975C5.625 7.7835 6.46625 8.62475 7.5 8.62475C8.53375 8.62475 9.375 7.7835 9.375 6.74975C9.375 5.716 8.53375 4.87475 7.5 4.87475ZM7.5 12.8331C6.49437 12.0138 3.75 9.52375 3.75 6.75C3.75 4.68187 5.43187 3 7.5 3C9.56812 3 11.25 4.68187 11.25 6.75C11.25 9.52375 8.50562 12.0138 7.5 12.8331ZM7.5 1.75C4.74313 1.75 2.5 3.9925 2.5 6.75C2.5 10.775 6.9475 13.9981 7.13688 14.1337C7.24563 14.2112 7.3725 14.25 7.5 14.25C7.6275 14.25 7.75437 14.2112 7.86313 14.1337C8.0525 13.9981 12.5 10.775 12.5 6.75C12.5 3.9925 10.2569 1.75 7.5 1.75Z']
  },
  BADGE_CHANGE: {
    path: ['M0 0H14V17.7092C14 17.9776 13.8921 18.2348 13.7005 18.4228L7.70051 24.3124C7.31154 24.6942 6.68846 24.6942 6.29949 24.3124L0.299492 18.4228C0.107923 18.2348 0 17.9776 0 17.7092V0Z', 'M4.75292 9.09316C4.87408 9.2117 4.87408 9.40246 4.75292 9.51964L2.55798 11.6425C1.50137 12.6644 2.13252 13.9547 2.91019 14.7068C3.12292 14.9126 3.36523 15.0693 3.60332 15.1892C3.9189 15.3472 4.21898 14.9507 3.9668 14.7068C3.6146 14.3662 3.6146 14.0256 4.31901 13.3443L6.51395 11.2214L8.91176 8.90241C9.0625 8.75525 8.97797 8.48819 8.76524 8.47593C8.76383 8.47593 8.76242 8.47593 8.76101 8.47593L4.39085 8.0004C4.10627 7.98678 3.95412 8.3206 4.15558 8.51544L4.75292 9.09316Z', 'M9.24696 16.474C9.1244 16.3568 9.1244 16.1647 9.24696 16.0475L11.4419 13.9247C12.4985 12.9028 11.8674 11.6124 11.0897 10.8603C10.877 10.6546 10.6361 10.4979 10.3966 10.378C10.081 10.2199 9.78091 10.6164 10.0331 10.8603C10.3853 11.2009 10.3853 11.5416 9.68088 12.2229L7.48735 14.3443L5.08813 16.6634C4.93739 16.8105 5.02192 17.0776 5.23465 17.0898C5.23606 17.0898 5.23746 17.0898 5.23887 17.0898L9.60762 17.564C9.8922 17.5776 10.0444 17.2438 9.84289 17.049L9.24696 16.474Z']
  },
  BADGE_DELIVERY: {
    path: ['M0 0H14V17.7092C14 17.9776 13.8921 18.2348 13.7005 18.4228L7.70051 24.3124C7.31154 24.6942 6.68846 24.6942 6.29949 24.3124L0.299492 18.4228C0.107923 18.2348 0 17.9776 0 17.7092V0Z', 'M9.09361 17.4995C8.38312 17.4995 7.80531 16.9217 7.80531 16.2112C7.80531 15.5007 8.38347 14.9229 9.09361 14.9229C9.8041 14.9229 10.3819 15.5007 10.3819 16.2112C10.3819 16.9217 9.80375 17.4995 9.09361 17.4995ZM12 15.4231C12 15.6882 11.7928 15.9064 11.5396 15.9088C11.4094 15.9099 11.2864 15.9116 11.1683 15.9133C11.0872 15.9147 11.0162 15.8586 10.9937 15.7768C10.7547 14.9143 9.99359 14.2814 9.09361 14.2814C8.15449 14.2814 7.36606 14.9704 7.16514 15.8908C7.14644 15.9771 7.07404 16.0384 6.98986 16.0384H6.36424C5.73932 16.0384 5.3063 15.2499 5.04961 14.686C4.99419 14.5644 5.07871 14.4238 5.20723 14.4238H5.95617C6.18307 14.4238 6.38087 14.2408 6.38745 14.0036C6.39438 13.758 6.20628 13.5567 5.97349 13.5567H4.53138C4.08209 13.5567 3.63591 12.5642 3.42737 12.1506C3.3671 12.0311 3.45058 11.8877 3.57979 11.8877H4.63912C4.86602 11.8877 5.06382 11.7048 5.0704 11.4671C5.07733 11.2215 4.88922 11.0203 4.65644 11.0203H3.21779C2.64864 11.0196 2.1893 9.9069 2.00743 9.25981C1.97349 9.13891 2.06009 9.01801 2.18029 9.01801H4.0568C4.69004 9.01282 4.7898 9.00866 4.8629 9.00554C4.93287 9.00312 4.97929 9.00104 5.67835 9H5.68147C6.43491 9 7.14817 9.39456 7.99307 10.2793C9.17467 11.5163 10.1159 12.162 11.1406 12.4385C11.6463 12.575 11.9997 13.0599 11.9997 13.618V15.4231H12Z']
  },
  ARROW_DOWN: {
    path: ['M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z']
  },
  LOGOUT: {
    path: ['M15.92 10.3801C15.97 10.2601 16 10.1301 16 10.0001C16 9.8701 15.97 9.7401 15.92 9.6201C15.87 9.5001 15.8 9.3901 15.7 9.3001L12.98 6.5801C12.59 6.1901 11.96 6.1901 11.57 6.5801C11.18 6.9701 11.18 7.6001 11.57 7.9901L12.59 9.0001H8C7.45 9.0001 7 9.4501 7 10.0001C7 10.5501 7.45 11.0001 8 11.0001H12.59L11.57 12.0201C11.18 12.4101 11.18 13.0401 11.57 13.4301C11.77 13.6301 12.02 13.7201 12.28 13.7201C12.54 13.7201 12.79 13.6201 12.99 13.4301L15.71 10.7101C15.8 10.6201 15.87 10.5101 15.92 10.3801Z', 'M14 14C13.45 14 13 14.45 13 15V17C13 17.55 12.55 18 12 18H3C2.45 18 2 17.55 2 17V3C2 2.45 2.45 2 3 2H12C12.55 2 13 2.45 13 3V4.99C13 5.55 13.45 6 14.01 6C14.56 6 15 5.56 15 5.01V3C15 1.34 13.66 0 12 0H3C1.34 0 0 1.34 0 3V17C0 18.66 1.34 20 3 20H12C13.66 20 15 18.66 15 17V15C15 14.45 14.55 14 14 14Z']
  },
  CAR360: {
    path: ['M2.4 15.0333C2.4 13.8735 4.81766 12.9333 7.8 12.9333V12C3.49218 12 0 13.3581 0 15.0333C0 16.7086 3.49218 18.0667 7.8 18.0667H9.6C10.2627 18.0667 10.8 17.8577 10.8 17.6C10.8 17.3423 10.2627 17.1333 9.6 17.1333H7.8C4.81766 17.1333 2.4 16.1931 2.4 15.0333Z', 'M24 15.0333C24 13.3581 20.5078 12 16.2 12V12.9333C19.1823 12.9333 21.6 13.8735 21.6 15.0333C21.6 16.0272 19.8247 16.8598 17.4401 17.0777L17.6485 16.9967C18.1172 16.8144 18.1172 16.5189 17.6485 16.3367C17.1799 16.1544 16.4201 16.1544 15.9515 16.3367L13.5515 17.27C13.0828 17.4523 13.0828 17.7477 13.5515 17.93L15.9515 18.8633C16.4201 19.0456 17.1799 19.0456 17.6485 18.8633C18.1172 18.6811 18.1172 18.3856 17.6485 18.2034L17.2297 18.0405C21.0508 17.8445 24 16.5729 24 15.0333Z', 'M5.05286 7.84962L4.98705 7.89349C4.59758 8.15314 4.36363 8.59027 4.36363 9.05836V15.2455C4.36363 15.6321 4.67703 15.9455 5.06363 15.9455H5.95455C6.34114 15.9455 6.65455 15.6321 6.65455 15.2455V14.4182H17.3455V15.2455C17.3455 15.6321 17.6589 15.9455 18.0455 15.9455H18.9364C19.323 15.9455 19.6364 15.6321 19.6364 15.2455V9.05836C19.6364 8.59027 19.4024 8.15314 19.013 7.89349L18.9472 7.84962C19.2255 7.68888 19.4775 7.53098 19.5265 7.46062C19.6446 7.29092 19.6989 6.78183 19.5265 6.78183H18.1091L17.1623 4.88813C16.8065 4.17668 16.0794 3.72728 15.284 3.72728H8.71606C7.92064 3.72728 7.19348 4.17668 6.83776 4.88813L5.8909 6.78185V6.78183H4.4735C4.30111 6.78183 4.35538 7.29092 4.4735 7.46062C4.52248 7.53098 4.77454 7.68888 5.05286 7.84962ZM7.53196 5.23208L6.1654 7.79439C6.04106 8.02752 6.21 8.30909 6.47422 8.30909H12H17.5258C17.79 8.30909 17.9589 8.02752 17.8346 7.79439L16.468 5.23208C16.2247 4.77587 15.7498 4.49091 15.2327 4.49091H8.76726C8.25022 4.49091 7.77527 4.77587 7.53196 5.23208ZM5.12727 10.7195V9.68208C5.12727 9.41196 5.4203 9.24365 5.65363 9.37976L8.37263 10.9658C8.69473 11.1537 8.53882 11.6479 8.16721 11.617L5.76914 11.4171C5.40634 11.3869 5.12727 11.0836 5.12727 10.7195ZM18.8727 9.68208V10.7195C18.8727 11.0836 18.5936 11.3869 18.2308 11.4171L15.8328 11.617C15.4612 11.6479 15.3052 11.1537 15.6273 10.9658L18.3463 9.37976C18.5797 9.24365 18.8727 9.41196 18.8727 9.68208Z']
  },
  CERTIFIED_PURCHASE: {
    path: ['M11.8,22c-0.9,0-1.6-0.7-2.1-1.2c-0.2-0.2-0.5-0.5-0.7-0.6c-0.2-0.1-0.6,0-0.9,0.1c-0.7,0.1-1.6,0.3-2.3-0.3  c-0.7-0.5-0.9-1.4-1-2.2c0-0.3-0.1-0.8-0.2-0.9c-0.1-0.1-0.5-0.3-0.8-0.5c-0.7-0.3-1.5-0.7-1.8-1.6c-0.3-0.8,0.1-1.6,0.5-2.3  c0.2-0.3,0.4-0.7,0.4-0.9s-0.2-0.6-0.4-0.9c-0.3-0.6-0.8-1.4-0.5-2.3C2.4,7.7,3.2,7.3,3.9,7c0.3-0.1,0.7-0.3,0.8-0.5  C4.7,6.4,4.8,6,4.8,5.7c0.1-0.7,0.2-1.6,1-2.2C6.5,3,7.4,3.1,8.2,3.2c0.3,0.1,0.8,0.1,0.9,0.1c0.1,0,0.5-0.4,0.7-0.6  c0.5-0.5,1.2-1.2,2.1-1.2c0.9,0,1.6,0.7,2.1,1.2c0.2,0.2,0.5,0.5,0.7,0.6c0.2,0.1,0.6,0,0.9-0.1c0.7-0.1,1.6-0.3,2.3,0.3  c0.7,0.5,0.9,1.4,1,2.2c0,0.3,0.1,0.8,0.2,0.9c0.1,0.1,0.5,0.3,0.8,0.5c0.7,0.3,1.5,0.7,1.8,1.6c0.3,0.8-0.1,1.6-0.5,2.3  c-0.2,0.3-0.4,0.7-0.4,0.9s0.2,0.6,0.4,0.9c0.3,0.6,0.8,1.4,0.5,2.3c-0.3,0.9-1.1,1.3-1.8,1.6c-0.3,0.1-0.7,0.3-0.8,0.5  c-0.1,0.1-0.2,0.6-0.2,0.9c-0.1,0.7-0.2,1.6-1,2.2c-0.7,0.5-1.6,0.4-2.3,0.3c-0.3-0.1-0.8-0.1-0.9-0.1c-0.1,0-0.5,0.4-0.7,0.6  C13.4,21.3,12.8,22,11.8,22z M8.9,18.3c0.3,0,0.5,0,0.8,0.1c0.6,0.2,1,0.7,1.4,1.1c0.2,0.2,0.5,0.6,0.7,0.6c0.2,0,0.5-0.4,0.7-0.6  c0.4-0.4,0.8-0.9,1.4-1.1c0.6-0.2,1.3-0.1,1.8,0c0.3,0,0.7,0.1,0.9,0.1c0.1-0.1,0.2-0.6,0.2-0.9c0.1-0.6,0.2-1.2,0.6-1.7  c0.4-0.5,1-0.8,1.5-1.1c0.2-0.1,0.7-0.3,0.8-0.5c0-0.2-0.2-0.6-0.3-0.8c-0.3-0.5-0.6-1.1-0.6-1.8c0-0.7,0.3-1.3,0.6-1.8  c0.1-0.2,0.3-0.6,0.3-0.8c-0.1-0.1-0.5-0.3-0.8-0.5c-0.5-0.3-1.1-0.5-1.5-1.1c-0.4-0.5-0.5-1.2-0.6-1.7c0-0.3-0.1-0.7-0.2-0.9  c-0.2,0-0.6,0-0.9,0.1c-0.6,0.1-1.2,0.2-1.8,0c-0.6-0.2-1-0.7-1.4-1.1c-0.2-0.2-0.5-0.6-0.7-0.6c-0.2,0-0.5,0.4-0.7,0.6  c-0.4,0.4-0.8,0.9-1.4,1.1c-0.6,0.2-1.3,0.1-1.8,0C7.6,5.1,7.1,5,6.9,5.1C6.9,5.2,6.8,5.7,6.7,5.9C6.7,6.5,6.6,7.2,6.2,7.7  c-0.4,0.5-1,0.8-1.5,1.1C4.5,8.8,4,9.1,3.9,9.2c0,0.2,0.2,0.6,0.3,0.8c0.3,0.5,0.6,1.1,0.6,1.8c0,0.7-0.3,1.3-0.6,1.8  c-0.1,0.2-0.3,0.6-0.3,0.8c0.1,0.1,0.5,0.3,0.8,0.5c0.5,0.3,1.1,0.5,1.5,1.1c0.4,0.5,0.5,1.2,0.6,1.7c0,0.3,0.1,0.7,0.2,0.9  c0.2,0,0.6,0,0.9-0.1C8.2,18.3,8.5,18.3,8.9,18.3z', 'M9.9,15.3c-0.2,0-0.3-0.1-0.5-0.2l-1.9-1.9c-0.3-0.3-0.3-0.7,0-0.9c0.3-0.3,0.7-0.3,0.9,0l1.5,1.5l5.4-5.4  c0.3-0.3,0.7-0.3,0.9,0c0.3,0.3,0.3,0.7,0,0.9l-5.8,5.8C10.2,15.3,10,15.3,9.9,15.3z']
  },
  INSPECTED: {
    path: ['M5.39647 8.55859C5.59649 8.75607 5.85681 8.85456 6.11764 8.85456C6.37847 8.85456 6.6393 8.75607 6.83932 8.55808L9.68785 5.74308C10.0909 5.3446 10.0949 4.69487 9.69639 4.29136C9.29786 3.88835 8.64755 3.88433 8.24449 4.28282L6.11714 6.38528L5.7558 6.029C5.35224 5.63052 4.70242 5.63454 4.30439 6.03805C3.90586 6.44156 3.91039 7.09129 4.31344 7.48927L5.39647 8.55859Z', 'M17.1067 0H16.4539H15.7724H2.89275C1.2951 0 0 1.29494 0 2.89239V17.1076C0 18.7051 1.2951 20 2.89275 20H10.4925C11.0483 20 11.5464 19.5839 11.5755 19.0287C11.6062 18.4367 11.1358 17.9473 10.5503 17.9473H2.89275C2.42889 17.9473 2.05297 17.5714 2.05297 17.1076V2.89239C2.05297 2.42858 2.42889 2.05271 2.89275 2.05271H12.0791C12.5334 2.05271 12.8807 2.42959 12.8792 2.88385C12.8792 2.88686 12.8792 2.88988 12.8792 2.89239V7.70684C12.8792 8.12291 13.128 8.47969 13.4843 8.64049V15.8624C13.4843 16.0579 13.5401 16.2493 13.6456 16.4147L15.6307 19.5251C15.8192 19.8206 16.1453 19.9995 16.4961 19.9995H16.5097C16.8615 19.9995 17.1877 19.8151 17.3691 19.5141L19.2482 16.3921C19.3442 16.2323 19.3954 16.0493 19.3954 15.8629V8.64049C19.7512 8.47918 20 8.12291 20 7.70684V2.89239C19.9995 1.29494 18.7044 0 17.1067 0ZM14.9327 6.21391V2.86123C14.9327 2.41451 15.295 2.05271 15.7413 2.05271H16.4539H17.1379C17.5847 2.05271 17.9465 2.41501 17.9465 2.86123V6.21391C17.9465 6.4717 17.7375 6.68023 17.4801 6.68023H15.3995C15.1412 6.68074 14.9327 6.4717 14.9327 6.21391ZM16.2006 16.6021L15.5865 15.6398C15.5548 15.5901 15.5377 15.5318 15.5377 15.4725V9.19977C15.5377 8.94199 15.7468 8.73345 16.0041 8.73345H16.8751C17.1329 8.73345 17.3414 8.94249 17.3414 9.19977V15.4916C17.3414 15.5478 17.3259 15.6036 17.2967 15.6519L16.7288 16.5951C16.6102 16.793 16.3248 16.7966 16.2006 16.6021Z', 'M10.4883 10.3646H5.03502C4.46813 10.3646 4.00879 10.8238 4.00879 11.3907C4.00879 11.9575 4.46813 12.4168 5.03502 12.4168H10.4883C11.0552 12.4168 11.5146 11.9575 11.5146 11.3907C11.5146 10.8238 11.0552 10.3646 10.4883 10.3646Z', 'M10.4883 13.9268H5.03502C4.46813 13.9268 4.00879 14.3861 4.00879 14.9529C4.00879 15.5197 4.46813 15.979 5.03502 15.979H10.4883C11.0552 15.979 11.5146 15.5197 11.5146 14.9529C11.5146 14.3861 11.0552 13.9268 10.4883 13.9268Z']
  }
};

var styles$8 = {"path":"_qNJk-"};

var _excluded$2 = ["name"];
function Icon(_ref) {
  var name = _ref.name,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  var _IconDataSet$name = IconDataSet == null ? void 0 : IconDataSet[name],
    path = _IconDataSet$name.path;
  return jsxRuntime.jsx("svg", _extends({}, props, {
    children: path.map(function (svgPath, idx) {
      return jsxRuntime.jsx("path", {
        className: styles$8.path,
        d: svgPath
      }, idx);
    })
  }));
}

var styles$7 = {"box":"_Tgtd5","popIn":"_fxzcF","mainContent":"_sWmTK","content":"_1AUQX","textInfo":"_jm6Zp","closeButton":"_Ndgxj","loginButton":"_9e51j","loginButtonText":"_2l3k0","overlay":"_zijDp"};

var FakeNotification = function FakeNotification(_ref) {
  var baseUrl = _ref.baseUrl,
    onClose = _ref.onClose;
  var _useState = react.useState(true),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var handleClose = function handleClose() {
    setIsOpen(false);
    typeof onClose === 'function' && onClose();
  };
  if (!isOpen) {
    return null;
  }
  return jsxRuntime.jsx("div", {
    className: styles$7.overlay,
    children: jsxRuntime.jsxs("div", {
      className: styles$7.box,
      children: [jsxRuntime.jsx(Icon, {
        className: styles$7.closeButton,
        onClick: handleClose,
        "data-testid": 'drawer-close-button',
        name: 'CLOSE',
        height: 10,
        width: 10
      }), jsxRuntime.jsx("div", {
        className: styles$7.mainContent,
        children: jsxRuntime.jsxs("div", {
          className: styles$7.content,
          children: [jsxRuntime.jsx(Notification, {}), jsxRuntime.jsx("p", {
            className: styles$7.textInfo,
            children: "Fa\xE7a login ou crie uma conta para uma experi\xEAncia ainda melhor! ;)"
          })]
        })
      }), jsxRuntime.jsx("a", {
        href: "" + baseUrl,
        target: '_self',
        rel: 'noopener',
        children: jsxRuntime.jsx("button", {
          className: styles$7.loginButton,
          children: jsxRuntime.jsx("span", {
            className: styles$7.loginButtonText,
            children: "Entrar"
          })
        })
      })]
    })
  });
};

var useLocalStorageState = function useLocalStorageState(key, initialValue) {
  var _useState = react.useState(function () {
      if (window__default["default"] && typeof window__default["default"].localStorage !== 'undefined') {
        var savedValue = window__default["default"].localStorage.getItem(key);
        return savedValue !== null ? JSON.parse(savedValue) : initialValue;
      }
    }),
    state = _useState[0],
    setState = _useState[1];
  react.useEffect(function () {
    if (window__default["default"] && typeof window__default["default"].localStorage !== 'undefined') {
      window__default["default"].localStorage.setItem(key, JSON.stringify(state));
    }
  }, [key, state]);
  return [state, setState];
};

var matchMedia = function matchMedia(querystring) {
  if (typeof window__default["default"] !== 'undefined' && typeof window__default["default"].matchMedia !== 'undefined') {
    return window__default["default"].matchMedia(querystring);
  }
  return {
    matches: true,
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {}
  };
};
/**
 * Check if a media query matches the UI
 * @param {String} mediaQueryString
 * @returns {Boolean}
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
 * https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/change_event
 *
 * Examples:
 *    useMediaQuery('(max-width: 600px)');
 *    useMediaQuery('only screen and (min-width: 600px)');
 *    useMediaQuery('@media only screen and (min-width: 600px)');
 */
function useMediaQuery(mediaQueryString) {
  var queryString = removeReservedMediaKeyWord(mediaQueryString);
  var query = react.useMemo(function () {
    return matchMedia(queryString);
  }, [queryString]);
  var _useState = react.useState(query.matches),
    matches = _useState[0],
    setMatches = _useState[1];
  react.useEffect(function () {
    var listener = function listener(e) {
      return setMatches(e.matches);
    };
    query.addEventListener('change', listener);
    return function () {
      return query.removeEventListener('change', listener);
    };
  }, [query]);
  return matches;
}
function removeReservedMediaKeyWord(mediaQueryString) {
  return mediaQueryString.replace('@media', '').trim();
}

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

function usePopover(initialState, options) {
  if (initialState === void 0) {
    initialState = false;
  }
  if (options === void 0) {
    options = {};
  }
  var _useState = react.useState(initialState),
    status = _useState[0],
    setStatus = _useState[1];
  var _useState2 = react.useState(v4()),
    uuid = _useState2[0];
  var dispatchPopoverEvent = react.useCallback(function (eventProps) {
    document.dispatchEvent(new CustomEvent('@popover:event', {
      detail: eventProps
    }));
  }, []);
  var open = react.useCallback(function (e) {
    e == null || e.stopPropagation();
    if (typeof window__default["default"].localStorage !== 'undefined') {
      window__default["default"].localStorage.removeItem('loginPopoverClosed');
    }
    dispatchPopoverEvent({
      status: true,
      uuid: uuid
    });
    setStatus(true);
  }, [setStatus, uuid, dispatchPopoverEvent]);
  var close = react.useCallback(function (e) {
    e == null || e.stopPropagation();
    if (typeof window__default["default"].localStorage !== 'undefined') {
      window__default["default"].localStorage.setItem('loginPopoverClosed', Date.now().toString());
    }
    dispatchPopoverEvent({
      status: false,
      uuid: uuid
    });
    setStatus(false);
  }, [setStatus, uuid, dispatchPopoverEvent]);
  var toggle = react.useCallback(function (e) {
    e == null || e.stopPropagation();
    dispatchPopoverEvent({
      status: !status,
      uuid: uuid
    });
    setStatus(function (_s) {
      return !_s;
    });
  }, [setStatus, status, uuid, dispatchPopoverEvent]);
  react.useEffect(function () {
    function popoverEventListener(e) {
      var detail = e.detail;
      if (detail.uuid !== uuid && detail.status && status && !options.keepOpen) {
        close();
      }
    }
    document.addEventListener('@popover:event', popoverEventListener);
    return function () {
      return document.removeEventListener('@popover:event', popoverEventListener);
    };
  }, [close, options.keepOpen, status, uuid]);
  var isClose = react.useMemo(function () {
    return !status;
  }, [status]);
  var isOpen = react.useMemo(function () {
    return status;
  }, [status]);
  return {
    isOpen: isOpen,
    isClose: isClose,
    toggle: toggle,
    close: close,
    open: open
  };
}

var dispatchCustomEvent = function dispatchCustomEvent(name, detail) {
  if (typeof window__default["default"] !== 'undefined') {
    var event = new CustomEvent(name, {
      detail: detail
    });
    window__default["default"].dispatchEvent(event);
  }
};

var setLocalStorageItem = function setLocalStorageItem(key, value) {
  if (window__default["default"] && typeof window__default["default"].localStorage !== 'undefined') {
    window__default["default"].localStorage.setItem(key, JSON.stringify(value));
  }
};
var getLocalStorageItem = function getLocalStorageItem(key) {
  if (!window__default["default"] || typeof window__default["default"].localStorage === 'undefined') {
    return null;
  }
  try {
    var item = window__default["default"].localStorage.getItem(key);
    if (!item) {
      return null;
    }
    try {
      var parsedItem = JSON.parse(item);
      return parsedItem;
    } catch (_unused) {
      return item;
    }
  } catch (error) {
    return null;
  }
};

function useDrawerMenu() {
  /**
   * Dispatches drawer menu events
   *
   * @param actived
   */
  function dispatchEvent(actived) {
    document.dispatchEvent(new CustomEvent('wb::drawer', {
      detail: {
        actived: actived
      }
    }));
  }
  /**
   * Handle drawer menu opening
   *
   */
  function open() {
    dispatchEvent(true);
  }
  /**
   * Handle drawer menu closing
   *
   */
  function close() {
    dispatchEvent(false);
  }
  return {
    open: open,
    close: close
  };
}

var styles$6 = {"container":"_c6tbA","containerActived":"_S3nIm","header":"_h-AL5","closeButton":"_LnDfa","title":"_FxGXg","body":"_uZWFv","footer":"_Epo71","accordionButton":"_Z03AI","labelWrapper":"_jYVju","accordionList":"_gfG54","listItem":"_7dZZn","arrowDown":"_fzBJV","customBadge":"_ZYbqu","accordionListItem":"_mJ8FC"};

function getDrawerLinks$1(links) {
  var subscriptionValue = getLocalStorageItem('solucoes-wm_assinatura');
  if (subscriptionValue !== 'B') {
    return links.filter(function (link) {
      return link.label !== 'Assinar';
    });
  }
  return links;
}
function DrawerMenu(props) {
  var _useState = react.useState(false),
    actived = _useState[0],
    setActived = _useState[1];
  var _useState2 = react.useState(getDrawerLinks$1(props.links)),
    drawerLinks = _useState2[0],
    setDrawerLinks = _useState2[1];
  var _useState3 = react.useState(null),
    index = _useState3[0],
    setIndex = _useState3[1];
  var _useLocalStorageState = useLocalStorageState('isClickedMobileMenu', true),
    isClickedMobileMenu = _useLocalStorageState[0],
    setIsClickedMobileMenu = _useLocalStorageState[1];
  var routes = props.routes,
    user = props.user,
    onLogOut = props.onLogOut,
    showNotification = props.showNotification,
    onNotificationClose = props.onNotificationClose;
  var _useDrawerMenu = useDrawerMenu(),
    close = _useDrawerMenu.close;
  var handleDrawerEvent = react.useCallback(function (_ref) {
    var detail = _ref.detail;
    setActived(detail.actived);
  }, []);
  var handleAccordionEvent = react.useCallback(function (idx) {
    idx === index ? setIndex(null) : setIndex(idx);
  }, [index, setIndex]);
  react.useEffect(function () {
    document.addEventListener('wb::drawer', handleDrawerEvent);
    return function () {
      return document.removeEventListener('wb::drawer', handleDrawerEvent);
    };
  }, [handleDrawerEvent]);
  react.useEffect(function () {
    if (typeof window__default["default"] === 'undefined') return;
    var handleCustomEvent = function handleCustomEvent(event) {
      setIsClickedMobileMenu(event.detail);
    };
    window__default["default"].addEventListener('customEventMobile', handleCustomEvent);
    return function () {
      window__default["default"].removeEventListener('customEventMobile', handleCustomEvent);
    };
  }, []);
  react.useEffect(function () {
    function getLinks() {
      setDrawerLinks(getDrawerLinks$1(props.links));
    }
    window__default["default"].addEventListener('@subscription::ABTest', getLinks);
    return function () {
      window__default["default"].removeEventListener('@subscription::ABTest', getLinks);
    };
  }, [props.links]);
  var handleClick = function handleClick() {
    if (isClickedMobileMenu) {
      setIsClickedMobileMenu(false);
      setLocalStorageItem('isClickedMobileMenu', false);
      dispatchCustomEvent('customEventMobile', false);
    }
  };
  return jsxRuntime.jsxs("div", {
    className: styles$6.container + " " + (actived && styles$6.containerActived),
    children: [jsxRuntime.jsxs("div", {
      className: styles$6.header,
      children: [jsxRuntime.jsx(SvgLogoSmall, {
        height: 60,
        width: 60
      }), jsxRuntime.jsxs("h2", {
        "data-qa": 'drawer-title-button',
        title: 'drawer title',
        children: [!user && jsxRuntime.jsx("a", {
          href: (routes == null ? void 0 : routes.LOGIN) + "?lkid=1402",
          children: "Entrar ou cadastrar"
        }), user && jsxRuntime.jsxs("div", {
          children: ["Ol\xE1, ", user.name]
        })]
      }), jsxRuntime.jsx(Icon, {
        className: styles$6.closeButton,
        onClick: function onClick() {
          return close();
        },
        "data-qa": 'drawer-close-button',
        name: 'SLIM_CLOSE',
        height: 24,
        width: 24
      })]
    }), jsxRuntime.jsxs("div", {
      className: styles$6.body,
      children: [jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx("div", {
          className: styles$6.title,
          children: "Menu"
        }), actived && showNotification && !user && jsxRuntime.jsx(FakeNotification, {
          baseUrl: (routes == null ? void 0 : routes.LOGIN) + "?lkid=1958",
          onClose: onNotificationClose
        }), jsxRuntime.jsx("ul", {
          children: drawerLinks.map(function (link, idx) {
            return jsxRuntime.jsxs("li", {
              className: styles$6.listItem,
              "data-open": index === idx,
              children: [jsxRuntime.jsxs("div", {
                onClick: function onClick() {
                  if (link.label === 'Serviços') {
                    handleClick();
                  }
                  handleAccordionEvent(idx);
                },
                className: styles$6.accordionButton,
                "data-qa": 'drawer-accordion-button',
                children: [jsxRuntime.jsxs("div", {
                  className: styles$6.labelWrapper,
                  children: [link.label, link.isNew && jsxRuntime.jsx("span", {
                    className: styles$6.customBadge,
                    children: "NOVO"
                  })]
                }), jsxRuntime.jsx(Icon, {
                  name: 'ARROW_DOWN',
                  className: styles$6.arrowDown,
                  height: 24,
                  width: 24
                })]
              }), link.links && jsxRuntime.jsx("ul", {
                "data-testid": 'drawer-accordion-list',
                className: styles$6.accordionList,
                children: link.links.map(function (child, idx) {
                  var _child$props;
                  return jsxRuntime.jsx("li", {
                    children: jsxRuntime.jsxs("a", {
                      href: child.href,
                      target: (child == null ? void 0 : child.target) || '_blank',
                      rel: 'noreferrer',
                      className: styles$6.accordionListItem,
                      id: "drawer_" + ((_child$props = child.props) == null ? void 0 : _child$props.id),
                      children: [child.icon && jsxRuntime.jsx(Icon, {
                        name: child.icon,
                        height: 24,
                        width: 24
                      }), child.label, child.label === 'Webmotors Serviços' ? jsxRuntime.jsx("span", {
                        className: styles$6.customBadge,
                        children: "NOVO"
                      }) : null]
                    })
                  }, idx);
                })
              })]
            }, idx);
          })
        })]
      }), jsxRuntime.jsxs("div", {
        "data-qa": 'drawer-footer',
        className: styles$6.footer,
        children: [user && jsxRuntime.jsx("div", {
          "data-qa": 'drawer-footer-button',
          onClick: function onClick() {
            return typeof onLogOut === 'function' && onLogOut();
          },
          children: jsxRuntime.jsx("span", {
            children: "Sair"
          })
        }), !user && jsxRuntime.jsx("a", {
          href: (routes == null ? void 0 : routes.COCKPIT) + "?lkid=1562",
          target: '_blank',
          rel: 'noreferrer',
          children: jsxRuntime.jsxs("span", {
            children: ["Acesse a plataforma do ", jsxRuntime.jsx("b", {
              children: "Cockpit"
            })]
          })
        })]
      })]
    })]
  });
}

var ArrowDownIcon = function ArrowDownIcon(props) {
  return jsxRuntime.jsx("svg", _extends({
    width: '12',
    height: '8',
    viewBox: '0 0 12 8',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, props, {
    children: jsxRuntime.jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.7072 2.20675L6.70725 7.20675C6.31625 7.59775 5.68425 7.59775 5.29325 7.20675L0.29325 2.20675C-0.09775 1.81575 -0.09775 1.18375 0.29325 0.79275C0.68425 0.40175 1.31625 0.40175 1.70725 0.79275L6.00025 5.08575L10.2933 0.79275C10.6842 0.40175 11.3162 0.40175 11.7072 0.79275C11.9022 0.98775 12.0002 1.24375 12.0002 1.49975C12.0002 1.75575 11.9022 2.01175 11.7072 2.20675Z',
      fill: 'white'
    })
  }));
};

function Assinatura(props) {
  return jsxRuntime.jsxs("svg", _extends({
    width: '356',
    height: '39',
    viewBox: '0 0 356 39',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, props, {
    children: [jsxRuntime.jsx("path", {
      d: 'M17.9082 36.9991C27.573 36.9991 35.4078 29.1643 35.4078 19.4995C35.4078 9.83481 27.573 2 17.9082 2C8.2435 2 0.408691 9.83481 0.408691 19.4995C0.408691 29.1643 8.2435 36.9991 17.9082 36.9991Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M27.6581 25.5417C27.6581 26.3657 26.9715 27.0284 26.1356 26.9806C25.3535 26.9388 24.7684 26.2403 24.7684 25.4581V21.7087C24.7684 21.2848 24.4221 20.9385 23.9982 20.9385H20.1173C19.6934 20.9385 19.3471 21.2848 19.3471 21.7087V26.3776C19.3471 27.2015 18.6605 27.8643 17.8247 27.8165C17.0425 27.7747 16.4574 27.0762 16.4574 26.294V21.7027C16.4574 21.2788 16.1111 20.9325 15.6872 20.9325H11.8064C11.3825 20.9325 11.0362 21.2788 11.0362 21.7027V25.5298C11.0362 26.3537 10.3496 27.0164 9.51373 26.9687C8.73159 26.9269 8.14648 26.2283 8.14648 25.4462V13.4455C8.14648 12.6216 8.83309 11.9588 9.66896 12.0066C10.4511 12.0484 11.0362 12.7469 11.0362 13.5291V17.2786C11.0362 17.7025 11.3825 18.0488 11.8064 18.0488H15.6872C16.1111 18.0488 16.4574 17.7025 16.4574 17.2786V12.6096C16.4574 11.7857 17.144 11.123 17.9799 11.1707C18.762 11.2125 19.3471 11.9111 19.3471 12.6932V17.2845C19.3471 17.7084 19.6934 18.0547 20.1173 18.0547H23.9982C24.4221 18.0547 24.7684 17.7084 24.7684 17.2845V13.5351C24.7684 12.7529 25.3535 12.0544 26.1356 12.0126C26.9655 11.9708 27.6581 12.6335 27.6581 13.4515V25.5358V25.5417Z',
      fill: '#E22446'
    }), jsxRuntime.jsx("path", {
      d: 'M139.682 7.7374H137.527C137.103 7.7374 136.756 8.08369 136.756 8.50759V21.8636C136.756 25.5414 138.339 27.0938 142.96 26.7415C143.366 26.7117 143.682 26.3773 143.682 25.9713V24.1264C143.682 23.6906 143.318 23.3503 142.888 23.3622C141.288 23.404 140.452 23.207 140.452 21.8696V15.4692H142.918C143.342 15.4692 143.688 15.1229 143.688 14.699V12.6869C143.688 12.263 143.342 11.9167 142.918 11.9167H140.452V8.51356C140.452 8.08966 140.106 7.74337 139.682 7.74337V7.7374Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M127.132 11.7737C122.923 11.7737 119.579 15.0635 119.579 19.3264C119.579 23.5893 122.929 26.8791 127.132 26.8791C131.335 26.8791 134.715 23.5893 134.715 19.3264C134.715 15.0635 131.335 11.7737 127.132 11.7737ZM127.132 23.2789C124.959 23.2789 123.269 21.6489 123.269 19.3324C123.269 17.0158 124.959 15.3859 127.132 15.3859C129.305 15.3859 131.025 17.0158 131.025 19.3324C131.025 21.6489 129.335 23.2789 127.132 23.2789Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M152.495 11.7737C148.285 11.7737 144.942 15.0635 144.942 19.3264C144.942 23.5893 148.291 26.8791 152.495 26.8791C156.698 26.8791 160.077 23.5893 160.077 19.3264C160.077 15.0635 156.698 11.7737 152.495 11.7737ZM152.495 23.2789C150.321 23.2789 148.632 21.6489 148.632 19.3324C148.632 17.0158 150.321 15.3859 152.495 15.3859C154.668 15.3859 156.387 17.0158 156.387 19.3324C156.387 21.6489 154.698 23.2789 152.495 23.2789Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M58.0289 20.6221C58.0289 22.0192 56.8288 23.1357 55.4019 22.9984C54.16 22.879 53.2525 21.7625 53.2525 20.5146V12.6754C53.2525 12.2515 52.9062 11.9052 52.4823 11.9052H50.2254C49.8015 11.9052 49.4552 12.2515 49.4552 12.6754V20.5146C49.4552 21.7625 48.5477 22.873 47.3059 22.9984C45.8849 23.1357 44.6788 22.0192 44.6788 20.6221V12.6754C44.6788 12.2515 44.3325 11.9052 43.9086 11.9052H41.6518C41.2279 11.9052 40.8816 12.2515 40.8816 12.6754V20.4251C40.8816 23.679 43.3176 26.521 46.5595 26.7777C48.4164 26.927 50.118 26.2404 51.3419 25.0642C52.5659 26.2404 54.2615 26.927 56.1243 26.7777C59.3663 26.521 61.8022 23.679 61.8022 20.4251V12.6754C61.8022 12.2515 61.4559 11.9052 61.032 11.9052H58.7752C58.3513 11.9052 58.005 12.2515 58.005 12.6754V20.6221H58.0289Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M112.224 11.911C110.367 11.7618 108.666 12.4484 107.442 13.6246C106.218 12.4484 104.522 11.7618 102.659 11.911C99.4174 12.1678 96.9814 15.0097 96.9814 18.2636V26.0133C96.9814 26.4373 97.3277 26.7835 97.7516 26.7835H100.008C100.432 26.7835 100.779 26.4373 100.779 26.0133V18.1741C100.779 16.9262 101.686 15.8157 102.928 15.6903C104.349 15.553 105.555 16.6695 105.555 18.0666V26.0133C105.555 26.4373 105.901 26.7835 106.325 26.7835H108.582C109.006 26.7835 109.352 26.4373 109.352 26.0133V18.1741C109.352 16.9262 110.26 15.8157 111.502 15.6903C112.923 15.553 114.129 16.6695 114.129 18.0666V26.0133C114.129 26.4373 114.475 26.7835 114.899 26.7835H117.156C117.58 26.7835 117.926 26.4373 117.926 26.0133V18.2636C117.926 15.0097 115.49 12.1678 112.248 11.911H112.224Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M175.409 16.2396C175.409 15.4695 176.156 15.0635 177.069 15.0635C177.816 15.0635 178.425 15.3321 178.878 15.8098C179.099 16.0426 179.481 16.1322 179.762 15.9829L181.583 15.0097C182.025 14.7709 182.114 14.1918 181.786 13.8097C180.628 12.4842 178.956 11.7737 177.069 11.7737C174.12 11.7737 171.63 13.4037 171.63 16.3232C171.63 21.3623 179.016 20.216 179.016 22.3057C179.016 23.1356 178.216 23.5356 177.039 23.5356C175.965 23.5356 175.153 23.1415 174.645 22.449C174.43 22.1564 174.024 22.031 173.702 22.2042L171.803 23.2192C171.403 23.4341 171.26 23.9356 171.517 24.3118C172.657 25.9775 174.568 26.8791 177.039 26.8791C180.102 26.8791 182.789 25.3924 182.789 22.2997C182.789 17.0337 175.404 18.3532 175.404 16.2337L175.409 16.2396Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M87.8277 11.7736C86.4067 11.7736 85.0932 12.1557 83.9648 12.8125V7.32558C83.9648 6.90168 83.6185 6.55539 83.1946 6.55539H81.0392C80.6153 6.55539 80.269 6.90168 80.269 7.32558V19.3741C80.2929 23.6131 83.6304 26.879 87.8217 26.879C92.013 26.879 95.4043 23.5892 95.4043 19.3263C95.4043 15.0634 92.025 11.7736 87.8217 11.7736H87.8277ZM87.8277 23.2788C85.6544 23.2788 83.9708 21.6548 83.9648 19.3382V19.3144C83.9648 17.0038 85.6544 15.3738 87.8277 15.3738C90.001 15.3738 91.7205 17.0038 91.7205 19.3203C91.7205 21.6369 90.0308 23.2668 87.8277 23.2668V23.2788Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M165.068 26.7821H162.811C162.387 26.7821 162.041 26.4358 162.041 26.0119V19.2413C162.041 15.1873 165.325 11.9036 169.379 11.9036H169.689C170.113 11.9036 170.459 12.2499 170.459 12.6738V14.9306C170.459 15.3545 170.113 15.7008 169.689 15.7008H169.379C167.42 15.7008 165.832 17.289 165.832 19.2473V26.0178C165.832 26.4417 165.486 26.788 165.062 26.788L165.068 26.7821Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M74.7288 21.9696C74.4243 21.8084 74.0482 21.8741 73.8094 22.1248C73.1108 22.8532 72.1317 23.2831 71.0032 23.2831C69.4509 23.2831 68.1493 22.4532 67.5284 21.1337C67.3553 20.7695 67.612 20.3456 68.012 20.3456H77.5708C78.126 20.3456 78.5798 19.8919 78.5798 19.3366C78.5798 15.0737 75.2005 11.7839 70.9973 11.7839C66.794 11.7839 63.4446 15.0737 63.4446 19.3366C63.4446 23.5996 66.794 26.8893 70.9973 26.8893C73.3795 26.8893 75.4871 25.8325 76.8722 24.1429C77.1767 23.7727 77.0454 23.2174 76.6275 22.9965L74.7169 21.9756L74.7288 21.9696ZM71.0092 15.3782C72.5496 15.3782 73.8392 16.1782 74.4721 17.4499H67.5702C68.2031 16.1782 69.4867 15.3782 71.0032 15.3782H71.0092Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M195 0L195 39',
      stroke: 'white',
      strokeMiterlimit: '10'
    }), jsxRuntime.jsx("path", {
      d: 'M296.512 30.4205C296.512 32.9042 297.814 34.3252 299.766 34.3252C300.805 34.3252 301.438 33.9132 301.856 33.2624L301.945 34.152H303.438V26.7486C302.578 26.4501 301.707 26.3366 300.638 26.3366C297.897 26.3366 296.506 27.8173 296.506 30.4205H296.512ZM301.808 32.4624C301.378 32.7908 300.859 32.9937 300.226 32.9937C298.775 32.9937 298.166 31.931 298.166 30.4205C298.166 28.7607 298.948 27.7278 300.638 27.7278C301.098 27.7278 301.468 27.7576 301.808 27.8173V32.4624ZM308.179 26.3366C307.396 26.3366 306.256 26.4978 305.217 26.7486V34.152H306.847V27.8472C307.289 27.7755 307.749 27.7278 308.137 27.7278C309.767 27.7278 310.149 28.289 310.149 29.4592V34.152H311.779V29.1786C311.779 27.3874 310.907 26.3366 308.185 26.3366H308.179ZM281.21 26.5277C281.186 25.9844 281.037 25.453 280.756 24.9694L278.29 20.6945C278.099 20.3661 277.974 20.0199 277.902 19.6616L277.801 19.8407C277.192 20.8975 277.192 22.1991 277.801 23.2618L279.777 26.6829C280.386 27.7397 280.386 29.0413 279.777 30.104L279.675 30.2831C279.604 29.9249 279.472 29.5786 279.287 29.2502L277.478 26.1217L276.326 24.1216C276.135 23.7932 276.01 23.4469 275.938 23.0887L275.836 23.2678C275.227 24.3246 275.227 25.6202 275.83 26.677L277.813 30.104C278.422 31.1608 278.422 32.4624 277.813 33.5251L277.711 33.7042C277.639 33.346 277.508 32.9997 277.323 32.6713L274.857 28.3965C274.529 27.8233 274.374 27.1785 274.403 26.5396C271.764 27.2322 269.938 28.695 269.938 30.3906C269.938 32.749 273.466 34.6655 277.819 34.6655C282.171 34.6655 285.7 32.7549 285.7 30.3906C285.7 28.695 283.879 27.2262 281.234 26.5396L281.21 26.5277ZM292.828 28.4383L292.028 28.0979C290.989 27.6561 290.416 27.2083 290.416 26.4381C290.416 25.6679 291.007 25.1485 292.297 25.1485C292.978 25.1485 293.927 25.2799 294.727 25.5784C294.876 25.1485 294.978 24.6888 295.026 24.0977C294.184 23.7992 293.276 23.6678 292.315 23.6678C289.915 23.6678 288.751 24.7485 288.751 26.4381C288.751 28.0084 289.7 28.7905 291.091 29.3995L291.843 29.7279C293.234 30.3369 293.796 30.7369 293.796 31.5907C293.796 32.4445 293.025 32.9102 291.652 32.9102C290.84 32.9102 289.772 32.7191 288.942 32.331C288.78 32.8027 288.691 33.2206 288.661 33.8237C289.491 34.2058 290.482 34.3849 291.694 34.3849C294.208 34.3849 295.497 33.2147 295.497 31.5131C295.497 30.0801 294.715 29.2323 292.834 28.4323L292.828 28.4383ZM340.001 26.4561C339.619 26.3844 339.219 26.3366 338.789 26.3366C336.049 26.3366 334.658 27.8173 334.658 30.4205C334.658 33.0236 335.959 34.3252 337.912 34.3252C338.98 34.3252 339.613 33.8953 340.031 33.2027L340.121 34.152H341.613V23.7932C341.082 23.7932 340.503 23.835 340.001 24.0141V26.4561ZM340.001 32.4325C339.56 32.7728 339.022 32.9937 338.371 32.9937C336.921 32.9937 336.312 31.931 336.312 30.4205C336.312 28.7308 337.082 27.7278 338.694 27.7278C339.124 27.7278 339.565 27.7875 339.995 27.877V32.4385L340.001 32.4325ZM346.557 26.3366C343.966 26.3366 342.945 28.086 342.945 30.2891C342.945 32.8206 344.264 34.3311 346.987 34.3311C347.859 34.3311 348.647 34.1998 349.387 33.8595C349.488 33.3699 349.578 32.8087 349.638 32.3788C348.826 32.749 347.918 32.94 347.035 32.94C345.584 32.94 344.814 32.3012 344.605 30.9877H349.799C349.859 30.5578 349.888 30.1876 349.888 29.7279C349.888 27.8651 348.879 26.3366 346.557 26.3366ZM344.575 29.6204C344.706 28.3606 345.315 27.6979 346.467 27.6979C347.62 27.6979 348.241 28.4084 348.241 29.6204H344.569H344.575ZM354.08 26.3366C353.16 26.3366 351.99 26.5158 351.298 26.7486V34.152H352.927V27.8173C353.328 27.7576 353.728 27.7278 354.128 27.7278C354.587 27.7278 354.969 27.7397 355.357 27.7875C355.447 27.477 355.507 26.8859 355.507 26.3963C355.149 26.3546 354.587 26.3366 354.086 26.3366H354.08ZM317.457 27.9785C317.528 27.5487 317.576 27.0889 317.606 26.5874H315.033V23.7872C314.531 23.7872 313.91 23.8589 313.403 24.0261V31.7996C313.403 33.6027 314.412 34.3311 315.994 34.3311C316.454 34.3311 316.925 34.2714 317.373 34.0923C317.463 33.6624 317.522 33.1609 317.564 32.7131C317.212 32.8445 316.764 32.934 316.292 32.934C315.51 32.934 315.033 32.5639 315.033 31.6026V27.9785H317.463H317.457ZM329.756 26.3366C328.974 26.3366 327.833 26.4978 326.795 26.7486V34.152H328.425V27.8472C328.866 27.7755 329.326 27.7278 329.714 27.7278C331.344 27.7278 331.726 28.289 331.726 29.4592V34.152H333.356V29.1786C333.356 27.3874 332.484 26.3366 329.762 26.3366H329.756ZM318.096 30.4205C318.096 32.9042 319.397 34.3252 321.35 34.3252C322.388 34.3252 323.021 33.9132 323.439 33.2624L323.529 34.152H325.021V26.7486C324.162 26.4501 323.29 26.3366 322.221 26.3366C319.481 26.3366 318.09 27.8173 318.09 30.4205H318.096ZM323.391 32.4624C322.962 32.7908 322.442 32.9937 321.809 32.9937C320.358 32.9937 319.749 31.931 319.749 30.4205C319.749 28.7607 320.532 27.7278 322.221 27.7278C322.681 27.7278 323.051 27.7576 323.391 27.8173V32.4624Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M206.512 29.778V25.4072H207.787V29.6817C207.787 30.3153 208.124 30.7884 208.998 30.7884C209.872 30.7884 210.209 30.3153 210.209 29.6817V25.4072H211.492V29.778C211.492 31.1814 210.434 32.0315 209.006 32.0315C207.579 32.0315 206.528 31.1734 206.528 29.778H206.512Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M219.463 29.04V31.903H218.268V29.1282C218.268 28.5828 217.988 28.246 217.49 28.246C216.961 28.246 216.624 28.5989 216.624 29.2966V31.903H215.429V29.1282C215.429 28.5828 215.149 28.246 214.651 28.246C214.154 28.246 213.777 28.5989 213.777 29.2966V31.903H212.582V27.2596H213.777V27.7488C214.034 27.3558 214.475 27.1233 215.068 27.1233C215.662 27.1233 216.071 27.3639 216.336 27.7889C216.624 27.3719 217.089 27.1233 217.723 27.1233C218.782 27.1233 219.479 27.8771 219.479 29.04H219.463Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M225.205 27.2589V31.9023H224.01V31.357C223.673 31.774 223.176 32.0386 222.494 32.0386C221.259 32.0386 220.241 30.972 220.241 29.5846C220.241 28.1972 221.259 27.1306 222.494 27.1306C223.176 27.1306 223.673 27.3872 224.01 27.8123V27.2669H225.205V27.2589ZM224.01 29.5766C224.01 28.7987 223.465 28.2694 222.719 28.2694C221.973 28.2694 221.436 28.7987 221.436 29.5766C221.436 30.3545 221.981 30.8838 222.719 30.8838C223.457 30.8838 224.01 30.3545 224.01 29.5766Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M230.938 30.9402C231.404 30.9402 231.772 30.7478 231.981 30.4751L232.943 31.0284C232.51 31.662 231.813 32.0229 230.922 32.0229C229.359 32.0229 228.38 30.9563 228.38 29.5689C228.38 28.1815 229.375 27.1148 230.834 27.1148C232.206 27.1148 233.184 28.1975 233.184 29.5689C233.184 29.7453 233.168 29.9057 233.136 30.0581H229.631C229.8 30.6676 230.313 30.9322 230.938 30.9322V30.9402ZM231.973 29.1438C231.821 28.4782 231.323 28.2055 230.818 28.2055C230.177 28.2055 229.743 28.5504 229.599 29.1438H231.965H231.973Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M240.899 29.04V31.903H239.704V29.1282C239.704 28.5828 239.423 28.246 238.926 28.246C238.397 28.246 238.06 28.5989 238.06 29.2966V31.903H236.865V29.1282C236.865 28.5828 236.584 28.246 236.087 28.246C235.59 28.246 235.213 28.5989 235.213 29.2966V31.903H234.018V27.2596H235.213V27.7488C235.47 27.3558 235.911 27.1233 236.504 27.1233C237.098 27.1233 237.507 27.3639 237.771 27.7889C238.06 27.3719 238.525 27.1233 239.159 27.1233C240.217 27.1233 240.915 27.8771 240.915 29.04H240.899Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M246.891 29.5769C246.891 30.9643 245.872 32.0309 244.621 32.0309C243.939 32.0309 243.45 31.7823 243.113 31.3492V33.7551H241.918V27.2512H243.113V27.7965C243.45 27.3715 243.939 27.1148 244.621 27.1148C245.864 27.1148 246.891 28.1815 246.891 29.5689V29.5769ZM245.688 29.5769C245.688 28.799 245.142 28.2697 244.397 28.2697C243.651 28.2697 243.113 28.799 243.113 29.5769C243.113 30.3548 243.659 30.8841 244.397 30.8841C245.134 30.8841 245.688 30.3548 245.688 29.5769Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M250.339 27.1622V28.5015C249.713 28.4293 248.927 28.702 248.927 29.6804V31.9018H247.732V27.2584H248.927V28.0604C249.168 27.4269 249.753 27.1702 250.339 27.1702V27.1622Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M253.178 30.9402C253.643 30.9402 254.012 30.7478 254.22 30.4751L255.183 31.0284C254.75 31.662 254.052 32.0229 253.162 32.0229C251.598 32.0229 250.62 30.9563 250.62 29.5689C250.62 28.1815 251.614 27.1148 253.074 27.1148C254.445 27.1148 255.423 28.1975 255.423 29.5689C255.423 29.7453 255.407 29.9057 255.375 30.0581H251.871C252.039 30.6676 252.552 30.9322 253.178 30.9322V30.9402ZM254.22 29.1438C254.068 28.4782 253.571 28.2055 253.066 28.2055C252.424 28.2055 251.991 28.5504 251.847 29.1438H254.212H254.22Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M259.569 30.5477C259.569 31.5501 258.695 32.0313 257.7 32.0313C256.77 32.0313 256.08 31.6384 255.751 30.9246L256.794 30.3392C256.922 30.7161 257.243 30.9406 257.708 30.9406C258.085 30.9406 258.35 30.8123 258.35 30.5397C258.35 29.858 255.952 30.2349 255.952 28.5989C255.952 27.6526 256.762 27.1233 257.716 27.1233C258.47 27.1233 259.12 27.4681 259.481 28.1097L258.462 28.663C258.326 28.3663 258.061 28.1899 257.716 28.1899C257.42 28.1899 257.179 28.3182 257.179 28.5668C257.179 29.2565 259.577 28.8234 259.577 30.5397L259.569 30.5477Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M264.999 27.2589V31.9023H263.804V31.357C263.467 31.774 262.97 32.0386 262.288 32.0386C261.053 32.0386 260.035 30.972 260.035 29.5846C260.035 28.1972 261.053 27.1306 262.288 27.1306C262.97 27.1306 263.467 27.3872 263.804 27.8123V27.2669H264.999V27.2589ZM263.804 29.5766C263.804 28.7987 263.259 28.2694 262.513 28.2694C261.767 28.2694 261.23 28.7987 261.23 29.5766C261.23 30.3545 261.775 30.8838 262.513 30.8838C263.251 30.8838 263.804 30.3545 263.804 29.5766Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M206.5 8.02374V3.65234H207.775V7.92749C207.775 8.56115 208.112 9.03438 208.986 9.03438C209.861 9.03438 210.198 8.56115 210.198 7.92749V3.65234H211.481V8.02374C211.481 9.42741 210.422 10.2776 208.994 10.2776C207.567 10.2776 206.516 9.41938 206.516 8.02374H206.5Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M219.453 7.28361V10.1471H218.258V7.37184C218.258 6.82641 217.978 6.48954 217.48 6.48954C216.951 6.48954 216.614 6.84246 216.614 7.54028V10.1471H215.419V7.37184C215.419 6.82641 215.138 6.48954 214.641 6.48954C214.144 6.48954 213.767 6.84246 213.767 7.54028V10.1471H212.572V5.50296H213.767V5.99224C214.023 5.59921 214.464 5.36661 215.058 5.36661C215.652 5.36661 216.061 5.60724 216.325 6.03234C216.614 5.61526 217.079 5.36661 217.713 5.36661C218.772 5.36661 219.47 6.12057 219.47 7.28361H219.453Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M225.204 5.50407V10.1482H224.009V9.60276C223.672 10.0198 223.175 10.2845 222.493 10.2845C221.258 10.2845 220.239 9.21775 220.239 7.83013C220.239 6.44251 221.258 5.37573 222.493 5.37573C223.175 5.37573 223.672 5.6324 224.009 6.05751V5.51209H225.204V5.50407ZM224.001 7.82211C224.001 7.04408 223.456 6.5147 222.71 6.5147C221.964 6.5147 221.426 7.04408 221.426 7.82211C221.426 8.60014 221.972 9.12952 222.71 9.12952C223.448 9.12952 224.001 8.60014 224.001 7.82211Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M230.932 9.19259C231.397 9.19259 231.766 9.00008 231.974 8.72737L232.937 9.28082C232.504 9.91447 231.806 10.2754 230.916 10.2754C229.352 10.2754 228.373 9.20863 228.373 7.82101C228.373 6.43339 229.368 5.36661 230.827 5.36661C232.199 5.36661 233.178 6.44943 233.178 7.82101C233.178 7.99747 233.162 8.15789 233.129 8.31029H229.624C229.793 8.91988 230.306 9.18457 230.932 9.18457V9.19259ZM231.966 7.38788C231.814 6.72214 231.317 6.44943 230.811 6.44943C230.17 6.44943 229.737 6.79433 229.592 7.38788H231.958H231.966Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M240.893 7.28361V10.1471H239.698V7.37184C239.698 6.82641 239.417 6.48954 238.92 6.48954C238.39 6.48954 238.054 6.84246 238.054 7.54028V10.1471H236.858V7.37184C236.858 6.82641 236.578 6.48954 236.08 6.48954C235.583 6.48954 235.206 6.84246 235.206 7.54028V10.1471H234.011V5.50296H235.206V5.99224C235.463 5.59921 235.904 5.36661 236.497 5.36661C237.091 5.36661 237.5 5.60724 237.765 6.03234C238.054 5.61526 238.519 5.36661 239.152 5.36661C240.211 5.36661 240.909 6.12057 240.909 7.28361H240.893Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M246.885 7.82109C246.885 9.20871 245.866 10.2755 244.615 10.2755C243.933 10.2755 243.444 10.0268 243.107 9.59372V12H241.912V5.49503H243.107V6.04045C243.444 5.61534 243.933 5.35867 244.615 5.35867C245.858 5.35867 246.885 6.42546 246.885 7.81307V7.82109ZM245.682 7.82109C245.682 7.04307 245.136 6.51369 244.39 6.51369C243.644 6.51369 243.107 7.04307 243.107 7.82109C243.107 8.59912 243.652 9.1285 244.39 9.1285C245.128 9.1285 245.682 8.59912 245.682 7.82109Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M250.335 5.4075V6.74699C249.709 6.67481 248.923 6.94752 248.923 7.92607V10.1479H247.728V5.50375H248.923V6.30584C249.164 5.67219 249.749 5.41552 250.335 5.41552V5.4075Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M253.174 9.19259C253.639 9.19259 254.008 9.00008 254.217 8.72737L255.179 9.28082C254.746 9.91447 254.048 10.2754 253.158 10.2754C251.594 10.2754 250.615 9.20863 250.615 7.82101C250.615 6.43339 251.61 5.36661 253.07 5.36661C254.441 5.36661 255.42 6.44943 255.42 7.82101C255.42 7.99747 255.404 8.15789 255.372 8.31029H251.867C252.035 8.91988 252.549 9.18457 253.174 9.18457V9.19259ZM254.217 7.38788C254.064 6.72214 253.567 6.44943 253.062 6.44943C252.42 6.44943 251.987 6.79433 251.843 7.38788H254.209H254.217Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M259.566 8.79154C259.566 9.79415 258.691 10.2754 257.697 10.2754C256.766 10.2754 256.076 9.88239 255.748 9.16852L256.79 8.583C256.919 8.95998 257.239 9.18457 257.705 9.18457C258.082 9.18457 258.346 9.05623 258.346 8.78352C258.346 8.10174 255.948 8.47872 255.948 6.84246C255.948 5.89599 256.758 5.36661 257.713 5.36661C258.467 5.36661 259.116 5.71151 259.477 6.35318L258.459 6.91465C258.322 6.61787 258.058 6.44141 257.713 6.44141C257.416 6.44141 257.175 6.56975 257.175 6.81839C257.175 7.50819 259.574 7.07506 259.574 8.79154H259.566Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M264.996 5.50407V10.1482H263.801V9.60276C263.464 10.0198 262.967 10.2845 262.285 10.2845C261.05 10.2845 260.031 9.21775 260.031 7.83013C260.031 6.44251 261.05 5.37573 262.285 5.37573C262.967 5.37573 263.464 5.6324 263.801 6.05751V5.51209H264.996V5.50407ZM263.801 7.82211C263.801 7.04408 263.255 6.5147 262.509 6.5147C261.764 6.5147 261.226 7.04408 261.226 7.82211C261.226 8.60014 261.772 9.12952 262.509 9.12952C263.247 9.12952 263.801 8.60014 263.801 7.82211Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M275.766 12.377C274.022 12.377 272.529 11.774 271.3 10.5859C270.082 9.40373 269.449 7.94095 269.449 6.2513C269.449 4.56165 270.064 3.09888 271.3 1.90478C272.518 0.710676 274.022 0.101685 275.766 0.101685C276.995 0.101685 278.148 0.436033 279.169 1.07488C280.19 1.71372 280.972 2.57944 281.479 3.62428L281.563 3.79146H279.443L279.408 3.74369C279.007 3.17649 278.47 2.72274 277.831 2.39436C277.192 2.06598 276.494 1.89881 275.76 1.89881C274.53 1.89881 273.473 2.32271 272.607 3.17649C271.741 4.01833 271.306 5.06317 271.306 6.24533C271.306 7.42749 271.741 8.47233 272.619 9.31417C273.485 10.156 274.554 10.5799 275.771 10.5799C276.506 10.5799 277.204 10.4127 277.843 10.0844C278.482 9.75002 279.013 9.30223 279.419 8.73503L279.455 8.68727H281.575L281.491 8.85444C280.984 9.91122 280.202 10.765 279.181 11.4038C278.16 12.0427 277.013 12.377 275.777 12.377L275.766 12.389V12.377Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M290.859 12.3772L289.593 9.16503H284.578L283.312 12.3772H281.324L286.19 0.101807H287.969L292.841 12.3772H290.853H290.865H290.859ZM288.763 7.37985L286.972 2.87809L285.181 7.37985H288.757H288.763Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M300.388 12.3772L298.232 7.6724H295.742V12.3772H293.892V0.101807H298.847C299.916 0.101807 300.847 0.483919 301.605 1.21829C302.364 1.95266 302.758 2.85421 302.758 3.89905C302.758 4.717 302.495 5.47526 301.988 6.13798C301.504 6.76489 300.883 7.21865 300.149 7.46344L302.4 12.3712H300.376L300.388 12.3831V12.3772ZM298.847 5.88722C299.414 5.88722 299.892 5.69617 300.304 5.29614C300.704 4.90806 300.907 4.43042 300.907 3.89905C300.907 3.36767 300.704 2.87809 300.304 2.49001C299.904 2.10192 299.426 1.89893 298.847 1.89893H295.742V5.88125H298.847V5.89319V5.88722Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M313.033 12.3772C311.29 12.3772 309.797 11.7741 308.567 10.586C307.349 9.40385 306.716 7.94108 306.716 6.25142C306.716 4.56177 307.331 3.099 308.567 1.9049C309.785 0.710798 311.29 0.101807 313.033 0.101807C314.335 0.101807 315.535 0.460037 316.597 1.17053C317.654 1.88102 318.436 2.81838 318.908 3.95278L318.98 4.10801H316.944L316.908 4.04831C316.508 3.39752 315.959 2.87809 315.272 2.4721C314.597 2.08401 313.839 1.88102 313.033 1.88102C311.803 1.88102 310.746 2.30492 309.881 3.1587C309.015 4.00054 308.579 5.04538 308.579 6.22754C308.579 7.4097 309.015 8.45454 309.881 9.29638C310.746 10.1382 311.815 10.5621 313.033 10.5621C313.923 10.5621 314.753 10.3233 315.487 9.85164C316.174 9.41579 316.693 8.83068 317.051 8.13213H312.914V6.34098H319.35V6.46039C319.278 8.09631 318.639 9.50535 317.415 10.6457C316.209 11.7861 314.723 12.3652 313.033 12.3652V12.3772Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M320.556 12.3771V7.55289C320.556 6.22744 321.04 5.07514 322.001 4.13777C322.962 3.2004 324.145 2.72873 325.506 2.72873H325.625V4.51988H325.506C324.652 4.51988 323.906 4.8184 323.315 5.40948C322.712 6.00056 322.401 6.72299 322.401 7.55289V12.3771H320.55H320.556Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M330.652 12.3771C329.291 12.3771 328.103 11.9054 327.148 10.968C326.175 10.0307 325.691 8.88432 325.691 7.55289C325.691 6.22147 326.175 5.07514 327.148 4.13777C328.121 3.2004 329.291 2.72873 330.652 2.72873C332.014 2.72873 333.202 3.2004 334.157 4.13777C335.13 5.07514 335.614 6.22147 335.614 7.55289C335.614 8.88432 335.13 10.0307 334.157 10.968C333.184 11.9054 332.014 12.3771 330.652 12.3771ZM330.652 4.52585C329.799 4.52585 329.052 4.82437 328.449 5.41545C327.846 6.00653 327.536 6.72897 327.536 7.55887C327.536 8.38876 327.846 9.1112 328.449 9.69033C329.052 10.2695 329.799 10.5799 330.652 10.5799C331.506 10.5799 332.252 10.2814 332.856 9.69033C333.459 9.1112 333.769 8.38876 333.769 7.55887C333.769 6.72897 333.459 6.00653 332.856 5.41545C332.252 4.82437 331.506 4.52585 330.652 4.52585Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M340.557 12.3763C339.488 12.3763 338.569 11.9942 337.811 11.2479C337.052 10.5016 336.658 9.61197 336.658 8.59102V2.72202H338.509V8.59699C338.509 9.12836 338.712 9.606 339.112 9.98214C339.512 10.3702 340.002 10.5613 340.545 10.5613C341.088 10.5613 341.59 10.3702 341.978 9.98214C342.378 9.60003 342.581 9.12836 342.581 8.59699V2.72202H344.432V8.59699C344.432 9.62989 344.05 10.5314 343.279 11.2658C342.521 12.0002 341.596 12.3823 340.533 12.3823H340.557V12.3763Z',
      fill: 'white'
    }), jsxRuntime.jsx("path", {
      d: 'M345.668 16.09V7.53424C345.668 6.20879 346.152 5.05648 347.125 4.13105C348.098 3.19369 349.269 2.72202 350.63 2.72202C351.991 2.72202 353.179 3.19369 354.134 4.13105C355.108 5.06842 355.591 6.21476 355.591 7.53424C355.591 8.85372 355.108 10.0239 354.134 10.9613C353.161 11.8987 351.991 12.3703 350.63 12.3703C349.46 12.3703 348.403 12.0121 347.513 11.3016V16.09H345.662H345.668ZM350.63 4.52511C349.776 4.52511 349.03 4.82363 348.427 5.40277C347.824 5.98191 347.513 6.70434 347.513 7.53424C347.513 8.36414 347.824 9.08657 348.427 9.67765C349.03 10.2687 349.776 10.5673 350.63 10.5673C351.484 10.5673 352.23 10.2687 352.833 9.67765C353.436 9.08657 353.746 8.36414 353.746 7.53424C353.746 6.70434 353.436 5.98191 352.833 5.40277C352.23 4.82363 351.484 4.52511 350.63 4.52511Z',
      fill: 'white'
    })]
  }));
}

function getYear() {
  var today = new Date();
  var year = today.getFullYear();
  return year;
}

function useFooterController(_ref) {
  var links = _ref.links,
    isMobile = _ref.isMobile;
  var collapseBodyRef = react.useRef({});
  var defineCollapseStatus = react.useMemo(function () {
    var collStatusObj = {};
    links.forEach(function (arrGroup) {
      arrGroup.forEach(function (category) {
        collStatusObj[category.text] = isMobile;
      });
    });
    return collStatusObj;
  }, [isMobile, links]);
  var _useState = react.useState(defineCollapseStatus),
    collapseStatus = _useState[0],
    setCollapseStatus = _useState[1];
  react.useEffect(function () {
    Object.keys(collapseBodyRef.current).forEach(function (collKey) {
      if (collapseBodyRef.current[collKey]) {
        collapseBodyRef.current[collKey].style.transition = '';
        if (!isMobile) return;
        setTimeout(function () {
          if (collapseBodyRef.current[collKey]) {
            collapseBodyRef.current[collKey].style.transition = 'height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms';
          }
        }, 300);
      }
    });
  }, [isMobile]);
  react.useEffect(function () {
    setCollapseStatus(defineCollapseStatus);
  }, [defineCollapseStatus]);
  react.useEffect(function () {
    Object.keys(collapseStatus).forEach(function (collKey) {
      var ref = collapseBodyRef.current[collKey];
      var height = ref.scrollHeight;
      if (!isMobile) {
        ref.style.height = 'auto';
      } else {
        ref.style.height = collapseStatus[collKey] ? 0 : height + "px";
      }
    });
  }, [collapseStatus, isMobile]);
  function createLkidUrl(path, lkid, redirectTo, inst) {
    var splittedUrl = path.split('/');
    var checkQuestionMark = splittedUrl[splittedUrl.length - 1].includes('?');
    var marker = checkQuestionMark ? '&' : '?';
    var redirect = redirectTo ? "&r=" + redirectTo : '';
    var lkidQueryString = lkid ? "lkid=" + lkid : '';
    var instQueryString = inst ? "&inst=" + inst : '';
    return "" + path + marker + lkidQueryString + instQueryString + redirect;
  }
  function handleCollapse(collapseId) {
    if (!isMobile) return;
    setCollapseStatus(function (prevState) {
      var collapseStatusClone = _extends({}, prevState);
      Object.keys(collapseStatusClone).forEach(function (collKey) {
        collapseStatusClone[collKey] = collKey !== collapseId ? true : !collapseStatus[collapseId];
      });
      return collapseStatusClone;
    });
  }
  function getTag(tag) {
    if (tag === void 0) {
      tag = 'p';
    }
    return tag;
  }
  return {
    createLkidUrl: createLkidUrl,
    handleCollapse: handleCollapse,
    collapseStatus: collapseStatus,
    collapseBodyRef: collapseBodyRef,
    getTag: getTag
  };
}

var styles$5 = {"footerHelpBar":"_H8Ehc","footerHelpBarHighlight":"_WqSDM","footerContainer":"_e3lXT","footerLinks":"_KuEVP","footerItem":"_VSpv2","footerItemText":"_-EIoR","footerLink":"_NROch","footerTag":"_SQJtg","footerCategoryGroup":"_dnkm6","footerCategoryContainer":"_UatzY","footerCategoryTitleContainer":"_m5RqT","arrowDownIcon":"_HqtJr","arrowUpIcon":"_HfHWX","footerCollapseBody":"_NiXq-","footerLogoWrapper":"_QXNST","footerLogoText":"_WQFmX","footerLogo":"_Pzt9N","footerCopyright":"_qV8Eu"};

var _excluded$1 = ["links", "callCookies", "isMobile"];
function getFooterLinks$1(links) {
  var subscriptionValue = getLocalStorageItem('solucoes-wm_assinatura');
  if (subscriptionValue !== 'B') {
    return links.map(function (link) {
      return link.filter(function (_ref) {
        var text = _ref.text;
        return text !== 'Assinar';
      });
    });
  }
  return links;
}
function Footer(_ref2) {
  var links = _ref2.links,
    _ref2$callCookies = _ref2.callCookies,
    callCookies = _ref2$callCookies === void 0 ? function () {
      return null;
    } : _ref2$callCookies,
    isMobile = _ref2.isMobile,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded$1);
  var _useState = react.useState(getFooterLinks$1(links)),
    footerLinks = _useState[0],
    setFooterLinks = _useState[1];
  react.useEffect(function () {
    function getLinks() {
      setFooterLinks(getFooterLinks$1(links));
    }
    window__default["default"].addEventListener('@subscription::ABTest', getLinks);
    return function () {
      window__default["default"].removeEventListener('@subscription::ABTest', getLinks);
    };
  }, [links]);
  var _useFooterController = useFooterController({
      links: footerLinks,
      isMobile: isMobile
    }),
    createLkidUrl = _useFooterController.createLkidUrl,
    handleCollapse = _useFooterController.handleCollapse,
    collapseStatus = _useFooterController.collapseStatus,
    collapseBodyRef = _useFooterController.collapseBodyRef,
    getTag = _useFooterController.getTag;
  return jsxRuntime.jsxs("footer", _extends({
    "data-testid": "footer-" + (isMobile ? 'mobile' : 'desktop')
  }, rest, {
    children: [jsxRuntime.jsx("div", {
      className: styles$5.footerContainer,
      children: jsxRuntime.jsx("nav", {
        className: styles$5.footerLinks,
        children: footerLinks.map(function (footerLinkCol, footerLinkIndex) {
          return jsxRuntime.jsx("div", {
            className: styles$5.footerCategoryGroup,
            children: footerLinkCol.map(function (_ref3) {
              var id = _ref3.id,
                dataQa = _ref3.data_qa,
                text = _ref3.text,
                items = _ref3.items,
                tag = _ref3.tag;
              var TitleTag = getTag(tag);
              return jsxRuntime.jsxs("div", {
                className: styles$5.footerCategoryContainer,
                children: [jsxRuntime.jsxs("div", {
                  "data-testid": 'footer-category',
                  className: styles$5.footerCategoryTitleContainer,
                  onClick: function onClick() {
                    return handleCollapse(text);
                  },
                  children: [jsxRuntime.jsx(TitleTag, {
                    id: id,
                    "data-qa": dataQa,
                    className: styles$5.footerTag,
                    children: text
                  }), isMobile && jsxRuntime.jsx(ArrowDownIcon, {
                    className: (styles$5.arrowDownIcon + " " + (!collapseStatus[text] ? styles$5.arrowUpIcon : '')).trim(),
                    width: 10
                  })]
                }), jsxRuntime.jsx("ul", {
                  "data-testid": "footer-" + (collapseStatus[text] ? 'collapsed' : 'expanded') + "-body",
                  "data-collapsed": collapseStatus[text],
                  ref: function ref(el) {
                    return collapseBodyRef.current[text] = el;
                  },
                  className: styles$5.footerCollapseBody,
                  children: items.map(function (_ref4) {
                    var id = _ref4.id,
                      dataQa = _ref4.data_qa,
                      href = _ref4.href,
                      redirectTo = _ref4.redirectTo,
                      lkid = _ref4.lkid,
                      text = _ref4.text,
                      callCookie = _ref4.callCookie,
                      attributes = _ref4.attributes,
                      tag = _ref4.tag;
                    var LinkTag = getTag(tag);
                    return jsxRuntime.jsx("li", {
                      className: styles$5.footerItem,
                      children: jsxRuntime.jsx("a", _extends({
                        "data-testid": "footer-" + (callCookie ? 'call-cookie' : 'link'),
                        id: id,
                        "data-qa": dataQa,
                        href: lkid ? createLkidUrl(href, lkid, redirectTo) : href
                      }, attributes, {
                        title: text,
                        onClick: function onClick(event) {
                          return callCookie && callCookies(event);
                        },
                        className: styles$5.footerLink,
                        children: jsxRuntime.jsx(LinkTag, {
                          className: styles$5.footerItemText,
                          children: text
                        })
                      }))
                    }, id);
                  })
                })]
              }, id);
            })
          }, footerLinkIndex);
        })
      })
    }), jsxRuntime.jsx("div", {
      className: styles$5.footerLogoWrapper,
      children: jsxRuntime.jsx(Assinatura, {
        className: styles$5.footerLogo
      })
    }), jsxRuntime.jsx("p", {
      className: styles$5.footerCopyright,
      children: "\xA9 1995-" + getYear() + " Webmotors S.A. CNPJ: 03.347.828/0001-09 Todos os direitos reservados."
    })]
  }));
}

var styles$4 = {"portal":"_ZwJCm","container":"_e3qOG","arrow":"_A5Dcs","boxClose":"_73yYL","text":"_tdMam","btnLogin":"_Uzp5T","register":"_odNfY"};

function LoginPopover(_ref) {
  var isOpen = _ref.isOpen,
    close = _ref.close,
    baseUrl = _ref.url,
    user = _ref.user;
  var isMobile = !useMediaQuery('(min-width: 900px)');
  if (!isOpen || user || isMobile) {
    return null;
  }
  var currentLocation = typeof window__default["default"] !== 'undefined' ? encodeURIComponent(window__default["default"].location) : '';
  return jsxRuntime.jsx("div", {
    className: styles$4.portal,
    children: jsxRuntime.jsxs("div", {
      className: styles$4.container,
      children: [jsxRuntime.jsx("div", {
        className: styles$4.arrow
      }), jsxRuntime.jsx("div", {
        className: styles$4.boxClose,
        "data-qa": 'login-popover-close-btn',
        onClick: close,
        children: jsxRuntime.jsx(Icon, {
          width: 10,
          height: 10,
          viewBox: '0 0 11 11',
          title: 'Fechar',
          name: 'CLOSE'
        })
      }), jsxRuntime.jsxs("p", {
        className: styles$4.text,
        children: ["Fa\xE7a login para uma experi\xEAncia ainda melhor! ;", ')']
      }), jsxRuntime.jsx("a", {
        href: baseUrl + "login?lkid=1364&r=" + currentLocation,
        target: '_self',
        rel: 'noopener',
        children: jsxRuntime.jsx("button", {
          className: styles$4.btnLogin,
          "data-qa": 'login-popover-button',
          children: "Fazer login"
        })
      }), jsxRuntime.jsxs("p", {
        className: styles$4.text,
        children: ["N\xE3o tem uma conta?", jsxRuntime.jsx("a", {
          className: styles$4.register,
          href: baseUrl + "login/register?r=" + currentLocation,
          target: '_self',
          rel: 'noopener',
          children: "Criar conta"
        })]
      })]
    })
  });
}

var styles$3 = {"navbar":"_hd47T","brand":"_IVZOj","section":"_vZ8Tq","menu":"_uM8yM","menuItem":"_MXDLK","btnGroupButton":"_peqSI","menuDropDown":"_OES6H","menuDropDownItem":"_g3gMC","menuDropDownIcon":"_Tw51m","btnGroup":"_L7wQQ","badge":"_JqV30","btnMobileButton":"_QEUTH","btnDesktopButton":"_GSpZM","icon":"_eayYE","notification":"_MIfCm","customNotification":"_cVar-","customBadge":"_kiuiG"};

function DropDown(_ref) {
  var links = _ref.links;
  if (!links) {
    return null;
  }
  var dispatchEvent = function dispatchEvent() {
    if (typeof window__default["default"] !== 'undefined') {
      localStorage.setItem('isHoverMenuDesktop', JSON.stringify(false));
      var event = new CustomEvent('customEventDesktop', {
        detail: false
      });
      window__default["default"].dispatchEvent(event);
    }
  };
  return jsxRuntime.jsx("ul", {
    className: styles$3.menuDropDown,
    children: links.map(function (dropDownLink, idx) {
      return jsxRuntime.jsx("li", _extends({}, (dropDownLink == null ? void 0 : dropDownLink.props) || {}, {
        children: dropDownLink.href ? jsxRuntime.jsxs("a", {
          href: dropDownLink.href,
          target: (dropDownLink == null ? void 0 : dropDownLink.target) || '_blank',
          rel: 'noreferrer',
          className: styles$3.menuDropDownItem,
          onMouseEnter: function onMouseEnter() {
            return dropDownLink.label === 'Webmotors Serviços' ? dispatchEvent() : null;
          },
          children: [(dropDownLink == null ? void 0 : dropDownLink.icon) && jsxRuntime.jsx(Icon, {
            name: dropDownLink.icon,
            className: styles$3.menuDropDownIcon,
            width: 25,
            height: 22
          }), dropDownLink == null ? void 0 : dropDownLink.label, dropDownLink.label === 'Webmotors Serviços' ? jsxRuntime.jsx("span", {
            className: styles$3.customBadge,
            children: "NOVO"
          }) : null]
        }) : jsxRuntime.jsxs("span", {
          className: styles$3.menuDropDownItem,
          children: [(dropDownLink == null ? void 0 : dropDownLink.icon) && jsxRuntime.jsx(Icon, {
            name: dropDownLink.icon,
            className: styles$3.menuDropDownIcon,
            width: 25,
            height: 22
          }), dropDownLink == null ? void 0 : dropDownLink.label]
        })
      }), idx);
    })
  });
}

exports.MenuPlacement = void 0;
(function (MenuPlacement) {
  MenuPlacement["CENTER"] = "center";
  MenuPlacement["RIGHT"] = "right";
  MenuPlacement["LEFT"] = "left";
})(exports.MenuPlacement || (exports.MenuPlacement = {}));
exports.ViewPort = void 0;
(function (ViewPort) {
  ViewPort["MOBILE"] = "mobile";
  ViewPort["DESKTOP"] = "desktop";
})(exports.ViewPort || (exports.ViewPort = {}));

function getNavLinks(links) {
  var subscriptionValue = getLocalStorageItem('solucoes-wm_assinatura');
  if (subscriptionValue !== 'B') {
    return links.filter(function (link) {
      return link.label !== 'Assinar';
    });
  }
  return links;
}
function useNavbarController(_ref) {
  var links = _ref.links;
  var _useState = react.useState(getNavLinks(links)),
    navLinks = _useState[0],
    setNavLinks = _useState[1];
  react.useEffect(function () {
    function getLinks() {
      setNavLinks(getNavLinks(links));
    }
    window__default["default"].addEventListener('@subscription::ABTest', getLinks);
    return function () {
      window__default["default"].removeEventListener('@subscription::ABTest', getLinks);
    };
  }, [links]);
  var centerLinks = react.useMemo(function () {
    return navLinks.filter(function (link) {
      return (link == null ? void 0 : link.placement) === exports.MenuPlacement.CENTER;
    });
  }, [navLinks]);
  var rightLinks = react.useMemo(function () {
    return links.filter(function (link) {
      return (link == null ? void 0 : link.placement) === exports.MenuPlacement.RIGHT;
    });
  }, [links]);
  function getViewportStyles(viewport, defaultStyles) {
    if (defaultStyles === void 0) {
      defaultStyles = '';
    }
    return viewport ? (viewport === exports.ViewPort.DESKTOP && styles$3.btnDesktopButton) + " " + (viewport === exports.ViewPort.MOBILE && styles$3.btnMobileButton) + " " + defaultStyles : defaultStyles;
  }
  var wasPopoverClosedTimestamp = typeof window__default["default"] !== 'undefined' && window__default["default"].localStorage ? Number.parseInt(window__default["default"].localStorage.getItem('loginPopoverClosed') || '0', 10) : 0;
  var thresholdInMilliseconds = 15 * 60 * 1000;
  var wasPopoverClosed = Date.now() - wasPopoverClosedTimestamp < thresholdInMilliseconds;
  var popover = usePopover(!wasPopoverClosed);
  function handleMenuClick() {}
  var triggered = react.useRef(false);
  react.useEffect(function () {
    if (triggered.current || popover.isClose) {
      return;
    }
    var timeOutPopover = setTimeout(function () {
      popover.open();
    }, 5000);
    triggered.current = true;
    return function () {
      triggered.current = false;
      clearTimeout(timeOutPopover);
    };
  }, [popover]);
  return {
    getViewportStyles: getViewportStyles,
    handleMenuClick: handleMenuClick,
    centerLinks: centerLinks,
    rightLinks: rightLinks,
    popover: popover
  };
}

function Navbar(props) {
  var _useNavbarController = useNavbarController(props),
    getViewportStyles = _useNavbarController.getViewportStyles,
    rightLinks = _useNavbarController.rightLinks,
    centerLinks = _useNavbarController.centerLinks,
    popover = _useNavbarController.popover;
  var url = props.url,
    user = props.user,
    showNotification = props.showNotification;
  var _useDrawerMenu = useDrawerMenu(),
    open = _useDrawerMenu.open;
  var _useLocalStorageState = useLocalStorageState('isClickedMobileMenu', true),
    isClickedMobileMenu = _useLocalStorageState[0],
    setIsClickedMobileMenu = _useLocalStorageState[1];
  var _useLocalStorageState2 = useLocalStorageState('isHoverMenuDesktop', true),
    isHoverDesktopMenu = _useLocalStorageState2[0],
    setIsHoverDesktopMenu = _useLocalStorageState2[1];
  react.useEffect(function () {
    if (typeof window__default["default"] === 'undefined') return;
    var handleCustomEventDesktop = function handleCustomEventDesktop(event) {
      setIsHoverDesktopMenu(event.detail);
    };
    window__default["default"].addEventListener('customEventDesktop', handleCustomEventDesktop);
    return function () {
      window__default["default"].removeEventListener('customEventDesktop', handleCustomEventDesktop);
    };
  }, [setIsHoverDesktopMenu]);
  react.useEffect(function () {
    if (typeof window__default["default"] === 'undefined') return;
    var handleCustomEventMobile = function handleCustomEventMobile(event) {
      setIsClickedMobileMenu(event.detail);
    };
    window__default["default"].addEventListener('customEventMobile', handleCustomEventMobile);
    return function () {
      window__default["default"].removeEventListener('customEventMobile', handleCustomEventMobile);
    };
  }, [setIsClickedMobileMenu]);
  return jsxRuntime.jsxs("div", {
    className: styles$3.navbar,
    children: [jsxRuntime.jsx("div", {
      className: styles$3.brand,
      children: jsxRuntime.jsx("a", {
        href: url,
        children: jsxRuntime.jsx(SvgLogo, {
          width: 145,
          height: 28
        })
      })
    }), jsxRuntime.jsx("div", {
      className: styles$3.section,
      children: jsxRuntime.jsx("ul", {
        className: styles$3.menu,
        children: centerLinks.map(function (link, idx) {
          var _link$props;
          return jsxRuntime.jsxs("li", _extends({
            className: styles$3.menuItem
          }, (_link$props = link == null ? void 0 : link.props) != null ? _link$props : {}, {
            children: [link.label, link.label === 'Serviços' && jsxRuntime.jsx("span", {
              className: isHoverDesktopMenu ? styles$3.customNotification : ''
            }), (link == null ? void 0 : link.isNew) && jsxRuntime.jsx("span", {
              className: styles$3.customBadge,
              children: "NOVO"
            }), jsxRuntime.jsx(DropDown, {
              links: link.links
            })]
          }), idx);
        })
      })
    }), jsxRuntime.jsxs("div", {
      className: styles$3.section,
      children: [jsxRuntime.jsx(LoginPopover, _extends({
        url: url,
        user: user
      }, popover)), jsxRuntime.jsxs("ul", {
        className: styles$3.btnGroup,
        children: [rightLinks.map(function (link, idx) {
          var _link$props2, _link$target, _link$accessibility;
          return jsxRuntime.jsxs("li", _extends({
            className: getViewportStyles(link.viewport)
          }, (_link$props2 = link == null ? void 0 : link.props) != null ? _link$props2 : {}, {
            children: [(link == null ? void 0 : link.href) && jsxRuntime.jsxs("a", _extends({
              href: link.href,
              target: (_link$target = link == null ? void 0 : link.target) != null ? _link$target : '_blank',
              rel: 'noreferrer',
              className: styles$3.btnGroupButton
            }, (_link$accessibility = link == null ? void 0 : link.accessibility) != null ? _link$accessibility : {}, {
              children: [link.icon && jsxRuntime.jsx(Icon, {
                name: link.icon,
                className: styles$3.icon
              }), link == null ? void 0 : link.label, (link == null ? void 0 : link.badge) && jsxRuntime.jsx("div", {
                className: styles$3.badge,
                children: link.badge
              }), jsxRuntime.jsx(DropDown, {
                links: link.links
              })]
            })), !(link != null && link.href) && jsxRuntime.jsxs("span", {
              className: styles$3.btnGroupButton,
              children: [link.icon && jsxRuntime.jsx(Icon, {
                name: link.icon,
                className: styles$3.icon
              }), link == null ? void 0 : link.label, (link == null ? void 0 : link.badge) && jsxRuntime.jsx("div", {
                className: styles$3.badge,
                children: link.badge
              }), jsxRuntime.jsx(DropDown, {
                links: link.links
              })]
            })]
          }), idx);
        }), jsxRuntime.jsxs("li", {
          className: styles$3.btnGroupButton + " " + styles$3.btnMobileButton,
          "data-qa": 'header_btn_toggleDrawer',
          id: 'header_btn_toggleDrawer',
          onClick: function onClick() {
            return open();
          },
          children: [jsxRuntime.jsx(Icon, {
            name: 'MENU',
            className: styles$3.icon
          }), (showNotification && !user || isClickedMobileMenu) && jsxRuntime.jsx("span", {
            className: styles$3.notification
          })]
        })]
      })]
    })]
  });
}

var ArrowLeftIcon = function ArrowLeftIcon() {
  return jsxRuntime.jsx("svg", {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    children: jsxRuntime.jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.2933 17.7072L8.29325 12.7073C7.90225 12.3163 7.90225 11.6842 8.29325 11.2933L13.2933 6.29325C13.6842 5.90225 14.3163 5.90225 14.7073 6.29325C15.0982 6.68425 15.0982 7.31625 14.7073 7.70725L10.4142 12.0002L14.7073 16.2933C15.0982 16.6842 15.0982 17.3162 14.7073 17.7072C14.5122 17.9022 14.2562 18.0002 14.0002 18.0002C13.7442 18.0002 13.4883 17.9022 13.2933 17.7072Z',
      fill: '#2E2D37'
    })
  });
};

var ArrowRightIcon = function ArrowRightIcon() {
  return jsxRuntime.jsx("svg", {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    children: jsxRuntime.jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.7073 17.7072L15.7073 12.7073C16.0983 12.3163 16.0983 11.6842 15.7073 11.2933L10.7073 6.29325C10.3163 5.90225 9.68425 5.90225 9.29325 6.29325C8.90225 6.68425 8.90225 7.31625 9.29325 7.70725L13.5863 12.0002L9.29325 16.2933C8.90225 16.6842 8.90225 17.3162 9.29325 17.7072C9.48825 17.9022 9.74425 18.0002 10.0003 18.0002C10.2563 18.0002 10.5123 17.9022 10.7073 17.7072Z',
      fill: '#2E2D37'
    })
  });
};

var styles$2 = {"paginationWrapper":"_jl79y","arrow":"_HKTzw","ellipsis":"_sGBgr","pageItem":"_fhIZU","current":"_xi85o","paginationNumbers":"_Orc4I"};

var PaginationItem = function PaginationItem(_ref) {
  var _ref$isCurrent = _ref.isCurrent,
    isCurrent = _ref$isCurrent === void 0 ? false : _ref$isCurrent,
    number = _ref.number,
    onPageChange = _ref.onPageChange;
  var pageItemClass = styles$2.pageItem + " " + (isCurrent ? styles$2.current : '');
  return jsxRuntime.jsx("button", {
    className: pageItemClass,
    onClick: function onClick() {
      return !isCurrent && onPageChange(number);
    },
    "data-testid": 'page-number',
    type: 'button',
    children: number
  });
};

var _excluded = ["pagesCount", "currentPage", "onPageChange", "dataQA", "variant"];
function generatePagesArray(from, to) {
  return Array.from({
    length: to - from + 1
  }, function (_, index) {
    return from + index;
  }).filter(function (page) {
    return page > 0;
  });
}
var Pagination = function Pagination(_ref) {
  var _ref$pagesCount = _ref.pagesCount,
    pagesCount = _ref$pagesCount === void 0 ? 1 : _ref$pagesCount,
    _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
    onPageChange = _ref.onPageChange,
    _ref$dataQA = _ref.dataQA,
    dataQA = _ref$dataQA === void 0 ? 'pagination-ds' : _ref$dataQA,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var maxVisiblePages = 6;
  var _useState = react.useState(maxVisiblePages),
    lastVisiblePage = _useState[0],
    setLastVisiblePage = _useState[1];
  var visiblePages = react.useMemo(function () {
    var start = Math.max(lastVisiblePage - 4, 1);
    var end = Math.min(lastVisiblePage, pagesCount);
    return generatePagesArray(start, end);
  }, [lastVisiblePage, pagesCount]);
  var handlePageChange = function handlePageChange(page) {
    if (page === lastVisiblePage && lastVisiblePage < pagesCount) {
      setLastVisiblePage(function (prev) {
        return Math.min(prev + 2, pagesCount);
      });
    }
    if (page === 1) {
      setLastVisiblePage(maxVisiblePages);
    }
    if (page === visiblePages[0]) {
      setLastVisiblePage(function (prev) {
        return Math.max(prev - 2, maxVisiblePages);
      });
    }
    if (page > visiblePages[visiblePages.length - 1]) {
      setLastVisiblePage(page + 2);
    }
    onPageChange(page);
  };
  var isFirstPage = currentPage === 1;
  var isLastPage = currentPage === pagesCount;
  var renderLeftEllipsis = function renderLeftEllipsis() {
    return visiblePages[0] > 1 ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [jsxRuntime.jsx(PaginationItem, {
        onPageChange: handlePageChange,
        number: 1,
        isCurrent: currentPage === 1
      }), visiblePages[0] > 3 && jsxRuntime.jsx("span", {
        className: styles$2.ellipsis,
        children: "..."
      })]
    }) : null;
  };
  react.useEffect(function () {
    if (currentPage === 1 && pagesCount > 1) {
      setLastVisiblePage(maxVisiblePages);
    }
  }, [currentPage, pagesCount]);
  if (pagesCount <= 1) {
    return null;
  }
  return jsxRuntime.jsxs("div", _extends({
    className: styles$2.paginationWrapper,
    "data-testid": 'pagination-component',
    "data-qa": dataQA
  }, props, {
    children: [jsxRuntime.jsx("button", {
      className: styles$2.arrow,
      disabled: isFirstPage,
      onClick: function onClick() {
        return handlePageChange(Math.max(currentPage - 1, 1));
      },
      "data-testid": 'previous-page',
      type: 'button',
      children: ArrowLeftIcon()
    }), jsxRuntime.jsxs("div", {
      className: styles$2.paginationNumbers,
      children: [renderLeftEllipsis(), visiblePages.map(function (page) {
        return jsxRuntime.jsx(PaginationItem, {
          onPageChange: handlePageChange,
          number: page,
          isCurrent: page === currentPage
        }, page);
      })]
    }), jsxRuntime.jsx("button", {
      className: styles$2.arrow,
      disabled: isLastPage,
      onClick: function onClick() {
        return handlePageChange(Math.min(currentPage + 1, pagesCount));
      },
      "data-testid": 'next-page',
      type: 'button',
      children: ArrowRightIcon()
    })]
  }));
};

/**
 * Get all links used in default navbar menu links
 *
 * @param baseUrl
 * @returns
 */
function linksDatasetFactory(params) {
  var baseUrl = params.baseUrl;
  return {
    BASE: baseUrl,
    COCKPIT: 'https://www.cockpit.com.br/',
    LOGIN: baseUrl + "login",
    REGISTER: baseUrl + "register",
    WM_APP_DOWNLOAD: 'https://app.adjust.com/rfifsh8',
    GARAGE: {
      BASE: baseUrl + "garagem",
      PERFIL: baseUrl + "garagem/perfil",
      PRODUCTS: baseUrl + "garagem/produtos",
      FAVORITES: baseUrl + "garagem/favoritos",
      PROPOSALS: baseUrl + "garagem/propostas"
    },
    INSTITUTIONAL: {
      ALO_ETICA: 'https://aloetica.com.br/otrs/canal-de-etica.pl?CustomerID=webmotors.com.br',
      CONDUCT_CODE: 'https://www.webmotors.com.br/seguranca/assets/files/codigo-de-conduta.pdf',
      SUPPLIER_CONDUCT_CODE: 'https://www.webmotors.com.br/seguranca/assets/files/codigo-conduta-fornecedores.pdf',
      CONSUMER: 'https://cdn.webmotors.com.br/webmotors/content/pdf/cdc.pdf?v:32673',
      PRIVACY: 'https://www.webmotors.com.br/seguranca/politica-de-privacidade',
      LGPD: 'https://www.webmotors.com.br/seguranca/lgpd',
      TRANSPARENCY: 'https://www.webmotors.com.br/seguranca/assets/files/relat%C3%B3rio_de_transpar%C3%AAncia_da_portaria_mte_no_3.714.2023.pdf',
      BOOKLETLGPD: 'https://www.webmotors.com.br/seguranca/assets/files/cartilha_lgpd_webmotors.pdf'
    },
    SUBSCRIPTION: baseUrl + "assinatura",
    SERVICES: {
      WEBMOTORS_SERVICES: baseUrl + "solutions/webmotors-servicos/",
      FIPE: baseUrl + "tabela-fipe/",
      FAZTUDO: baseUrl + "vender-carro/faztudo",
      FINANCING: baseUrl + "financiamento",
      CONSORTIUM: baseUrl + "solutions/consorcio",
      DEALER_PLATFORM: 'https://cockpit.com.br/',
      INSURANCE: 'https://www.autocompara.com.br/',
      CAR10: 'https://www.webmotors.com.br/car10',
      AUTOPAGO: 'https://autopago.webmotors.com.br/',
      ADVERTISING: 'https://www.webmotors.com.br/solutions/ads/',
      COMPARE_VEHICLES: 'https://www.webmotors.com.br/catalogo/comparativo-de-carros',
      FINES_AND_DEBTS: 'https://webmotors.usezapay.com.br/',
      CERTIFIED_PURCHASE: 'https://www.webmotors.com.br/compracertificada'
    },
    HELP: {
      YOU: 'https://ajuda.webmotors.com.br/hc/pt-br',
      HOW_TO_BUY: 'https://ajuda.cockpit.com.br/hc/pt-br/',
      HOW_TO_SELL: 'https://ajuda.webmotors.com.br/hc/pt-br/articles/360038764251-como-anunciar-/',
      STORE: 'https://ajuda.cockpit.com.br/hc/pt-br',
      SECURITY: 'https://www.webmotors.com.br/solutions/seguranca',
      PRIVACY_POLICY: 'https://www.webmotors.com.br/assets/termos-de-uso-e-politica-de-privacidade.pdf',
      INSTITUCIONAL: 'https://www.webmotors.com.br/solutions/quemsomos/',
      WORK_WITH_US: 'https://webmotors.gupy.io/',
      SITEMAP: baseUrl + "mapasite"
    },
    WM1: {
      PORTAL: baseUrl + "wm1",
      LASTNEWS: baseUrl + "wm1/noticias",
      TESTS: baseUrl + "wm1/testes",
      COMPARATIVES: baseUrl + "wm1/comparativos",
      VIDEOS: baseUrl + "wm1/videos-de-carros-e-motos",
      BIKES: baseUrl + "wm1/motos",
      SECRETS: baseUrl + "wm1/segredos-auto",
      TIPS: baseUrl + "wm1/dicas",
      POCKET: baseUrl + "wm1/dinheiro-e-economia"
    },
    CAR: {
      ALL: baseUrl + "carros/estoque",
      NEW: baseUrl + "carros-novos/estoque",
      USED: baseUrl + "carros-usados/estoque",
      BY_STATE: baseUrl + "mapasite/carros",
      ZERO: baseUrl + "catalogo",
      SELL: baseUrl + "vender"
    },
    BIKE: {
      NEW: baseUrl + "motos-novas/estoque",
      USED: baseUrl + "motos-usadas/estoque",
      BY_STATE: baseUrl + "mapasite/motos",
      SELL: baseUrl + "vender/moto"
    }
  };
}
/**
 * Get links that appers both on navbar and drawer menu as default
 *
 * @param baseUrl
 * @returns
 */
function defaultLinksFactory(params) {
  var ROUTES = linksDatasetFactory(params);
  var defaultLinks = [{
    label: 'Comprar',
    placement: exports.MenuPlacement.CENTER,
    props: {
      id: 'header_buy',
      'data-qa': 'header_buy'
    },
    links: [{
      icon: 'CAR_USED',
      href: ROUTES.CAR.USED + "?lkid=1000",
      label: 'Carros usados',
      props: {
        id: 'header_buy_car_used',
        'data-qa': 'header_buy_car_used'
      }
    }, {
      icon: 'CAR',
      href: ROUTES.CAR.NEW + "?lkid=1001",
      label: 'Carros novos',
      props: {
        id: 'header_buy_car_new',
        'data-qa': 'header_buy_car_new'
      }
    }, {
      icon: 'BIKE_USED',
      href: ROUTES.BIKE.USED + "?lkid=1002",
      label: 'Motos usadas',
      props: {
        id: 'header_buy_bike_used',
        'data-qa': 'header_buy_bike_used'
      }
    }, {
      icon: 'BIKE',
      href: ROUTES.BIKE.NEW + "?lkid=1003",
      label: 'Motos novas',
      props: {
        id: 'header_buy_bike_new',
        'data-qa': 'header_buy_bike_new'
      }
    }, {
      icon: 'INSPECTED',
      href: ROUTES.CAR.ALL + "?Oportunidades=Vistoriado&lkid=1576",
      label: 'Vistoriado',
      props: {
        id: 'header_buy_inspected',
        'data-qa': 'header_buy_inspected'
      }
    }]
  }, {
    label: 'Vender',
    placement: exports.MenuPlacement.CENTER,
    props: {
      id: 'header_sell',
      'data-qa': 'header_sell'
    },
    links: [{
      icon: 'CAR_SELL',
      href: ROUTES.CAR.SELL + "?lkid=1006",
      label: 'Vender carro',
      props: {
        id: 'header_sell_car',
        'data-qa': 'header_sell_car'
      }
    }, {
      icon: 'BIKE_SELL',
      href: ROUTES.BIKE.SELL + "?lkid=1007",
      label: 'Vender moto',
      props: {
        id: 'header_sell_bike',
        'data-qa': 'header_sell_bike'
      }
    }, {
      icon: 'MANAGE_AD',
      label: 'Gerenciar meu anúncio',
      href: ROUTES.GARAGE.BASE + "?lkid=1009",
      props: {
        id: 'header_sell_manage_ad',
        'data-qa': 'header_sell_manage_ad'
      }
    }, {
      icon: 'DEALER_PLATFORM',
      href: ROUTES.SERVICES.DEALER_PLATFORM + "?lkid=1017",
      label: 'Plataforma revendedores',
      props: {
        id: 'header_sell_dealer_platform',
        'data-qa': 'header_sell_dealer_platform'
      }
    }]
  }, {
    isNew: true,
    label: 'Assinar',
    placement: exports.MenuPlacement.CENTER,
    props: {
      id: 'header_subscription',
      'data-qa': 'header_subscription'
    },
    links: [{
      icon: 'SUBSCRIPTION',
      href: ROUTES.SUBSCRIPTION + "?lkid=3797",
      label: 'Carros por assinatura',
      props: {
        id: 'header_vehicles_subscription',
        'data-qa': 'header_vehicles_subscription'
      }
    }]
  }, {
    label: 'Serviços',
    placement: exports.MenuPlacement.CENTER,
    props: {
      id: 'header_services',
      'data-qa': 'header_services'
    },
    links: [{
      icon: 'WEBMOTORS_SERVICES',
      href: ROUTES.SERVICES.WEBMOTORS_SERVICES + "?lkid=2473",
      label: 'Webmotors Serviços',
      props: {
        id: 'header_webmotors_services',
        'data-qa': 'header_webmotors_services'
      }
    }, {
      icon: 'FIPE',
      href: ROUTES.SERVICES.FIPE + "?lkid=1010",
      label: 'Tabela FIPE e Tabela Webmotors',
      props: {
        id: 'header_services_fipe',
        'data-qa': 'header_services_fipe'
      }
    }, {
      icon: 'FINANCING',
      href: ROUTES.SERVICES.FINANCING + "?lkid=1011",
      label: 'Financiamento',
      props: {
        id: 'header_services_financing',
        'data-qa': 'header_services_financing'
      }
    },
    // {
    //   icon: 'CONSORTIUM',
    //   href: `${ROUTES.SERVICES.CONSORTIUM}?lkid=2301`,
    //   label: 'Consórcio',
    //   props: {
    //     id: 'header_services_consortium',
    //     'data-qa': 'header_services_consortium'
    //   }
    // },
    {
      icon: 'CATALOG_0KM',
      href: ROUTES.CAR.ZERO + "?lkid=1012",
      label: 'Catálogo 0km',
      props: {
        id: 'header_services_catalog_0km',
        'data-qa': 'header_services_catalog_0km'
      }
    }, {
      icon: 'INSPECTED',
      href: ROUTES.COCKPIT + "solutions/vistoriado?lkid=1577",
      label: 'Vistoriado',
      props: {
        id: 'header_services_inspected',
        'data-qa': 'header_services_inspected'
      }
    }, {
      icon: 'DEALER_PLATFORM',
      href: ROUTES.SERVICES.DEALER_PLATFORM + "?lkid=1017",
      label: 'Plataforma revendedores',
      props: {
        id: 'header_services_dealer_platform',
        'data-qa': 'header_services_dealer_platform'
      }
    }, {
      icon: 'INSURANCE',
      href: ROUTES.SERVICES.INSURANCE + "?lkid=1015&utm_source=webmotors&utm_medium=site&utm_campaign=menu_servicos_seguro_veiculo",
      label: 'Seguro veículo',
      props: {
        id: 'header_services_insurance',
        'data-qa': 'header_services_insurance'
      }
    }]
  }, {
    label: 'Notícias WM1',
    placement: exports.MenuPlacement.CENTER,
    props: {
      id: 'header_wm1',
      'data-qa': 'header_wm1'
    },
    links: [{
      icon: 'PORTAL',
      href: ROUTES.WM1.PORTAL + "?lkid=1549",
      label: 'Portal',
      props: {
        id: 'header_wm1_portal',
        'data-qa': 'header_wm1_portal'
      }
    }, {
      icon: 'LASTNEWS',
      href: ROUTES.WM1.LASTNEWS + "?lkid=1550",
      label: 'Últimas notícias',
      props: {
        id: 'header_wm1_lastnews',
        'data-qa': 'header_wm1_lastnews'
      }
    }, {
      icon: 'TESTS',
      href: ROUTES.WM1.TESTS + "?lkid=1551",
      label: 'Testes',
      props: {
        id: 'header_wm1_tests',
        'data-qa': 'header_wm1_tests'
      }
    }, {
      icon: 'COMPARATIVES',
      href: ROUTES.WM1.COMPARATIVES + "?lkid=1552",
      label: 'Comparativos',
      props: {
        id: 'header_wm1_comparativos',
        'data-qa': 'header_wm1_comparativos'
      }
    }, {
      icon: 'VIDEOS',
      href: ROUTES.WM1.VIDEOS + "?lkid=1553",
      label: 'Vídeos',
      props: {
        id: 'header_wm1_videos',
        'data-qa': 'header_wm1_videos'
      }
    }, {
      icon: 'BIKE_USED',
      href: ROUTES.WM1.BIKES + "?lkid=1554",
      label: 'Motos',
      props: {
        id: 'header_wm1_bikes',
        'data-qa': 'header_wm1_bikes'
      }
    }, {
      icon: 'SECRETS',
      href: ROUTES.WM1.SECRETS + "?lkid=1555",
      label: 'Segredos',
      props: {
        id: 'header_wm1_secrets',
        'data-qa': 'header_wm1_secrets'
      }
    }, {
      icon: 'TIPS',
      href: ROUTES.WM1.TIPS + "?lkid=1556",
      label: 'Dicas',
      props: {
        id: 'header_wm1_tips',
        'data-qa': 'header_wm1_tips'
      }
    }, {
      icon: 'POCKET',
      href: ROUTES.WM1.POCKET + "?lkid=1557",
      label: 'Bolso',
      props: {
        id: 'header_wm1_pocket',
        'data-qa': 'header_wm1_pocket'
      }
    }]
  }, {
    label: 'Ajuda',
    placement: exports.MenuPlacement.CENTER,
    props: {
      id: 'header_help',
      'data-qa': 'header_help'
    },
    links: [{
      icon: 'HELP_YOU',
      href: ROUTES.HELP.YOU + "?lkid=1018",
      label: 'Para você',
      props: {
        id: 'header_help_you',
        'data-qa': 'header_help_you'
      }
    }, {
      icon: 'HELP_STORE',
      href: ROUTES.HELP.STORE + "?lkid=1019",
      label: 'Para sua loja',
      props: {
        id: 'header_help_store',
        'data-qa': 'header_help_store'
      }
    }, {
      icon: 'HELP_SECURITY',
      href: ROUTES.HELP.SECURITY + "?lkid=2173",
      label: 'Segurança',
      props: {
        id: 'header_help_security',
        'data-qa': 'header_help_security'
      }
    }]
  }];
  return defaultLinks;
}

function drawerLinksFactory(params) {
  var ROUTES = linksDatasetFactory(params);
  var drawerLinks = [{
    label: 'Minha Garagem',
    props: {
      id: 'header_myGarage',
      'data-qa': 'header_myGarage'
    },
    links: [{
      icon: 'MANAGE_AD',
      href: ROUTES.GARAGE.BASE,
      label: 'Meus anúncios',
      props: {
        id: 'header_myGarage_myAds',
        'data-qa': 'header_myGarage_myAds'
      }
    }, {
      icon: 'EDIT',
      href: ROUTES.GARAGE.PERFIL,
      label: 'Minha conta',
      props: {
        id: 'header_myGarage_myAccount',
        'data-qa': 'header_myGarage_myAccount'
      }
    }, {
      icon: 'FAVORITES',
      href: ROUTES.GARAGE.FAVORITES,
      label: 'Favoritos',
      props: {
        id: 'header_myGarage_favorites',
        'data-qa': 'header_myGarage_favorites'
      }
    }]
  }];
  return params != null && params.user ? drawerLinks : [];
}
function getDrawerLinks(params) {
  var defaulRoutes = defaultLinksFactory(params);
  var drawerLinks = drawerLinksFactory(params);
  return [].concat(drawerLinks, defaulRoutes);
}

var defaultAnchorAttributes = {
  rel: 'noopener',
  target: '_blank'
};

var footerLinksFactory = function footerLinksFactory(params) {
  var ROUTES = linksDatasetFactory(params);
  var footerLinks = [[{
    text: 'Comprar',
    id: 'footer_buy',
    data_qa: 'footer_buy',
    tag: 'p',
    items: [{
      id: 'footer_buy_usedOrNewCars',
      data_qa: 'footer_buy_usedOrNewCars',
      text: 'Carros usados',
      href: ROUTES.CAR.USED,
      lkid: '1075',
      tag: 'h2',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_buy_newCars',
      data_qa: 'footer_buy_newCars',
      text: 'Carros novos',
      href: ROUTES.CAR.NEW,
      lkid: '1076',
      tag: 'h2',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_buy_usedOrNewMotorbikes',
      data_qa: 'footer_buy_usedOrNewMotorbikes',
      text: 'Motos usadas',
      href: ROUTES.BIKE.USED,
      lkid: '1077',
      tag: 'h2',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_buy_newMotorbikes',
      data_qa: 'footer_buy_newMotorbikes',
      text: 'Motos novas',
      href: ROUTES.BIKE.NEW,
      lkid: '1078',
      tag: 'h2',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_buy_inspected',
      data_qa: 'footer_buy_inspected',
      text: 'Vistoriado',
      href: ROUTES.CAR.ALL + "?Oportunidades=Vistoriado",
      lkid: '1578',
      tag: 'h2',
      attributes: _extends({}, defaultAnchorAttributes)
    }]
  }, {
    text: 'Vender',
    id: 'footer_sell',
    data_qa: 'footer_sell',
    tag: 'p',
    items: [{
      id: 'footer_sell_car',
      data_qa: 'footer_sell_car',
      text: 'Vender carro',
      href: ROUTES.CAR.SELL + "/",
      lkid: '1080',
      tag: 'h2',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_sell_bike',
      data_qa: 'footer_sell_bike',
      text: 'Vender moto',
      href: ROUTES.BIKE.SELL,
      lkid: '1081',
      tag: 'h2',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_sell_manage_ad',
      data_qa: 'footer_sell_manage_ad',
      text: 'Gerenciar meu anúncio',
      href: ROUTES.LOGIN,
      redirectTo: ROUTES.GARAGE.BASE,
      lkid: '1082',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_sell_dealer_platform',
      data_qa: 'footer_sell_dealer_platform',
      text: 'Plataforma revendedores',
      href: ROUTES.SERVICES.DEALER_PLATFORM,
      lkid: '1091',
      attributes: _extends({}, defaultAnchorAttributes)
    }]
  }], [{
    text: 'Assinar',
    id: 'footer_subscription',
    data_qa: 'footer_subscription',
    tag: 'h2',
    items: [{
      id: 'footer_vehicles_subscription',
      data_qa: 'footer_vehicles_subscription',
      text: 'Carros por assinatura',
      href: ROUTES.SUBSCRIPTION,
      lkid: '3798',
      attributes: _extends({}, defaultAnchorAttributes)
    }]
  }, {
    text: 'Serviços',
    id: 'footer_services',
    data_qa: 'footer_services',
    tag: 'p',
    items: [{
      id: 'footer_webmotors_services',
      data_qa: 'footer_webmotors_services',
      text: 'Webmotors Serviços',
      href: ROUTES.SERVICES.WEBMOTORS_SERVICES,
      lkid: '2474',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_services_fipe',
      data_qa: 'footer_services_fipe',
      text: 'Tabela FIPE e Tabela Webmotors',
      href: ROUTES.SERVICES.FIPE,
      lkid: '1084',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_services_financing',
      data_qa: 'footer_services_financing',
      text: 'Financiamento',
      href: ROUTES.SERVICES.FINANCING + "/",
      lkid: '1088',
      attributes: _extends({}, defaultAnchorAttributes)
    },
    // {
    //   id: 'footer_services_consortium',
    //   data_qa: 'footer_services_consortium',
    //   text: 'Consórcio',
    //   href: `${ROUTES.SERVICES.CONSORTIUM}/`,
    //   lkid: '2302',
    //   attributes: {
    //     ...defaultAnchorAttributes
    //   }
    // },
    {
      id: 'footer_services_catalog_0km',
      data_qa: 'footer_services_catalog_0km',
      text: 'Catálogo 0km',
      href: ROUTES.CAR.ZERO,
      lkid: '1085',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_services_inspected',
      data_qa: 'footer_services_inspected',
      text: 'Vistoriado',
      href: ROUTES.COCKPIT + "solutions/vistoriado",
      lkid: '1579',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_services_dealer_platform',
      data_qa: 'footer_services_dealer_platform',
      text: 'Plataforma revendedores',
      href: ROUTES.SERVICES.DEALER_PLATFORM,
      lkid: '1091',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_services_insurance',
      data_qa: 'footer_services_insurance',
      text: 'Seguro veículo',
      href: ROUTES.SERVICES.INSURANCE,
      lkid: '1090&utm_source=webmotors&utm_medium=site&utm_campaign=footer_seguro_veiculo',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_services_advertising',
      data_qa: 'footer_services_advertising',
      text: 'Webmotors Ads',
      href: ROUTES.SERVICES.ADVERTISING,
      lkid: '1092',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_services_compare_vehicles',
      data_qa: 'footer_services_compare_vehicles',
      text: 'Comparar veículos',
      href: ROUTES.SERVICES.COMPARE_VEHICLES,
      lkid: '1766',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_services_fines',
      data_qa: 'footer_services_fines',
      text: 'Multas e Débitos',
      href: ROUTES.SERVICES.FINES_AND_DEBTS,
      lkid: '1767',
      attributes: _extends({}, defaultAnchorAttributes)
    }]
  }], [{
    text: 'Notícias WM1',
    id: 'footer_wm1',
    data_qa: 'footer_wm1',
    tag: 'h2',
    items: [{
      id: 'footer_wm1_portal',
      data_qa: 'footer_wm1_portal',
      text: 'Portal',
      href: ROUTES.WM1.PORTAL + "/",
      lkid: '1531',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_wm1_lastnews',
      data_qa: 'footer_wm1_lastnews',
      text: 'Últimas notícias',
      href: ROUTES.WM1.LASTNEWS,
      lkid: '1532',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_wm1_tests',
      data_qa: 'footer_wm1_tests',
      text: 'Testes',
      lkid: '1533',
      href: ROUTES.WM1.TESTS,
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_wm1_comparativos',
      data_qa: 'footer_wm1_comparativos',
      text: 'Comparativos',
      lkid: '1534',
      href: ROUTES.WM1.COMPARATIVES,
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_wm1_videos',
      data_qa: 'footer_wm1_videos',
      text: 'Vídeos',
      href: ROUTES.WM1.VIDEOS,
      lkid: '1535',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_wm1_bikes',
      data_qa: 'footer_wm1_bikes',
      text: 'Motos',
      href: ROUTES.WM1.BIKES,
      lkid: '1536',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_wm1_secrets',
      data_qa: 'footer_wm1_secrets',
      text: 'Segredos',
      href: ROUTES.WM1.SECRETS,
      lkid: '1537',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_wm1_tips',
      data_qa: 'footer_wm1_tips',
      text: 'Dicas',
      href: ROUTES.WM1.TIPS,
      lkid: '1538',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_wm1_pocket',
      data_qa: 'footer_wm1_pocket',
      text: 'Bolso',
      href: ROUTES.WM1.POCKET,
      lkid: '1539',
      attributes: _extends({}, defaultAnchorAttributes)
    }]
  }], [{
    text: 'Ajuda',
    id: 'footer_help',
    data_qa: 'footer_help',
    tag: 'p',
    items: [{
      id: 'footer_help_you',
      data_qa: 'footer_help_you',
      text: 'Para você',
      href: ROUTES.HELP.YOU,
      lkid: '1093',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_help_store',
      data_qa: 'footer_help_store',
      text: 'Para a sua loja',
      href: ROUTES.HELP.HOW_TO_BUY,
      lkid: '1096',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_help_security',
      data_qa: 'footer_help_security',
      text: 'Segurança',
      href: ROUTES.HELP.SECURITY,
      lkid: '2172',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_help_institutional',
      data_qa: 'footer_help_institutional',
      text: 'Quem somos',
      href: ROUTES.HELP.INSTITUCIONAL,
      lkid: '1542',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_help_workWithUs',
      data_qa: 'footer_help_workWithUs',
      text: 'Trabalhe com a gente',
      href: ROUTES.HELP.WORK_WITH_US,
      lkid: '1099',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_help_siteMap',
      data_qa: 'footer_help_siteMap',
      text: 'Mapa do site',
      href: ROUTES.HELP.SITEMAP,
      lkid: '1543',
      attributes: _extends({}, defaultAnchorAttributes)
    }]
  }], [{
    text: 'Institucional',
    id: 'footer_institutional',
    data_qa: 'footer_institutional',
    tag: 'h2',
    items: [{
      id: 'footer_institutional_ethic',
      data_qa: 'footer_institutional_ethic',
      text: 'Canal de ética',
      href: ROUTES.INSTITUTIONAL.ALO_ETICA,
      lkid: '1544',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_institutional_conductCode',
      data_qa: 'footer_institutional_conductCode',
      text: 'Código de conduta Webmotors',
      href: ROUTES.INSTITUTIONAL.CONDUCT_CODE,
      lkid: '1545',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_institutional_supplierConductCode',
      data_qa: 'footer_institutional_supplierConductCode',
      text: 'Código de Conduta Fornecedores',
      href: ROUTES.INSTITUTIONAL.SUPPLIER_CONDUCT_CODE,
      lkid: '2122',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_institutional_consumerPolicy',
      data_qa: 'footer_institutional_consumerPolicy',
      text: 'Código defesa do consumidor',
      href: ROUTES.INSTITUTIONAL.CONSUMER,
      lkid: '1097',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_institutional_cookiesManagement',
      data_qa: 'footer_institutional_cookiesManagement',
      text: 'Gerenciamento de cookies',
      href: '#',
      callCookie: true,
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_institutional_privacyPolicy',
      data_qa: 'footer_institutional_privacyPolicy',
      text: 'Termos de Uso e Política de privacidade',
      lkid: '1546',
      href: ROUTES.INSTITUTIONAL.PRIVACY,
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_institutional_lgpd',
      data_qa: 'footer_institutional_lgpd',
      text: 'LGPD',
      href: ROUTES.INSTITUTIONAL.LGPD,
      lkid: '1548',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_institutional_booklet_lgpd',
      data_qa: 'footer_institutional_booklet_lgpd',
      text: 'Cartilha LGPD',
      href: ROUTES.INSTITUTIONAL.BOOKLETLGPD,
      lkid: '',
      attributes: _extends({}, defaultAnchorAttributes)
    }, {
      id: 'footer_institutional_transparency',
      data_qa: 'footer_institutional_transparency',
      text: 'Relatório de Transparência',
      href: ROUTES.INSTITUTIONAL.TRANSPARENCY,
      lkid: '',
      attributes: _extends({}, defaultAnchorAttributes)
    }]
  }]];
  return footerLinks;
};
/**
 * Get all footer links
 *
 * @param baseUrl
 * @returns
 */
function getFooterLinks(params) {
  var footerLinks = footerLinksFactory(params);
  return footerLinks;
}

var LinkBuilder = /*#__PURE__*/function () {
  /**
   * Constructor with links factory
   *
   * @param linksFactory
   */
  function LinkBuilder(linksFactory) {
    /**
     * Base url used to build menu links
     *
     */
    this.baseUrl = 'https://webmotors.com.br/';
    /**
     * builderConstructor that should be used
     *
     */
    this.linksFactory = void 0;
    /**
     * Links editors used at build time
     *
     */
    this.editors = [];
    /**
     * Current logged user
     *
     */
    this.baseUser = void 0;
    this.linksFactory = linksFactory;
  }
  /**
   * Apply changes of editors on every link on the tree
   *
   * @param links
   * @returns
   */
  var _proto = LinkBuilder.prototype;
  _proto.applyCallback = function applyCallback(links) {
    var _this = this;
    return links.map(function (link) {
      var _link;
      for (var _iterator = _createForOfIteratorHelperLoose(_this.editors), _step; !(_step = _iterator()).done;) {
        var _link$props;
        var editor = _step.value;
        if (editor.idx === ((_link$props = link.props) == null ? void 0 : _link$props.id)) {
          link = editor.callback(link);
        }
      }
      // Apply callback recursively to links children
      if ((_link = link) != null && _link.links) {
        link.links = _this.applyCallback(link.links);
      }
      return link;
    });
  }
  /**
   * Push an new editor into the tree
   *
   * @param idx
   * @param callback
   * @returns
   */;
  _proto.edit = function edit(idx, callback) {
    this.editors.push({
      idx: idx,
      callback: callback
    });
    return this;
  }
  /**
   * Add default url to link factory
   *
   * @param baseUrl
   * @returns
   */;
  _proto.url = function url(baseUrl) {
    this.baseUrl = baseUrl;
    return this;
  }
  /**
   * Set user value
   *
   * @param baseUser
   * @returns
   */;
  _proto.user = function user(baseUser) {
    this.baseUser = baseUser;
    return this;
  }
  /**
   * Build link tree
   *
   * @returns
   */;
  _proto.build = function build() {
    var params = {
      baseUrl: this.baseUrl,
      user: this.baseUser
    };
    return {
      links: this.applyCallback(this.linksFactory(params)),
      user: this.baseUser,
      url: this.baseUrl
    };
  };
  return LinkBuilder;
}();
function linkBuilder(builderType) {
  return new LinkBuilder(builderType);
}

/**
 * Get all navbar links placed on the right
 * @param baseUrl
 * @returns
 */
function rightNavbarLinksFactory(params) {
  var _params$user;
  var ROUTES = linksDatasetFactory(params);
  var guestLinks = [{
    label: 'Login',
    icon: 'FOWARD',
    href: ROUTES.LOGIN + "?lkid=1364",
    target: '_self',
    props: {
      id: 'header_btn_login',
      'data-qa': 'header_btn_login'
    }
  }, {
    label: 'Sou lojista',
    icon: 'ODOMETER',
    href: ROUTES.COCKPIT + "?lkid=1365",
    props: {
      id: 'header_btn_cockpit',
      'data-qa': 'header_btn_cockpit'
    }
  }];
  var userLinks = [{
    label: 'Meus anúncios',
    icon: 'GARAGE',
    href: ROUTES.GARAGE.BASE + "?lkid=1101",
    props: {
      id: 'header_logIn_myAds',
      'data-qa': 'header_logIn_myAds'
    }
  }, {
    label: 'Minha conta',
    icon: 'EDIT',
    href: ROUTES.GARAGE.PERFIL + "?lkid=1102",
    props: {
      id: 'header_logIn_myAccount',
      'data-qa': 'header_logIn_myAccount'
    }
  }, {
    label: 'Sair',
    icon: 'LOGOUT',
    props: {
      id: 'header_logIn_logOut',
      'data-qa': 'header_logIn_logOut'
    }
  }];
  var rightMenuLinks = [{
    label: params != null && params.user ? params == null || (_params$user = params.user) == null ? void 0 : _params$user.name : 'Entrar',
    icon: 'USER',
    viewport: exports.ViewPort.DESKTOP,
    placement: exports.MenuPlacement.RIGHT,
    popover: params.loginPopover,
    props: {
      id: 'btn_header_login',
      'data-qa': 'btn_header_login'
    },
    links: [].concat(params != null && params.user ? userLinks : guestLinks)
  }, {
    icon: 'FAVORITES',
    placement: exports.MenuPlacement.RIGHT,
    href: ROUTES.GARAGE.FAVORITES + "?lkid=1366",
    props: {
      id: 'header_btn_favorite',
      'data-qa': 'header_btn_favorite'
    },
    accessibility: {
      'aria-label': 'Visualizar favoritos'
    }
  }, {
    icon: 'MESSAGES',
    placement: exports.MenuPlacement.RIGHT,
    href: params != null && params.user ? ROUTES.GARAGE.PROPOSALS + "?nps=true&lkid=1561" : ROUTES.GARAGE.PROPOSALS + "?nps=true&lkid=1367",
    props: {
      id: 'header_btn_messages',
      'data-qa': 'header_btn_messages'
    },
    accessibility: {
      'aria-label': 'Visualizar chat'
    }
  }];
  return rightMenuLinks;
}
/**
 * Get all navbar links
 *
 * @param baseUrl
 * @returns
 */
function getNavbarLinks(params) {
  var defaulRoutes = defaultLinksFactory(params);
  var rightLinks = rightNavbarLinksFactory(params);
  return [].concat(defaulRoutes, rightLinks);
}

var styles$1 = {"spin__wrapper":"_EJw7k","spin__cta":"_5PJ65","spin__icon":"_VSZN3","spin__mask":"_hWaJH"};

function SpinLink(props) {
  var toogle = props.onClick,
    _props$title = props.title,
    title = _props$title === void 0 ? 'Ver 360°' : _props$title,
    image = props.image;
  return jsxRuntime.jsxs("div", {
    className: "" + styles$1.spin__wrapper,
    style: {
      backgroundImage: "url(" + image + ")"
    },
    children: [jsxRuntime.jsxs("button", {
      onClick: toogle,
      className: "spin__cta " + styles$1.spin__cta,
      children: [title, jsxRuntime.jsx(Icon, {
        name: 'CAR360',
        "data-qa": 'car360-open-button',
        height: 20,
        width: 24,
        className: styles$1.spin__icon
      })]
    }), jsxRuntime.jsx("div", {
      className: "" + styles$1.spin__mask
    })]
  });
}

var styles = {"modal":"_qma22","fadeInFromNone":"_kGeEQ","modal__dialog":"_iKfSC","modal__content":"_sQztW","modal__close":"_wCKN4","modal__iframe":"_Wzj4r","animate__fadeIn":"_7TsNQ"};

function SpinModal(props) {
  var toogle = props.onClose,
    isOpen = props.isOpen,
    href = props.href;
  if (!isOpen) return null;
  return jsxRuntime.jsx("div", {
    className: "" + styles.modal,
    onClick: toogle,
    "data-qa": 'car360-close-overlay',
    children: jsxRuntime.jsx("div", {
      className: "" + styles.modal__dialog,
      children: jsxRuntime.jsxs("div", {
        className: "" + styles.modal__content,
        children: [jsxRuntime.jsx("button", {
          "aria-label": 'fechar',
          className: "modal__close " + styles.modal__close,
          children: jsxRuntime.jsx(Icon, {
            name: 'CLOSE',
            "data-qa": 'car360-close-button',
            height: 10,
            width: 11,
            onClick: toogle
          })
        }), jsxRuntime.jsx("div", {
          className: "modal__iframe " + styles.modal__iframe,
          children: jsxRuntime.jsx("iframe", {
            src: href,
            width: '100%',
            height: '100%',
            title: "Vis\xE3o 360\xB0"
          })
        })]
      })
    })
  });
}

function useSpin(_ref) {
  var title = _ref.title,
    image = _ref.image,
    href = _ref.href;
  var _useState = react.useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var toogle = function toogle() {
    return setIsOpen(function (currentState) {
      return !currentState;
    });
  };
  var getCTAProps = {
    title: title,
    image: image,
    onClick: toogle
  };
  var getModalProps = {
    isOpen: isOpen,
    onClose: toogle,
    href: href
  };
  return {
    isOpen: isOpen,
    toogle: toogle,
    getCTAProps: getCTAProps,
    getModalProps: getModalProps
  };
}

function Spin(props) {
  var _useSpin = useSpin(props),
    getCTAProps = _useSpin.getCTAProps,
    getModalProps = _useSpin.getModalProps;
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsx(SpinLink, _extends({}, getCTAProps)), jsxRuntime.jsx(SpinModal, _extends({}, getModalProps))]
  });
}

exports.DrawerMenu = DrawerMenu;
exports.FakeNotification = FakeNotification;
exports.Footer = Footer;
exports.Icon = Icon;
exports.LinkBuilder = LinkBuilder;
exports.LoginPopover = LoginPopover;
exports.Navbar = Navbar;
exports.Pagination = Pagination;
exports.Spin = Spin;
exports.SpinLink = SpinLink;
exports.SpinModal = SpinModal;
exports.defaultAnchorAttributes = defaultAnchorAttributes;
exports.defaultLinksFactory = defaultLinksFactory;
exports.drawerLinksFactory = drawerLinksFactory;
exports.footerLinksFactory = footerLinksFactory;
exports.getDrawerLinks = getDrawerLinks;
exports.getFooterLinks = getFooterLinks;
exports.getNavbarLinks = getNavbarLinks;
exports.linkBuilder = linkBuilder;
exports.linksDatasetFactory = linksDatasetFactory;
exports.rightNavbarLinksFactory = rightNavbarLinksFactory;
exports.useDrawerMenu = useDrawerMenu;
exports.useLocalStorageState = useLocalStorageState;
exports.useMediaQuery = useMediaQuery;
exports.usePopover = usePopover;
//# sourceMappingURL=index.js.map
